(function () {

var $parcel$bundleURL;
function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  if (!$parcel$bundleURL) {
    try {
      throw new Error();
    } catch (err) {
      var matches = ('' + err.stack).match(
        /(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g,
      );
      if (matches) {
        $parcel$bundleURL = matches[0];
      } else {
        return $parcel$distDir + url;
      }
    }
  }
  return new URL($parcel$distDir + url, $parcel$bundleURL).toString();
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirea1ac"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirea1ac"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("7ErNH", function(module, exports) {

module.exports = (parcelRequire("3fGD8"))($parcel$resolve("7WJe0")).then(function() {
    return parcelRequire('ju6sr');
});

});
parcelRegister("3fGD8", function(module, exports) {
"use strict";

var $l68DB = parcelRequire("l68DB");
module.exports = $l68DB(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName('script');
        if ([].concat(existingScripts).some(function(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement('link');
        preloadLink.href = bundle;
        preloadLink.rel = 'preload';
        preloadLink.as = 'script';
        document.head.appendChild(preloadLink);
        var script = document.createElement('script');
        script.async = true;
        script.type = 'text/javascript';
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(script);
    });
});

});
parcelRegister("l68DB", function(module, exports) {
"use strict";
var $f5c0dbccaee288fb$var$cachedBundles = {};
var $f5c0dbccaee288fb$var$cachedPreloads = {};
var $f5c0dbccaee288fb$var$cachedPrefetches = {};
function $f5c0dbccaee288fb$var$getCache(type) {
    switch(type){
        case 'preload':
            return $f5c0dbccaee288fb$var$cachedPreloads;
        case 'prefetch':
            return $f5c0dbccaee288fb$var$cachedPrefetches;
        default:
            return $f5c0dbccaee288fb$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $f5c0dbccaee288fb$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments)["catch"](function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



parcelRegister("9Rj4S", function(module, exports) {

module.exports = (parcelRequire("3fGD8"))($parcel$resolve("eyyvH")).then(function() {
    return parcelRequire('c4A8R');
});

});

parcelRegister("kq5Gg", function(module, exports) {

module.exports = (parcelRequire("3fGD8"))($parcel$resolve("guRRe")).then(function() {
    return parcelRequire('dBSAC');
});

});

parcelRegister("79Dca", function(module, exports) {

module.exports = (parcelRequire("3fGD8"))($parcel$resolve("8sOCb")).then(function() {
    return parcelRequire('7JNns');
});

});

parcelRegister("2aA9k", function(module, exports) {

module.exports = (parcelRequire("3fGD8"))($parcel$resolve("5PzfF")).then(function() {
    return parcelRequire('5DSDX');
});

});

parcelRegister("fQjVH", function(module, exports) {

module.exports = (parcelRequire("3fGD8"))($parcel$resolve("4RfOC")).then(function() {
    return parcelRequire('dZ2NS');
});

});

parcelRegister("cJqUG", function(module, exports) {

module.exports = (parcelRequire("3fGD8"))($parcel$resolve("aI9dn")).then(function() {
    return parcelRequire('jMTfq');
});

});

parcelRegister("bp49u", function(module, exports) {

module.exports = (parcelRequire("3fGD8"))($parcel$resolve("lpg3u")).then(function() {
    return parcelRequire('dlyLL');
});

});

parcelRegister("47BTp", function(module, exports) {

module.exports = (parcelRequire("3fGD8"))($parcel$resolve("axaxX")).then(function() {
    return parcelRequire('54dZI');
});

});

parcelRegister("5Bb8J", function(module, exports) {

module.exports = (parcelRequire("3fGD8"))($parcel$resolve("7jKnD")).then(function() {
    return parcelRequire('4I9LZ');
});

});

parcelRegister("9Mb7m", function(module, exports) {

module.exports = (parcelRequire("3fGD8"))($parcel$resolve("lWLLF")).then(function() {
    return parcelRequire('jGwKQ');
});

});

parcelRegister("9lwob", function(module, exports) {

module.exports = (parcelRequire("3fGD8"))($parcel$resolve("ikm6K")).then(function() {
    return parcelRequire('l50Cf');
});

});

parcelRegister("dOUch", function(module, exports) {

module.exports = (parcelRequire("3fGD8"))($parcel$resolve("edhjD")).then(function() {
    return parcelRequire('ixitn');
});

});

parcelRegister("8fSon", function(module, exports) {

module.exports = (parcelRequire("3fGD8"))($parcel$resolve("aTgsl")).then(function() {
    return parcelRequire('6KjvV');
});

});

parcelRegister("27aFe", function(module, exports) {

module.exports = (parcelRequire("3fGD8"))($parcel$resolve("eaD4U")).then(function() {
    return parcelRequire('4tf4b');
});

});

parcelRegister("3TzSS", function(module, exports) {

module.exports = (parcelRequire("3fGD8"))($parcel$resolve("1cCj4")).then(function() {
    return parcelRequire('3RaXT');
});

});

parcelRegister("jhCZ7", function(module, exports) {

module.exports = (parcelRequire("3fGD8"))($parcel$resolve("gGlTs")).then(function() {
    return parcelRequire('d7uoR');
});

});

parcelRegister("5PMwu", function(module, exports) {

module.exports = (parcelRequire("3fGD8"))($parcel$resolve("8gRpd")).then(function() {
    return parcelRequire('gOha1');
});

});

parcelRegister("5MF98", function(module, exports) {

module.exports = (parcelRequire("3fGD8"))($parcel$resolve("cNoNU")).then(function() {
    return parcelRequire('5aGAE');
});

});

parcelRegister("1Uyaf", function(module, exports) {

module.exports = (parcelRequire("3fGD8"))($parcel$resolve("7BBIJ")).then(function() {
    return parcelRequire('6DlSr');
});

});

parcelRegister("7jouE", function(module, exports) {

module.exports = (parcelRequire("3fGD8"))($parcel$resolve("7AU5u")).then(function() {
    return parcelRequire('kX3rv');
});

});

parcelRegister("6PjO2", function(module, exports) {

module.exports = (parcelRequire("3fGD8"))($parcel$resolve("hQvyU")).then(function() {
    return parcelRequire('bB4MM');
});

});

parcelRegister("aHNV2", function(module, exports) {

module.exports = (parcelRequire("3fGD8"))($parcel$resolve("fc2q7")).then(function() {
    return parcelRequire('0509N');
});

});

parcelRegister("iRnqe", function(module, exports) {

module.exports = (parcelRequire("3fGD8"))($parcel$resolve("h3612")).then(function() {
    return parcelRequire('2t8W9');
});

});

parcelRegister("4Hxzu", function(module, exports) {

module.exports = (parcelRequire("3fGD8"))($parcel$resolve("7XO2f")).then(function() {
    return parcelRequire('ewnSk');
});

});

parcelRegister("dMNiO", function(module, exports) {

module.exports = (parcelRequire("3fGD8"))($parcel$resolve("h42wW")).then(function() {
    return parcelRequire('kFid0');
});

});

parcelRegister("cIUuE", function(module, exports) {

module.exports = (parcelRequire("3fGD8"))($parcel$resolve("3gHFe")).then(function() {
    return parcelRequire('69lh9');
});

});

parcelRegister("9ynBl", function(module, exports) {

module.exports = (parcelRequire("3fGD8"))($parcel$resolve("29jhd")).then(function() {
    return parcelRequire('2vbqs');
});

});

parcelRegister("cbpEo", function(module, exports) {

module.exports = (parcelRequire("3fGD8"))($parcel$resolve("waH9V")).then(function() {
    return parcelRequire('azV4X');
});

});

parcelRegister("8PAlw", function(module, exports) {

module.exports = (parcelRequire("3fGD8"))($parcel$resolve("86ae5")).then(function() {
    return parcelRequire('chMHk');
});

});

parcelRegister("hyL4o", function(module, exports) {

module.exports = (parcelRequire("3fGD8"))($parcel$resolve("90V6s")).then(function() {
    return parcelRequire('aDgks');
});

});

parcelRegister("kINHl", function(module, exports) {

module.exports = (parcelRequire("3fGD8"))($parcel$resolve("1qTiu")).then(function() {
    return parcelRequire('bogzY');
});

});

parcelRegister("5J2FV", function(module, exports) {

module.exports = (parcelRequire("3fGD8"))($parcel$resolve("4ikYo")).then(function() {
    return parcelRequire('89fHu');
});

});

parcelRegister("lYAUT", function(module, exports) {

module.exports = (parcelRequire("3fGD8"))($parcel$resolve("ju0rD")).then(function() {
    return parcelRequire('eXKUg');
});

});

var $75ef23bdcb72af53$exports = {};
$parcel$extendImportMap({
    iJPGa: "LimbleLogo.718672e3.svg",
    gxAgp: "DHL.82f000bc.png",
    "8ZdaI": "neutron-light-background.b981cea9.png",
    jTQWl: "enco.af8dd6b6.png",
    "9iap4": "Deliverez_Logo_New_NoBG.1261f27b.png",
    "8rctJ": "epicGames.5538ddcb.png",
    "2lU7u": "iotplus-light-background.4b7825c9.png",
    kB9Md: "invata-light-background.518c7628.png",
    "4mSQ1": "netswat.525ee24a.png",
    "5teKa": "demirer-hodling.5c91f8eb.png",
    aCHb4: "Scandinavian-Drone-Logo-svart.17c393f7.png",
    "7plC6": "2D-Comstock-Logo.1f1aa8ca.jpg",
    ekseF: "HarriganLogo.62e00185.png",
    behbj: "sentegrity.230af4aa.png",
    "2hpS8": "Dartbrook_logo.c22bd1f9.svg",
    ahx9V: "redaptive_logo.61ab5928.svg",
    "6STaM": "LoginScreenSwoosh.f5f4b20d.svg",
    "5p7Og": "johndeere_logo.7d528477.png",
    aU3AY: "KU.1bfb01de.svg",
    Mu50N: "homeFixLogo.16b4996c.svg",
    "1G1JZ": "intelsat.c3ef53da.svg",
    "60k6i": "jbm.12186be8.svg",
    "3cgvA": "access.ceb02b12.svg",
    jVbKF: "canyonRidgeServices-light.1ceacb22.svg",
    bODa4: "watermark-facilities-logo.db561ffb.svg",
    hzCNs: "OFB_logo_black.c08b8aa6.png",
    c3622: "germantown-baptist-church.ef4ccdcc.png",
    gehAD: "TQL_black.2f8406a9.png",
    "7WJe0": "en.ad9f9f6b.js",
    eyyvH: "et.8b864d70.js",
    guRRe: "sl.b5212b46.js",
    "8sOCb": "es.c67ada99.js",
    "5PzfF": "th.e934a629.js",
    "4RfOC": "fr.fde97052.js",
    aI9dn: "pt.1d33f771.js",
    lpg3u: "he.4c57d323.js",
    axaxX: "de.1a5fded3.js",
    "7jKnD": "zh.4a4159d0.js",
    lWLLF: "ar.546ac1a4.js",
    ikm6K: "bg.3c306061.js",
    edhjD: "cs.ac6d358b.js",
    aTgsl: "fa.40891667.js",
    eaD4U: "hu.b7a20f87.js",
    "1cCj4": "it.84857398.js",
    gGlTs: "ja.90faae94.js",
    "8gRpd": "ko.2ffbd3d2.js",
    cNoNU: "lv.61485a0b.js",
    "7BBIJ": "nl.1015f6fc.js",
    "7AU5u": "no.98cf327f.js",
    hQvyU: "id.7fa941f2.js",
    fc2q7: "pl.99a7fd74.js",
    h3612: "ro.6da121d5.js",
    "7XO2f": "ru.6756a965.js",
    h42wW: "sv.eeb1ab84.js",
    "3gHFe": "sw.475ea214.js",
    "29jhd": "tl.241228f5.js",
    waH9V: "tg.0e42a0c0.js",
    "86ae5": "tr.8085b131.js",
    "90V6s": "vi.bec6301a.js",
    "1qTiu": "bn.4bf1bd15.js",
    "4ikYo": "hi.d8184dce.js",
    ju0rD: "zh-TW.5be97b58.js"
});

function $03857362ebfa6f2c$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $03857362ebfa6f2c$export$71511d61b312f219(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $03857362ebfa6f2c$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $03857362ebfa6f2c$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}


function $ca8679453dfc275b$export$71511d61b312f219(thisArg, body) {
    var f, y, t, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype), d = Object.defineProperty;
    return d(g, "next", {
        value: verb(0)
    }), d(g, "throw", {
        value: verb(1)
    }), d(g, "return", {
        value: verb(2)
    }), typeof Symbol === "function" && d(g, Symbol.iterator, {
        value: function() {
            return this;
        }
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}


var $9d6020d1166e2bc7$exports = {};
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ function $15ae7fd16c0fe95b$export$71511d61b312f219(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}


var $9d6020d1166e2bc7$var$runtime = function(exports) {
    "use strict";
    var Op = Object.prototype;
    var hasOwn = Op.hasOwnProperty;
    var defineProperty = Object.defineProperty || function(obj, key, desc) {
        obj[key] = desc.value;
    };
    var undefined; // More compressible than void 0.
    var $Symbol = typeof Symbol === "function" ? Symbol : {};
    var iteratorSymbol = $Symbol.iterator || "@@iterator";
    var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
    var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    function define(obj, key, value) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        return obj[key];
    }
    try {
        // IE 8 has a broken Object.defineProperty that only works on DOM objects.
        define({}, "");
    } catch (err) {
        define = function define(obj, key, value) {
            return obj[key] = value;
        };
    }
    function wrap(innerFn, outerFn, self, tryLocsList) {
        // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
        var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
        var generator = Object.create(protoGenerator.prototype);
        var context = new Context(tryLocsList || []);
        // The ._invoke method unifies the implementations of the .next,
        // .throw, and .return methods.
        defineProperty(generator, "_invoke", {
            value: makeInvokeMethod(innerFn, self, context)
        });
        return generator;
    }
    exports.wrap = wrap;
    // Try/catch helper to minimize deoptimizations. Returns a completion
    // record like context.tryEntries[i].completion. This interface could
    // have been (and was previously) designed to take a closure to be
    // invoked without arguments, but in all the cases we care about we
    // already have an existing method we want to call, so there's no need
    // to create a new function object. We can even get away with assuming
    // the method takes exactly one argument, since that happens to be true
    // in every case, so we don't have to touch the arguments object. The
    // only additional allocation required is the completion record, which
    // has a stable shape and so hopefully should be cheap to allocate.
    function tryCatch(fn, obj, arg) {
        try {
            return {
                type: "normal",
                arg: fn.call(obj, arg)
            };
        } catch (err) {
            return {
                type: "throw",
                arg: err
            };
        }
    }
    var GenStateSuspendedStart = "suspendedStart";
    var GenStateSuspendedYield = "suspendedYield";
    var GenStateExecuting = "executing";
    var GenStateCompleted = "completed";
    // Returning this object from the innerFn has the same effect as
    // breaking out of the dispatch switch statement.
    var ContinueSentinel = {};
    // Dummy constructor functions that we use as the .constructor and
    // .constructor.prototype properties for functions that return Generator
    // objects. For full spec compliance, you may wish to configure your
    // minifier not to mangle the names of these two functions.
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    // This is a polyfill for %IteratorPrototype% for environments that
    // don't natively support it.
    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function() {
        return this;
    });
    var getProto = Object.getPrototypeOf;
    var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    GeneratorFunction.prototype = GeneratorFunctionPrototype;
    defineProperty(Gp, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: true
    });
    defineProperty(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: true
    });
    GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction");
    // Helper for defining the .next, .throw, and .return methods of the
    // Iterator interface in terms of a single ._invoke method.
    function defineIteratorMethods(prototype) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(method) {
            define(prototype, method, function(arg) {
                return this._invoke(method, arg);
            });
        });
    }
    exports.isGeneratorFunction = function(genFun) {
        var ctor = typeof genFun === "function" && genFun.constructor;
        return ctor ? ctor === GeneratorFunction || // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
    };
    exports.mark = function(genFun) {
        if (Object.setPrototypeOf) Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
        else {
            genFun.__proto__ = GeneratorFunctionPrototype;
            define(genFun, toStringTagSymbol, "GeneratorFunction");
        }
        genFun.prototype = Object.create(Gp);
        return genFun;
    };
    // Within the body of any async function, `await x` is transformed to
    // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
    // `hasOwn.call(value, "__await")` to determine if the yielded value is
    // meant to be awaited.
    exports.awrap = function(arg) {
        return {
            __await: arg
        };
    };
    function AsyncIterator(generator, PromiseImpl) {
        function invoke(method, arg, resolve, reject) {
            var record = tryCatch(generator[method], generator, arg);
            if (record.type === "throw") reject(record.arg);
            else {
                var result = record.arg;
                var value = result.value;
                if (value && (typeof value === "undefined" ? "undefined" : (0, $15ae7fd16c0fe95b$export$71511d61b312f219)(value)) === "object" && hasOwn.call(value, "__await")) return PromiseImpl.resolve(value.__await).then(function(value) {
                    invoke("next", value, resolve, reject);
                }, function(err) {
                    invoke("throw", err, resolve, reject);
                });
                return PromiseImpl.resolve(value).then(function(unwrapped) {
                    // When a yielded Promise is resolved, its final value becomes
                    // the .value of the Promise<{value,done}> result for the
                    // current iteration.
                    result.value = unwrapped;
                    resolve(result);
                }, function(error) {
                    // If a rejected Promise was yielded, throw the rejection back
                    // into the async generator function so it can be handled there.
                    return invoke("throw", error, resolve, reject);
                });
            }
        }
        var previousPromise;
        function enqueue(method, arg) {
            function callInvokeWithMethodAndArg() {
                return new PromiseImpl(function(resolve, reject) {
                    invoke(method, arg, resolve, reject);
                });
            }
            return previousPromise = // If enqueue has been called before, then we want to wait until
            // all previous Promises have been resolved before calling invoke,
            // so that results are always delivered in the correct order. If
            // enqueue has not been called before, then it is important to
            // call invoke immediately, without waiting on a callback to fire,
            // so that the async generator function has the opportunity to do
            // any necessary setup in a predictable way. This predictability
            // is why the Promise constructor synchronously invokes its
            // executor callback, and why async functions synchronously
            // execute code before the first await. Since we implement simple
            // async functions in terms of async generators, it is especially
            // important to get this right, even though it requires care.
            previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, // Avoid propagating failures to Promises returned by later
            // invocations of the iterator.
            callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
        }
        // Define the unified helper method that is used to implement .next,
        // .throw, and .return (see defineIteratorMethods).
        defineProperty(this, "_invoke", {
            value: enqueue
        });
    }
    defineIteratorMethods(AsyncIterator.prototype);
    define(AsyncIterator.prototype, asyncIteratorSymbol, function() {
        return this;
    });
    exports.AsyncIterator = AsyncIterator;
    // Note that simple async functions are implemented on top of
    // AsyncIterator objects; they just return a Promise for the value of
    // the final result produced by the iterator.
    exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
        if (PromiseImpl === void 0) PromiseImpl = Promise;
        var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
        return exports.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
         : iter.next().then(function(result) {
            return result.done ? result.value : iter.next();
        });
    };
    function makeInvokeMethod(innerFn, self, context) {
        var state = GenStateSuspendedStart;
        return function invoke(method, arg) {
            if (state === GenStateExecuting) throw new Error("Generator is already running");
            if (state === GenStateCompleted) {
                if (method === "throw") throw arg;
                // Be forgiving, per GeneratorResume behavior specified since ES2015:
                // ES2015 spec, step 3: https://262.ecma-international.org/6.0/#sec-generatorresume
                // Latest spec, step 2: https://tc39.es/ecma262/#sec-generatorresume
                return doneResult();
            }
            context.method = method;
            context.arg = arg;
            while(true){
                var delegate = context.delegate;
                if (delegate) {
                    var delegateResult = maybeInvokeDelegate(delegate, context);
                    if (delegateResult) {
                        if (delegateResult === ContinueSentinel) continue;
                        return delegateResult;
                    }
                }
                if (context.method === "next") // Setting context._sent for legacy support of Babel's
                // function.sent implementation.
                context.sent = context._sent = context.arg;
                else if (context.method === "throw") {
                    if (state === GenStateSuspendedStart) {
                        state = GenStateCompleted;
                        throw context.arg;
                    }
                    context.dispatchException(context.arg);
                } else if (context.method === "return") context.abrupt("return", context.arg);
                state = GenStateExecuting;
                var record = tryCatch(innerFn, self, context);
                if (record.type === "normal") {
                    // If an exception is thrown from innerFn, we leave state ===
                    // GenStateExecuting and loop back for another invocation.
                    state = context.done ? GenStateCompleted : GenStateSuspendedYield;
                    if (record.arg === ContinueSentinel) continue;
                    return {
                        value: record.arg,
                        done: context.done
                    };
                } else if (record.type === "throw") {
                    state = GenStateCompleted;
                    // Dispatch the exception by looping back around to the
                    // context.dispatchException(context.arg) call above.
                    context.method = "throw";
                    context.arg = record.arg;
                }
            }
        };
    }
    // Call delegate.iterator[context.method](context.arg) and handle the
    // result, either by returning a { value, done } result from the
    // delegate iterator, or by modifying context.method and context.arg,
    // setting context.delegate to null, and returning the ContinueSentinel.
    function maybeInvokeDelegate(delegate, context) {
        var methodName = context.method;
        var method = delegate.iterator[methodName];
        if (method === undefined) {
            // A .throw or .return when the delegate iterator has no .throw
            // method, or a missing .next method, always terminate the
            // yield* loop.
            context.delegate = null;
            // Note: ["return"] must be used for ES3 parsing compatibility.
            if (methodName === "throw" && delegate.iterator["return"]) {
                // If the delegate iterator has a return method, give it a
                // chance to clean up.
                context.method = "return";
                context.arg = undefined;
                maybeInvokeDelegate(delegate, context);
                if (context.method === "throw") // If maybeInvokeDelegate(context) changed context.method from
                // "return" to "throw", let that override the TypeError below.
                return ContinueSentinel;
            }
            if (methodName !== "return") {
                context.method = "throw";
                context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method");
            }
            return ContinueSentinel;
        }
        var record = tryCatch(method, delegate.iterator, context.arg);
        if (record.type === "throw") {
            context.method = "throw";
            context.arg = record.arg;
            context.delegate = null;
            return ContinueSentinel;
        }
        var info = record.arg;
        if (!info) {
            context.method = "throw";
            context.arg = new TypeError("iterator result is not an object");
            context.delegate = null;
            return ContinueSentinel;
        }
        if (info.done) {
            // Assign the result of the finished delegate to the temporary
            // variable specified by delegate.resultName (see delegateYield).
            context[delegate.resultName] = info.value;
            // Resume execution at the desired location (see delegateYield).
            context.next = delegate.nextLoc;
            // If context.method was "throw" but the delegate handled the
            // exception, let the outer generator proceed normally. If
            // context.method was "next", forget context.arg since it has been
            // "consumed" by the delegate iterator. If context.method was
            // "return", allow the original .return call to continue in the
            // outer generator.
            if (context.method !== "return") {
                context.method = "next";
                context.arg = undefined;
            }
        } else // Re-yield the result returned by the delegate method.
        return info;
        // The delegate iterator is finished, so forget it and continue with
        // the outer generator.
        context.delegate = null;
        return ContinueSentinel;
    }
    // Define Generator.prototype.{next,throw,return} in terms of the
    // unified ._invoke helper method.
    defineIteratorMethods(Gp);
    define(Gp, toStringTagSymbol, "Generator");
    // A Generator should always return itself as the iterator object when the
    // @@iterator function is called on it. Some browsers' implementations of the
    // iterator prototype chain incorrectly implement this, causing the Generator
    // object to not be returned from this call. This ensures that doesn't happen.
    // See https://github.com/facebook/regenerator/issues/274 for more details.
    define(Gp, iteratorSymbol, function() {
        return this;
    });
    define(Gp, "toString", function() {
        return "[object Generator]";
    });
    function pushTryEntry(locs) {
        var entry = {
            tryLoc: locs[0]
        };
        if (1 in locs) entry.catchLoc = locs[1];
        if (2 in locs) {
            entry.finallyLoc = locs[2];
            entry.afterLoc = locs[3];
        }
        this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
        var record = entry.completion || {};
        record.type = "normal";
        delete record.arg;
        entry.completion = record;
    }
    function Context(tryLocsList) {
        // The root entry object (effectively a try statement without a catch
        // or a finally block) gives us a place to store values thrown from
        // locations where there is no enclosing try statement.
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ];
        tryLocsList.forEach(pushTryEntry, this);
        this.reset(true);
    }
    exports.keys = function(val) {
        var object = Object(val);
        var keys = [];
        for(var key in object)keys.push(key);
        keys.reverse();
        // Rather than returning an object with a next method, we keep
        // things simple and return the next function itself.
        return function next() {
            while(keys.length){
                var key = keys.pop();
                if (key in object) {
                    next.value = key;
                    next.done = false;
                    return next;
                }
            }
            // To avoid creating an additional object, we just hang the .value
            // and .done properties off the next function object itself. This
            // also ensures that the minifier will not anonymize the function.
            next.done = true;
            return next;
        };
    };
    function values(iterable) {
        if (iterable != null) {
            var iteratorMethod = iterable[iteratorSymbol];
            if (iteratorMethod) return iteratorMethod.call(iterable);
            if (typeof iterable.next === "function") return iterable;
            if (!isNaN(iterable.length)) {
                var i = -1, next = function next() {
                    while(++i < iterable.length)if (hasOwn.call(iterable, i)) {
                        next.value = iterable[i];
                        next.done = false;
                        return next;
                    }
                    next.value = undefined;
                    next.done = true;
                    return next;
                };
                return next.next = next;
            }
        }
        throw new TypeError((typeof iterable === "undefined" ? "undefined" : (0, $15ae7fd16c0fe95b$export$71511d61b312f219)(iterable)) + " is not iterable");
    }
    exports.values = values;
    function doneResult() {
        return {
            value: undefined,
            done: true
        };
    }
    Context.prototype = {
        constructor: Context,
        reset: function reset(skipTempReset) {
            this.prev = 0;
            this.next = 0;
            // Resetting context._sent for legacy support of Babel's
            // function.sent implementation.
            this.sent = this._sent = undefined;
            this.done = false;
            this.delegate = null;
            this.method = "next";
            this.arg = undefined;
            this.tryEntries.forEach(resetTryEntry);
            if (!skipTempReset) {
                for(var name in this)// Not sure about the optimal order of these conditions:
                if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) this[name] = undefined;
            }
        },
        stop: function stop() {
            this.done = true;
            var rootEntry = this.tryEntries[0];
            var rootRecord = rootEntry.completion;
            if (rootRecord.type === "throw") throw rootRecord.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(exception) {
            if (this.done) throw exception;
            var context = this;
            function handle(loc, caught) {
                record.type = "throw";
                record.arg = exception;
                context.next = loc;
                if (caught) {
                    // If the dispatched exception was caught by a catch block,
                    // then let that catch block handle the exception normally.
                    context.method = "next";
                    context.arg = undefined;
                }
                return !!caught;
            }
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                var record = entry.completion;
                if (entry.tryLoc === "root") // Exception thrown outside of any try block that could handle
                // it, so set the completion value of the entire function to
                // throw the exception.
                return handle("end");
                if (entry.tryLoc <= this.prev) {
                    var hasCatch = hasOwn.call(entry, "catchLoc");
                    var hasFinally = hasOwn.call(entry, "finallyLoc");
                    if (hasCatch && hasFinally) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                        else if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else if (hasCatch) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                    } else if (hasFinally) {
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else throw new Error("try statement without catch or finally");
                }
            }
        },
        abrupt: function abrupt(type, arg) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                    var finallyEntry = entry;
                    break;
                }
            }
            if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) // Ignore the finally entry if control is not jumping to a
            // location outside the try/catch block.
            finallyEntry = null;
            var record = finallyEntry ? finallyEntry.completion : {};
            record.type = type;
            record.arg = arg;
            if (finallyEntry) {
                this.method = "next";
                this.next = finallyEntry.finallyLoc;
                return ContinueSentinel;
            }
            return this.complete(record);
        },
        complete: function complete(record, afterLoc) {
            if (record.type === "throw") throw record.arg;
            if (record.type === "break" || record.type === "continue") this.next = record.arg;
            else if (record.type === "return") {
                this.rval = this.arg = record.arg;
                this.method = "return";
                this.next = "end";
            } else if (record.type === "normal" && afterLoc) this.next = afterLoc;
            return ContinueSentinel;
        },
        finish: function finish(finallyLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.finallyLoc === finallyLoc) {
                    this.complete(entry.completion, entry.afterLoc);
                    resetTryEntry(entry);
                    return ContinueSentinel;
                }
            }
        },
        "catch": function(tryLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc === tryLoc) {
                    var record = entry.completion;
                    if (record.type === "throw") {
                        var thrown = record.arg;
                        resetTryEntry(entry);
                    }
                    return thrown;
                }
            }
            // The context.catch method must only be called with a location
            // argument that corresponds to a known catch block.
            throw new Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(iterable, resultName, nextLoc) {
            this.delegate = {
                iterator: values(iterable),
                resultName: resultName,
                nextLoc: nextLoc
            };
            if (this.method === "next") // Deliberately forget the last sent value so that we don't
            // accidentally pass it on to the delegate.
            this.arg = undefined;
            return ContinueSentinel;
        }
    };
    // Regardless of whether this script is executing as a CommonJS module
    // or not, return the runtime object so that we can declare the variable
    // regeneratorRuntime in the outer scope, which allows this module to be
    // injected easily by `bin/regenerator --include-runtime script.js`.
    return exports;
}(// If this script is executing as a CommonJS module, use module.exports
// as the regeneratorRuntime namespace. Otherwise create a new empty
// object. Either way, the resulting object will be used to initialize
// the regeneratorRuntime variable at the top of this file.
(0, $9d6020d1166e2bc7$exports));
try {
    regeneratorRuntime = $9d6020d1166e2bc7$var$runtime;
} catch (accidentalStrictMode) {
    // This module should not be running in strict mode, so the above
    // assignment should always work unless something is misconfigured. Just
    // in case runtime.js accidentally runs in strict mode, in modern engines
    // we can explicitly access globalThis. In older engines we can escape
    // strict mode using a global Function call. This could conceivably fail
    // if a Content Security Policy forbids using Function, but in that case
    // the proper solution is to fix the accidental strict mode problem. If
    // you've misconfigured your bundler to force strict mode and applied a
    // CSP to forbid Function, and you're not willing to fix either of those
    // problems, please detail your unique predicament in a GitHub issue.
    if ((typeof globalThis === "undefined" ? "undefined" : (0, $15ae7fd16c0fe95b$export$71511d61b312f219)(globalThis)) === "object") globalThis.regeneratorRuntime = $9d6020d1166e2bc7$var$runtime;
    else Function("r", "regeneratorRuntime = r")($9d6020d1166e2bc7$var$runtime);
}


/**
 * This is a shim to load our routes at runtime, allowing us to generate
 * routes separate from the bundled assets. This is useful because we
 * can then ship the same asset bundle in different environments without
 * needing to recompile for the different routes file in use.
 */ 
function $27b4cf4927316b66$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}


function $3f7d8c76d5b7f5da$export$71511d61b312f219(receiver, descriptor) {
    if (descriptor.get) return descriptor.get.call(receiver);
    return descriptor.value;
}


function $4ac355461952e1f4$export$71511d61b312f219(receiver, privateMap, action) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to " + action + " private field on non-instance");
    return privateMap.get(receiver);
}


function $9a040ee0b198d009$export$71511d61b312f219(receiver, privateMap) {
    var descriptor = (0, $4ac355461952e1f4$export$71511d61b312f219)(receiver, privateMap, "get");
    return (0, $3f7d8c76d5b7f5da$export$71511d61b312f219)(receiver, descriptor);
}


function $ddf44fe2f40c269c$export$71511d61b312f219(obj, privateCollection) {
    if (privateCollection.has(obj)) throw new TypeError("Cannot initialize the same private elements twice on an object");
}


function $532319f0d9d2d372$export$71511d61b312f219(obj, privateMap, value) {
    (0, $ddf44fe2f40c269c$export$71511d61b312f219)(obj, privateMap);
    privateMap.set(obj, value);
}


function $8c93dcb7aea2115e$export$71511d61b312f219(receiver, descriptor, value) {
    if (descriptor.set) descriptor.set.call(receiver, value);
    else {
        if (!descriptor.writable) // This should only throw in strict mode, but class bodies are
        // always strict and private fields can only be used inside
        // class bodies.
        throw new TypeError("attempted to set read only private field");
        descriptor.value = value;
    }
}



function $e0a0c6592404d6dd$export$71511d61b312f219(receiver, privateMap, value) {
    var descriptor = (0, $4ac355461952e1f4$export$71511d61b312f219)(receiver, privateMap, "set");
    (0, $8c93dcb7aea2115e$export$71511d61b312f219)(receiver, descriptor, value);
    return value;
}


function $9ec8be00d480deaf$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $9ec8be00d480deaf$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $9ec8be00d480deaf$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $9ec8be00d480deaf$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}



function $2bc71ddc9d71fda1$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return arr;
}


function $4640fe41fbd1e26e$export$71511d61b312f219(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}


function $aa87ab402a218cdb$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $f716e475b33ed48e$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $d18d353f273b4be3$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $f716e475b33ed48e$export$71511d61b312f219)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $f716e475b33ed48e$export$71511d61b312f219)(o, minLen);
}


function $c940fad574a3594c$export$71511d61b312f219(arr, i) {
    return (0, $2bc71ddc9d71fda1$export$71511d61b312f219)(arr) || (0, $4640fe41fbd1e26e$export$71511d61b312f219)(arr, i) || (0, $d18d353f273b4be3$export$71511d61b312f219)(arr, i) || (0, $aa87ab402a218cdb$export$71511d61b312f219)();
}



'use strict';
function $ad97c7e0c7328995$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}


'use strict';
// utils is a library of generic helper functions non-specific to axios
var $4ee88d3ab9e0f87b$var$toString = Object.prototype.toString;
var $4ee88d3ab9e0f87b$var$getPrototypeOf = Object.getPrototypeOf;
var $4ee88d3ab9e0f87b$var$iterator = Symbol.iterator, $4ee88d3ab9e0f87b$var$toStringTag = Symbol.toStringTag;
var $4ee88d3ab9e0f87b$var$kindOf = function(cache) {
    return function(thing) {
        var str = $4ee88d3ab9e0f87b$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    };
}(Object.create(null));
var $4ee88d3ab9e0f87b$var$kindOfTest = function(type) {
    type = type.toLowerCase();
    return function(thing) {
        return $4ee88d3ab9e0f87b$var$kindOf(thing) === type;
    };
};
var $4ee88d3ab9e0f87b$var$typeOfTest = function(type) {
    return function(thing) {
        return (typeof thing === "undefined" ? "undefined" : (0, $15ae7fd16c0fe95b$export$71511d61b312f219)(thing)) === type;
    };
};
/**
 * Determine if a value is a non-null object
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ var $4ee88d3ab9e0f87b$var$isArray = Array.isArray;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ var $4ee88d3ab9e0f87b$var$isUndefined = $4ee88d3ab9e0f87b$var$typeOfTest('undefined');
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $4ee88d3ab9e0f87b$var$isBuffer(val) {
    return val !== null && !$4ee88d3ab9e0f87b$var$isUndefined(val) && val.constructor !== null && !$4ee88d3ab9e0f87b$var$isUndefined(val.constructor) && $4ee88d3ab9e0f87b$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ var $4ee88d3ab9e0f87b$var$isArrayBuffer = $4ee88d3ab9e0f87b$var$kindOfTest('ArrayBuffer');
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $4ee88d3ab9e0f87b$var$isArrayBufferView(val) {
    var result;
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $4ee88d3ab9e0f87b$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ var $4ee88d3ab9e0f87b$var$isString = $4ee88d3ab9e0f87b$var$typeOfTest('string');
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ var $4ee88d3ab9e0f87b$var$isFunction = $4ee88d3ab9e0f87b$var$typeOfTest('function');
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ var $4ee88d3ab9e0f87b$var$isNumber = $4ee88d3ab9e0f87b$var$typeOfTest('number');
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ var $4ee88d3ab9e0f87b$var$isObject = function(thing) {
    return thing !== null && (typeof thing === "undefined" ? "undefined" : (0, $15ae7fd16c0fe95b$export$71511d61b312f219)(thing)) === 'object';
};
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ var $4ee88d3ab9e0f87b$var$isBoolean = function(thing) {
    return thing === true || thing === false;
};
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ var $4ee88d3ab9e0f87b$var$isPlainObject = function(val) {
    if ($4ee88d3ab9e0f87b$var$kindOf(val) !== 'object') return false;
    var prototype = $4ee88d3ab9e0f87b$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !($4ee88d3ab9e0f87b$var$toStringTag in val) && !($4ee88d3ab9e0f87b$var$iterator in val);
};
/**
 * Determine if a value is an empty object (safely handles Buffers)
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an empty object, otherwise false
 */ var $4ee88d3ab9e0f87b$var$isEmptyObject = function(val) {
    // Early return for non-objects or Buffers to prevent RangeError
    if (!$4ee88d3ab9e0f87b$var$isObject(val) || $4ee88d3ab9e0f87b$var$isBuffer(val)) return false;
    try {
        return Object.keys(val).length === 0 && Object.getPrototypeOf(val) === Object.prototype;
    } catch (e) {
        // Fallback for any other objects that might cause RangeError with Object.keys()
        return false;
    }
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ var $4ee88d3ab9e0f87b$var$isDate = $4ee88d3ab9e0f87b$var$kindOfTest('Date');
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ var $4ee88d3ab9e0f87b$var$isFile = $4ee88d3ab9e0f87b$var$kindOfTest('File');
/**
 * Determine if a value is a React Native Blob
 * React Native "blob": an object with a `uri` attribute. Optionally, it can
 * also have a `name` and `type` attribute to specify filename and content type
 *
 * @see https://github.com/facebook/react-native/blob/26684cf3adf4094eb6c405d345a75bf8c7c0bf88/Libraries/Network/FormData.js#L68-L71
 *
 * @param {*} value The value to test
 *
 * @returns {boolean} True if value is a React Native Blob, otherwise false
 */ var $4ee88d3ab9e0f87b$var$isReactNativeBlob = function(value) {
    return !!(value && typeof value.uri !== 'undefined');
};
/**
 * Determine if environment is React Native
 * ReactNative `FormData` has a non-standard `getParts()` method
 *
 * @param {*} formData The formData to test
 *
 * @returns {boolean} True if environment is React Native, otherwise false
 */ var $4ee88d3ab9e0f87b$var$isReactNative = function(formData) {
    return formData && typeof formData.getParts !== 'undefined';
};
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ var $4ee88d3ab9e0f87b$var$isBlob = $4ee88d3ab9e0f87b$var$kindOfTest('Blob');
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a FileList, otherwise false
 */ var $4ee88d3ab9e0f87b$var$isFileList = $4ee88d3ab9e0f87b$var$kindOfTest('FileList');
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ var $4ee88d3ab9e0f87b$var$isStream = function(val) {
    return $4ee88d3ab9e0f87b$var$isObject(val) && $4ee88d3ab9e0f87b$var$isFunction(val.pipe);
};
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ function $4ee88d3ab9e0f87b$var$getGlobal() {
    if (typeof globalThis !== 'undefined') return globalThis;
    if (typeof self !== 'undefined') return self;
    if (typeof window !== 'undefined') return window;
    if (typeof $parcel$global !== 'undefined') return $parcel$global;
    return {};
}
var $4ee88d3ab9e0f87b$var$G = $4ee88d3ab9e0f87b$var$getGlobal();
var $4ee88d3ab9e0f87b$var$FormDataCtor = typeof $4ee88d3ab9e0f87b$var$G.FormData !== 'undefined' ? $4ee88d3ab9e0f87b$var$G.FormData : undefined;
var $4ee88d3ab9e0f87b$var$isFormData = function(thing) {
    if (!thing) return false;
    if ($4ee88d3ab9e0f87b$var$FormDataCtor && thing instanceof $4ee88d3ab9e0f87b$var$FormDataCtor) return true;
    // Reject plain objects inheriting directly from Object.prototype so prototype-pollution gadgets can't spoof FormData.
    var proto = $4ee88d3ab9e0f87b$var$getPrototypeOf(thing);
    if (!proto || proto === Object.prototype) return false;
    if (!$4ee88d3ab9e0f87b$var$isFunction(thing.append)) return false;
    var kind = $4ee88d3ab9e0f87b$var$kindOf(thing);
    return kind === 'formdata' || // detect form-data instance
    kind === 'object' && $4ee88d3ab9e0f87b$var$isFunction(thing.toString) && thing.toString() === '[object FormData]';
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ var $4ee88d3ab9e0f87b$var$isURLSearchParams = $4ee88d3ab9e0f87b$var$kindOfTest('URLSearchParams');
var $4ee88d3ab9e0f87b$var$_map = (0, $c940fad574a3594c$export$71511d61b312f219)([
    'ReadableStream',
    'Request',
    'Response',
    'Headers'
].map($4ee88d3ab9e0f87b$var$kindOfTest), 4), $4ee88d3ab9e0f87b$var$isReadableStream = $4ee88d3ab9e0f87b$var$_map[0], $4ee88d3ab9e0f87b$var$isRequest = $4ee88d3ab9e0f87b$var$_map[1], $4ee88d3ab9e0f87b$var$isResponse = $4ee88d3ab9e0f87b$var$_map[2], $4ee88d3ab9e0f87b$var$isHeaders = $4ee88d3ab9e0f87b$var$_map[3];
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ var $4ee88d3ab9e0f87b$var$trim = function(str) {
    return str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
};
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array<unknown>} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Object} [options]
 * @param {Boolean} [options.allOwnKeys = false]
 * @returns {any}
 */ function $4ee88d3ab9e0f87b$var$forEach(obj, fn) {
    var _ref = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, _ref_allOwnKeys = _ref.allOwnKeys, allOwnKeys = _ref_allOwnKeys === void 0 ? false : _ref_allOwnKeys;
    // Don't bother if no value provided
    if (obj === null || typeof obj === 'undefined') return;
    var i;
    var l;
    // Force an array if not already something iterable
    if ((typeof obj === "undefined" ? "undefined" : (0, $15ae7fd16c0fe95b$export$71511d61b312f219)(obj)) !== 'object') /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($4ee88d3ab9e0f87b$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Buffer check
        if ($4ee88d3ab9e0f87b$var$isBuffer(obj)) return;
        // Iterate over object keys
        var keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        var len = keys.length;
        var key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
/**
 * Finds a key in an object, case-insensitive, returning the actual key name.
 * Returns null if the object is a Buffer or if no match is found.
 *
 * @param {Object} obj - The object to search.
 * @param {string} key - The key to find (case-insensitive).
 * @returns {?string} The actual key name if found, otherwise null.
 */ function $4ee88d3ab9e0f87b$var$findKey(obj, key) {
    if ($4ee88d3ab9e0f87b$var$isBuffer(obj)) return null;
    key = key.toLowerCase();
    var keys = Object.keys(obj);
    var i = keys.length;
    var _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
var $4ee88d3ab9e0f87b$var$_global = function() {
    /*eslint no-undef:0*/ if (typeof globalThis !== 'undefined') return globalThis;
    return typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : $parcel$global;
}();
var $4ee88d3ab9e0f87b$var$isContextDefined = function(context) {
    return !$4ee88d3ab9e0f87b$var$isUndefined(context) && context !== $4ee88d3ab9e0f87b$var$_global;
};
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * const result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $4ee88d3ab9e0f87b$var$merge() {
    for(var _len = arguments.length, objs = new Array(_len), _key = 0; _key < _len; _key++){
        objs[_key] = arguments[_key];
    }
    var _ref = $4ee88d3ab9e0f87b$var$isContextDefined(this) && this || {}, caseless = _ref.caseless, skipUndefined = _ref.skipUndefined;
    var result = {};
    var assignValue = function(val, key) {
        // Skip dangerous property names to prevent prototype pollution
        if (key === '__proto__' || key === 'constructor' || key === 'prototype') return;
        var targetKey = caseless && $4ee88d3ab9e0f87b$var$findKey(result, key) || key;
        // Read via own-prop only — a bare `result[targetKey]` walks the prototype
        // chain, so a polluted Object.prototype value could surface here and get
        // copied into the merged result.
        var existing = $4ee88d3ab9e0f87b$var$hasOwnProperty(result, targetKey) ? result[targetKey] : undefined;
        if ($4ee88d3ab9e0f87b$var$isPlainObject(existing) && $4ee88d3ab9e0f87b$var$isPlainObject(val)) result[targetKey] = $4ee88d3ab9e0f87b$var$merge(existing, val);
        else if ($4ee88d3ab9e0f87b$var$isPlainObject(val)) result[targetKey] = $4ee88d3ab9e0f87b$var$merge({}, val);
        else if ($4ee88d3ab9e0f87b$var$isArray(val)) result[targetKey] = val.slice();
        else if (!skipUndefined || !$4ee88d3ab9e0f87b$var$isUndefined(val)) result[targetKey] = val;
    };
    for(var i = 0, l = objs.length; i < l; i++)objs[i] && $4ee88d3ab9e0f87b$var$forEach(objs[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Object} [options]
 * @param {Boolean} [options.allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ var $4ee88d3ab9e0f87b$var$extend = function(a, b, thisArg) {
    var allOwnKeys = (arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}).allOwnKeys;
    $4ee88d3ab9e0f87b$var$forEach(b, function(val, key) {
        if (thisArg && $4ee88d3ab9e0f87b$var$isFunction(val)) Object.defineProperty(a, key, {
            // Null-proto descriptor so a polluted Object.prototype.get cannot
            // hijack defineProperty's accessor-vs-data resolution.
            __proto__: null,
            value: (0, $ad97c7e0c7328995$export$2e2bcd8739ae039)(val, thisArg),
            writable: true,
            enumerable: true,
            configurable: true
        });
        else Object.defineProperty(a, key, {
            __proto__: null,
            value: val,
            writable: true,
            enumerable: true,
            configurable: true
        });
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ var $4ee88d3ab9e0f87b$var$stripBOM = function(content) {
    if (content.charCodeAt(0) === 0xfeff) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ var $4ee88d3ab9e0f87b$var$inherits = function(constructor, superConstructor, props, descriptors) {
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    Object.defineProperty(constructor.prototype, 'constructor', {
        __proto__: null,
        value: constructor,
        writable: true,
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(constructor, 'super', {
        __proto__: null,
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ var $4ee88d3ab9e0f87b$var$toFlatObject = function(sourceObj, destObj, filter, propFilter) {
    var props;
    var i;
    var prop;
    var merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $4ee88d3ab9e0f87b$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ var $4ee88d3ab9e0f87b$var$endsWith = function(str, searchString, position) {
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    var lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ var $4ee88d3ab9e0f87b$var$toArray = function(thing) {
    if (!thing) return null;
    if ($4ee88d3ab9e0f87b$var$isArray(thing)) return thing;
    var i = thing.length;
    if (!$4ee88d3ab9e0f87b$var$isNumber(i)) return null;
    var arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
var $4ee88d3ab9e0f87b$var$isTypedArray = function(TypedArray) {
    // eslint-disable-next-line func-names
    return function(thing) {
        return TypedArray && thing instanceof TypedArray;
    };
}(typeof Uint8Array !== 'undefined' && $4ee88d3ab9e0f87b$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ var $4ee88d3ab9e0f87b$var$forEachEntry = function(obj, fn) {
    var generator = obj && obj[$4ee88d3ab9e0f87b$var$iterator];
    var _iterator = generator.call(obj);
    var result;
    while((result = _iterator.next()) && !result.done){
        var pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ var $4ee88d3ab9e0f87b$var$matchAll = function(regExp, str) {
    var matches;
    var arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ var $4ee88d3ab9e0f87b$var$isHTMLForm = $4ee88d3ab9e0f87b$var$kindOfTest('HTMLFormElement');
var $4ee88d3ab9e0f87b$var$toCamelCase = function(str) {
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
/* Creating a function that will check if an object has a property. */ var $4ee88d3ab9e0f87b$var$hasOwnProperty = function(param) {
    var hasOwnProperty = param.hasOwnProperty;
    return function(obj, prop) {
        return hasOwnProperty.call(obj, prop);
    };
}(Object.prototype);
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ var $4ee88d3ab9e0f87b$var$isRegExp = $4ee88d3ab9e0f87b$var$kindOfTest('RegExp');
var $4ee88d3ab9e0f87b$var$reduceDescriptors = function(obj, reducer) {
    var descriptors = Object.getOwnPropertyDescriptors(obj);
    var reducedDescriptors = {};
    $4ee88d3ab9e0f87b$var$forEach(descriptors, function(descriptor, name) {
        var ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ var $4ee88d3ab9e0f87b$var$freezeMethods = function(obj) {
    $4ee88d3ab9e0f87b$var$reduceDescriptors(obj, function(descriptor, name) {
        // skip restricted props in strict mode
        if ($4ee88d3ab9e0f87b$var$isFunction(obj) && [
            'arguments',
            'caller',
            'callee'
        ].includes(name)) return false;
        var value = obj[name];
        if (!$4ee88d3ab9e0f87b$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ('writable' in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = function() {
            throw Error("Can not rewrite read-only method '" + name + "'");
        };
    });
};
/**
 * Converts an array or a delimited string into an object set with values as keys and true as values.
 * Useful for fast membership checks.
 *
 * @param {Array|string} arrayOrString - The array or string to convert.
 * @param {string} delimiter - The delimiter to use if input is a string.
 * @returns {Object} An object with keys from the array or string, values set to true.
 */ var $4ee88d3ab9e0f87b$var$toObjectSet = function(arrayOrString, delimiter) {
    var obj = {};
    var define = function(arr) {
        arr.forEach(function(value) {
            obj[value] = true;
        });
    };
    $4ee88d3ab9e0f87b$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
var $4ee88d3ab9e0f87b$var$noop = function() {};
var $4ee88d3ab9e0f87b$var$toFiniteNumber = function(value, defaultValue) {
    return value != null && Number.isFinite(value = +value) ? value : defaultValue;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $4ee88d3ab9e0f87b$var$isSpecCompliantForm(thing) {
    return !!(thing && $4ee88d3ab9e0f87b$var$isFunction(thing.append) && thing[$4ee88d3ab9e0f87b$var$toStringTag] === 'FormData' && thing[$4ee88d3ab9e0f87b$var$iterator]);
}
/**
 * Recursively converts an object to a JSON-compatible object, handling circular references and Buffers.
 *
 * @param {Object} obj - The object to convert.
 * @returns {Object} The JSON-compatible object.
 */ var $4ee88d3ab9e0f87b$var$toJSONObject = function(obj) {
    var visited = new WeakSet();
    var visit = function(source) {
        if ($4ee88d3ab9e0f87b$var$isObject(source)) {
            if (visited.has(source)) return;
            //Buffer check
            if ($4ee88d3ab9e0f87b$var$isBuffer(source)) return source;
            if (!('toJSON' in source)) {
                // add-on descent / delete-on-ascent: preserves path semantics, so DAG nodes serialise at every occurrence (see #7230).
                visited.add(source);
                var target = $4ee88d3ab9e0f87b$var$isArray(source) ? [] : {};
                $4ee88d3ab9e0f87b$var$forEach(source, function(value, key) {
                    var reducedValue = visit(value);
                    !$4ee88d3ab9e0f87b$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                });
                visited["delete"](source);
                return target;
            }
        }
        return source;
    };
    return visit(obj);
};
/**
 * Determines if a value is an async function.
 *
 * @param {*} thing - The value to test.
 * @returns {boolean} True if value is an async function, otherwise false.
 */ var $4ee88d3ab9e0f87b$var$isAsyncFn = $4ee88d3ab9e0f87b$var$kindOfTest('AsyncFunction');
/**
 * Determines if a value is thenable (has then and catch methods).
 *
 * @param {*} thing - The value to test.
 * @returns {boolean} True if value is thenable, otherwise false.
 */ var $4ee88d3ab9e0f87b$var$isThenable = function(thing) {
    return thing && ($4ee88d3ab9e0f87b$var$isObject(thing) || $4ee88d3ab9e0f87b$var$isFunction(thing)) && $4ee88d3ab9e0f87b$var$isFunction(thing.then) && $4ee88d3ab9e0f87b$var$isFunction(thing["catch"]);
};
// original code
// https://github.com/DigitalBrainJS/AxiosPromise/blob/16deab13710ec09779922131f3fa5954320f83ab/lib/utils.js#L11-L34
/**
 * Provides a cross-platform setImmediate implementation.
 * Uses native setImmediate if available, otherwise falls back to postMessage or setTimeout.
 *
 * @param {boolean} setImmediateSupported - Whether setImmediate is supported.
 * @param {boolean} postMessageSupported - Whether postMessage is supported.
 * @returns {Function} A function to schedule a callback asynchronously.
 */ var $4ee88d3ab9e0f87b$var$_setImmediate = function(setImmediateSupported, postMessageSupported) {
    if (setImmediateSupported) return setImmediate;
    return postMessageSupported ? function(token, callbacks) {
        $4ee88d3ab9e0f87b$var$_global.addEventListener('message', function(param) {
            var source = param.source, data = param.data;
            if (source === $4ee88d3ab9e0f87b$var$_global && data === token) callbacks.length && callbacks.shift()();
        }, false);
        return function(cb) {
            callbacks.push(cb);
            $4ee88d3ab9e0f87b$var$_global.postMessage(token, '*');
        };
    }("axios@".concat(Math.random()), []) : function(cb) {
        return setTimeout(cb);
    };
}(typeof setImmediate === 'function', $4ee88d3ab9e0f87b$var$isFunction($4ee88d3ab9e0f87b$var$_global.postMessage));
/**
 * Schedules a microtask or asynchronous callback as soon as possible.
 * Uses queueMicrotask if available, otherwise falls back to process.nextTick or _setImmediate.
 *
 * @type {Function}
 */ var $4ee88d3ab9e0f87b$var$asap = typeof queueMicrotask !== 'undefined' ? queueMicrotask.bind($4ee88d3ab9e0f87b$var$_global) : $4ee88d3ab9e0f87b$var$_setImmediate;
// *********************
var $4ee88d3ab9e0f87b$var$isIterable = function(thing) {
    return thing != null && $4ee88d3ab9e0f87b$var$isFunction(thing[$4ee88d3ab9e0f87b$var$iterator]);
};
var $4ee88d3ab9e0f87b$export$2e2bcd8739ae039 = {
    isArray: $4ee88d3ab9e0f87b$var$isArray,
    isArrayBuffer: $4ee88d3ab9e0f87b$var$isArrayBuffer,
    isBuffer: $4ee88d3ab9e0f87b$var$isBuffer,
    isFormData: $4ee88d3ab9e0f87b$var$isFormData,
    isArrayBufferView: $4ee88d3ab9e0f87b$var$isArrayBufferView,
    isString: $4ee88d3ab9e0f87b$var$isString,
    isNumber: $4ee88d3ab9e0f87b$var$isNumber,
    isBoolean: $4ee88d3ab9e0f87b$var$isBoolean,
    isObject: $4ee88d3ab9e0f87b$var$isObject,
    isPlainObject: $4ee88d3ab9e0f87b$var$isPlainObject,
    isEmptyObject: $4ee88d3ab9e0f87b$var$isEmptyObject,
    isReadableStream: $4ee88d3ab9e0f87b$var$isReadableStream,
    isRequest: $4ee88d3ab9e0f87b$var$isRequest,
    isResponse: $4ee88d3ab9e0f87b$var$isResponse,
    isHeaders: $4ee88d3ab9e0f87b$var$isHeaders,
    isUndefined: $4ee88d3ab9e0f87b$var$isUndefined,
    isDate: $4ee88d3ab9e0f87b$var$isDate,
    isFile: $4ee88d3ab9e0f87b$var$isFile,
    isReactNativeBlob: $4ee88d3ab9e0f87b$var$isReactNativeBlob,
    isReactNative: $4ee88d3ab9e0f87b$var$isReactNative,
    isBlob: $4ee88d3ab9e0f87b$var$isBlob,
    isRegExp: $4ee88d3ab9e0f87b$var$isRegExp,
    isFunction: $4ee88d3ab9e0f87b$var$isFunction,
    isStream: $4ee88d3ab9e0f87b$var$isStream,
    isURLSearchParams: $4ee88d3ab9e0f87b$var$isURLSearchParams,
    isTypedArray: $4ee88d3ab9e0f87b$var$isTypedArray,
    isFileList: $4ee88d3ab9e0f87b$var$isFileList,
    forEach: $4ee88d3ab9e0f87b$var$forEach,
    merge: $4ee88d3ab9e0f87b$var$merge,
    extend: $4ee88d3ab9e0f87b$var$extend,
    trim: $4ee88d3ab9e0f87b$var$trim,
    stripBOM: $4ee88d3ab9e0f87b$var$stripBOM,
    inherits: $4ee88d3ab9e0f87b$var$inherits,
    toFlatObject: $4ee88d3ab9e0f87b$var$toFlatObject,
    kindOf: $4ee88d3ab9e0f87b$var$kindOf,
    kindOfTest: $4ee88d3ab9e0f87b$var$kindOfTest,
    endsWith: $4ee88d3ab9e0f87b$var$endsWith,
    toArray: $4ee88d3ab9e0f87b$var$toArray,
    forEachEntry: $4ee88d3ab9e0f87b$var$forEachEntry,
    matchAll: $4ee88d3ab9e0f87b$var$matchAll,
    isHTMLForm: $4ee88d3ab9e0f87b$var$isHTMLForm,
    hasOwnProperty: $4ee88d3ab9e0f87b$var$hasOwnProperty,
    hasOwnProp: $4ee88d3ab9e0f87b$var$hasOwnProperty,
    reduceDescriptors: $4ee88d3ab9e0f87b$var$reduceDescriptors,
    freezeMethods: $4ee88d3ab9e0f87b$var$freezeMethods,
    toObjectSet: $4ee88d3ab9e0f87b$var$toObjectSet,
    toCamelCase: $4ee88d3ab9e0f87b$var$toCamelCase,
    noop: $4ee88d3ab9e0f87b$var$noop,
    toFiniteNumber: $4ee88d3ab9e0f87b$var$toFiniteNumber,
    findKey: $4ee88d3ab9e0f87b$var$findKey,
    global: $4ee88d3ab9e0f87b$var$_global,
    isContextDefined: $4ee88d3ab9e0f87b$var$isContextDefined,
    isSpecCompliantForm: $4ee88d3ab9e0f87b$var$isSpecCompliantForm,
    toJSONObject: $4ee88d3ab9e0f87b$var$toJSONObject,
    isAsyncFn: $4ee88d3ab9e0f87b$var$isAsyncFn,
    isThenable: $4ee88d3ab9e0f87b$var$isThenable,
    setImmediate: $4ee88d3ab9e0f87b$var$_setImmediate,
    asap: $4ee88d3ab9e0f87b$var$asap,
    isIterable: $4ee88d3ab9e0f87b$var$isIterable
};







function $8339d784fb1d4c34$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $f716e475b33ed48e$export$71511d61b312f219)(arr);
}


function $2979195cf50db614$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


function $6ec61e19cd261b80$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}



function $9b2c00b55773b429$export$71511d61b312f219(arr) {
    return (0, $8339d784fb1d4c34$export$71511d61b312f219)(arr) || (0, $2979195cf50db614$export$71511d61b312f219)(arr) || (0, $d18d353f273b4be3$export$71511d61b312f219)(arr) || (0, $6ec61e19cd261b80$export$71511d61b312f219)();
}







function $83d3250fb80924d6$export$71511d61b312f219(o) {
    $83d3250fb80924d6$export$71511d61b312f219 = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $83d3250fb80924d6$export$71511d61b312f219(o);
}


function $525b82f3a5b8a294$export$71511d61b312f219() {
    // Since Reflect.construct can't be properly polyfilled, some
    // implementations (e.g. core-js@2) don't set the correct internal slots.
    // Those polyfills don't allow us to subclass built-ins, so we need to
    // use our fallback implementation.
    try {
        // If the internal slots aren't set, this throws an error similar to
        //   TypeError: this is not a Boolean object.
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return ($525b82f3a5b8a294$export$71511d61b312f219 = function() {
        return !!result;
    })();
}


function $28d2387416aed0d9$export$71511d61b312f219(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}



function $e1040b412682724d$export$71511d61b312f219(self, call) {
    if (call && ((0, $15ae7fd16c0fe95b$export$71511d61b312f219)(call) === "object" || typeof call === "function")) return call;
    return (0, $28d2387416aed0d9$export$71511d61b312f219)(self);
}


function $c3d1220ab604b036$export$71511d61b312f219(_this, derived, args) {
    // Super
    derived = (0, $83d3250fb80924d6$export$71511d61b312f219)(derived);
    return (0, $e1040b412682724d$export$71511d61b312f219)(_this, (0, $525b82f3a5b8a294$export$71511d61b312f219)() ? Reflect.construct(derived, args || [], (0, $83d3250fb80924d6$export$71511d61b312f219)(_this).constructor) : derived.apply(_this, args));
}




function $d37431e13fff57cb$export$71511d61b312f219(o, p) {
    $d37431e13fff57cb$export$71511d61b312f219 = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $d37431e13fff57cb$export$71511d61b312f219(o, p);
}


function $001a6eca05b809d8$export$71511d61b312f219(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) (0, $d37431e13fff57cb$export$71511d61b312f219)(subClass, superClass);
}






function $e0f0655c54957619$export$71511d61b312f219(Parent, args, Class) {
    if ((0, $525b82f3a5b8a294$export$71511d61b312f219)()) $e0f0655c54957619$export$71511d61b312f219 = Reflect.construct;
    else $e0f0655c54957619$export$71511d61b312f219 = function construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) (0, $d37431e13fff57cb$export$71511d61b312f219)(instance, Class.prototype);
        return instance;
    };
    return $e0f0655c54957619$export$71511d61b312f219.apply(null, arguments);
}



function $2806864211fe9108$export$71511d61b312f219(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}



function $b0e767267984ab71$export$71511d61b312f219(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $b0e767267984ab71$export$71511d61b312f219 = function(Class) {
        if (Class === null || !(0, $2806864211fe9108$export$71511d61b312f219)(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return (0, $e0f0655c54957619$export$71511d61b312f219)(Class, arguments, (0, $83d3250fb80924d6$export$71511d61b312f219)(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return (0, $d37431e13fff57cb$export$71511d61b312f219)(Wrapper, Class);
    };
    return $b0e767267984ab71$export$71511d61b312f219(Class);
}









'use strict';
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var $4b5ada3fe62d548c$var$ignoreDuplicateOf = (0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).toObjectSet([
    'age',
    'authorization',
    'content-length',
    'content-type',
    'etag',
    'expires',
    'from',
    'host',
    'if-modified-since',
    'if-unmodified-since',
    'last-modified',
    'location',
    'max-forwards',
    'proxy-authorization',
    'referer',
    'retry-after',
    'user-agent'
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $4b5ada3fe62d548c$export$2e2bcd8739ae039 = function(rawHeaders) {
    var parsed = {};
    var key;
    var val;
    var i;
    rawHeaders && rawHeaders.split('\n').forEach(function parser(line) {
        i = line.indexOf(':');
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        if (!key || parsed[key] && $4b5ada3fe62d548c$var$ignoreDuplicateOf[key]) return;
        if (key === 'set-cookie') {
            if (parsed[key]) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
    });
    return parsed;
};



'use strict';
function $11e5b93840d3f7d6$var$trimSPorHTAB(str) {
    var start = 0;
    var end = str.length;
    while(start < end){
        var code = str.charCodeAt(start);
        if (code !== 0x09 && code !== 0x20) break;
        start += 1;
    }
    while(end > start){
        var code1 = str.charCodeAt(end - 1);
        if (code1 !== 0x09 && code1 !== 0x20) break;
        end -= 1;
    }
    return start === 0 && end === str.length ? str : str.slice(start, end);
}
// The control-code ranges are intentional: header sanitization strips C0/DEL bytes.
// eslint-disable-next-line no-control-regex
var $11e5b93840d3f7d6$var$INVALID_UNICODE_HEADER_VALUE_CHARS = new RegExp('[\\u0000-\\u0008\\u000a-\\u001f\\u007f]+', 'g');
// eslint-disable-next-line no-control-regex
var $11e5b93840d3f7d6$var$INVALID_BYTE_STRING_HEADER_VALUE_CHARS = new RegExp('[^\\u0009\\u0020-\\u007e\\u0080-\\u00ff]+', 'g');
function $11e5b93840d3f7d6$var$sanitizeValue(value, invalidChars) {
    if ((0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).isArray(value)) return value.map(function(item) {
        return $11e5b93840d3f7d6$var$sanitizeValue(item, invalidChars);
    });
    return $11e5b93840d3f7d6$var$trimSPorHTAB(String(value).replace(invalidChars, ''));
}
var $11e5b93840d3f7d6$export$9e344cffce061a22 = function(value) {
    return $11e5b93840d3f7d6$var$sanitizeValue(value, $11e5b93840d3f7d6$var$INVALID_UNICODE_HEADER_VALUE_CHARS);
};
var $11e5b93840d3f7d6$export$59dd66c2a12d8f62 = function(value) {
    return $11e5b93840d3f7d6$var$sanitizeValue(value, $11e5b93840d3f7d6$var$INVALID_BYTE_STRING_HEADER_VALUE_CHARS);
};
function $11e5b93840d3f7d6$export$c30c72bb7e677d54(headers) {
    var byteStringHeaders = Object.create(null);
    (0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).forEach(headers.toJSON(), function(value, header) {
        byteStringHeaders[header] = $11e5b93840d3f7d6$export$59dd66c2a12d8f62(value);
    });
    return byteStringHeaders;
}


'use strict';
var $027c52967d4f7f5c$var$$internals = Symbol('internals');
function $027c52967d4f7f5c$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $027c52967d4f7f5c$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).isArray(value) ? value.map($027c52967d4f7f5c$var$normalizeValue) : (0, $11e5b93840d3f7d6$export$9e344cffce061a22)(String(value));
}
function $027c52967d4f7f5c$var$parseTokens(str) {
    var tokens = Object.create(null);
    var tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    var match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
var $027c52967d4f7f5c$var$isValidHeaderName = function(str) {
    return /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
};
function $027c52967d4f7f5c$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).isString(value)) return;
    if ((0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).isRegExp(filter)) return filter.test(value);
}
function $027c52967d4f7f5c$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, function(w, _char, str) {
        return _char.toUpperCase() + str;
    });
}
function $027c52967d4f7f5c$var$buildAccessors(obj, header) {
    var accessorName = (0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).toCamelCase(' ' + header);
    [
        'get',
        'set',
        'has'
    ].forEach(function(methodName) {
        Object.defineProperty(obj, methodName + accessorName, {
            // Null-proto descriptor so a polluted Object.prototype.get cannot turn
            // this data descriptor into an accessor descriptor on the way in.
            __proto__: null,
            value: function value(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
var $027c52967d4f7f5c$var$AxiosHeaders = /*#__PURE__*/ function() {
    function AxiosHeaders(headers) {
        (0, $27b4cf4927316b66$export$71511d61b312f219)(this, AxiosHeaders);
        headers && this.set(headers);
    }
    (0, $9ec8be00d480deaf$export$71511d61b312f219)(AxiosHeaders, [
        {
            key: "set",
            value: function set(header, valueOrRewrite, rewrite) {
                var self = this;
                function setHeader(_value, _header, _rewrite) {
                    var lHeader = $027c52967d4f7f5c$var$normalizeHeader(_header);
                    if (!lHeader) throw new Error('header name must be a non-empty string');
                    var key = (0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).findKey(self, lHeader);
                    if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $027c52967d4f7f5c$var$normalizeValue(_value);
                }
                var setHeaders = function(headers, _rewrite) {
                    return (0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).forEach(headers, function(_value, _header) {
                        return setHeader(_value, _header, _rewrite);
                    });
                };
                if ((0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
                else if ((0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).isString(header) && (header = header.trim()) && !$027c52967d4f7f5c$var$isValidHeaderName(header)) setHeaders((0, $4b5ada3fe62d548c$export$2e2bcd8739ae039)(header), valueOrRewrite);
                else if ((0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).isObject(header) && (0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).isIterable(header)) {
                    var obj = {}, dest, key;
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = header[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var entry = _step.value;
                            if (!(0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).isArray(entry)) throw TypeError('Object iterator must return a key-value pair');
                            obj[key = entry[0]] = (dest = obj[key]) ? (0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).isArray(dest) ? (0, $9b2c00b55773b429$export$71511d61b312f219)(dest).concat([
                                entry[1]
                            ]) : [
                                dest,
                                entry[1]
                            ] : entry[1];
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                _iterator["return"]();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    setHeaders(obj, valueOrRewrite);
                } else header != null && setHeader(valueOrRewrite, header, rewrite);
                return this;
            }
        },
        {
            key: "get",
            value: function get(header, parser) {
                header = $027c52967d4f7f5c$var$normalizeHeader(header);
                if (header) {
                    var key = (0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).findKey(this, header);
                    if (key) {
                        var value = this[key];
                        if (!parser) return value;
                        if (parser === true) return $027c52967d4f7f5c$var$parseTokens(value);
                        if ((0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).isFunction(parser)) return parser.call(this, value, key);
                        if ((0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).isRegExp(parser)) return parser.exec(value);
                        throw new TypeError('parser must be boolean|regexp|function');
                    }
                }
            }
        },
        {
            key: "has",
            value: function has(header, matcher) {
                header = $027c52967d4f7f5c$var$normalizeHeader(header);
                if (header) {
                    var key = (0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).findKey(this, header);
                    return !!(key && this[key] !== undefined && (!matcher || $027c52967d4f7f5c$var$matchHeaderValue(this, this[key], key, matcher)));
                }
                return false;
            }
        },
        {
            key: "delete",
            value: function _delete(header, matcher) {
                var self = this;
                var deleted = false;
                function deleteHeader(_header) {
                    _header = $027c52967d4f7f5c$var$normalizeHeader(_header);
                    if (_header) {
                        var key = (0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).findKey(self, _header);
                        if (key && (!matcher || $027c52967d4f7f5c$var$matchHeaderValue(self, self[key], key, matcher))) {
                            delete self[key];
                            deleted = true;
                        }
                    }
                }
                if ((0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).isArray(header)) header.forEach(deleteHeader);
                else deleteHeader(header);
                return deleted;
            }
        },
        {
            key: "clear",
            value: function clear(matcher) {
                var keys = Object.keys(this);
                var i = keys.length;
                var deleted = false;
                while(i--){
                    var key = keys[i];
                    if (!matcher || $027c52967d4f7f5c$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                        delete this[key];
                        deleted = true;
                    }
                }
                return deleted;
            }
        },
        {
            key: "normalize",
            value: function normalize(format) {
                var self = this;
                var headers = {};
                (0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).forEach(this, function(value, header) {
                    var key = (0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).findKey(headers, header);
                    if (key) {
                        self[key] = $027c52967d4f7f5c$var$normalizeValue(value);
                        delete self[header];
                        return;
                    }
                    var normalized = format ? $027c52967d4f7f5c$var$formatHeader(header) : String(header).trim();
                    if (normalized !== header) delete self[header];
                    self[normalized] = $027c52967d4f7f5c$var$normalizeValue(value);
                    headers[normalized] = true;
                });
                return this;
            }
        },
        {
            key: "concat",
            value: function concat() {
                for(var _len = arguments.length, targets = new Array(_len), _key = 0; _key < _len; _key++){
                    targets[_key] = arguments[_key];
                }
                var _this_constructor;
                return (_this_constructor = this.constructor).concat.apply(_this_constructor, [
                    this
                ].concat((0, $9b2c00b55773b429$export$71511d61b312f219)(targets)));
            }
        },
        {
            key: "toJSON",
            value: function toJSON(asStrings) {
                var obj = Object.create(null);
                (0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).forEach(this, function(value, header) {
                    value != null && value !== false && (obj[header] = asStrings && (0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).isArray(value) ? value.join(', ') : value);
                });
                return obj;
            }
        },
        {
            key: Symbol.iterator,
            value: function value() {
                return Object.entries(this.toJSON())[Symbol.iterator]();
            }
        },
        {
            key: "toString",
            value: function toString() {
                return Object.entries(this.toJSON()).map(function(param) {
                    var _param = (0, $c940fad574a3594c$export$71511d61b312f219)(param, 2), header = _param[0], value = _param[1];
                    return header + ': ' + value;
                }).join('\n');
            }
        },
        {
            key: "getSetCookie",
            value: function getSetCookie() {
                return this.get('set-cookie') || [];
            }
        },
        {
            key: Symbol.toStringTag,
            get: function get() {
                return 'AxiosHeaders';
            }
        }
    ], [
        {
            key: "from",
            value: function from(thing) {
                return thing instanceof this ? thing : new this(thing);
            }
        },
        {
            key: "concat",
            value: function concat(first) {
                for(var _len = arguments.length, targets = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    targets[_key - 1] = arguments[_key];
                }
                var computed = new this(first);
                targets.forEach(function(target) {
                    return computed.set(target);
                });
                return computed;
            }
        },
        {
            key: "accessor",
            value: function accessor(header) {
                var internals = this[$027c52967d4f7f5c$var$$internals] = this[$027c52967d4f7f5c$var$$internals] = {
                    accessors: {}
                };
                var accessors = internals.accessors;
                var prototype = this.prototype;
                function defineAccessor(_header) {
                    var lHeader = $027c52967d4f7f5c$var$normalizeHeader(_header);
                    if (!accessors[lHeader]) {
                        $027c52967d4f7f5c$var$buildAccessors(prototype, _header);
                        accessors[lHeader] = true;
                    }
                }
                (0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
                return this;
            }
        }
    ]);
    return AxiosHeaders;
}();
$027c52967d4f7f5c$var$AxiosHeaders.accessor([
    'Content-Type',
    'Content-Length',
    'Accept',
    'Accept-Encoding',
    'User-Agent',
    'Authorization'
]);
// reserved names hotfix
(0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).reduceDescriptors($027c52967d4f7f5c$var$AxiosHeaders.prototype, function(param, key) {
    var value = param.value;
    var mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: function() {
            return value;
        },
        set: function(headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).freezeMethods($027c52967d4f7f5c$var$AxiosHeaders);
var $027c52967d4f7f5c$export$2e2bcd8739ae039 = $027c52967d4f7f5c$var$AxiosHeaders;


'use strict';
var $781d5d445dc0d633$var$REDACTED = '[REDACTED ****]';
function $781d5d445dc0d633$var$hasOwnOrPrototypeToJSON(source) {
    if ((0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).hasOwnProp(source, 'toJSON')) return true;
    var prototype = Object.getPrototypeOf(source);
    while(prototype && prototype !== Object.prototype){
        if ((0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).hasOwnProp(prototype, 'toJSON')) return true;
        prototype = Object.getPrototypeOf(prototype);
    }
    return false;
}
// Build a plain-object snapshot of `config` and replace the value of any key
// (case-insensitive) listed in `redactKeys` with REDACTED. Walks through arrays
// and AxiosHeaders, and short-circuits on circular references.
function $781d5d445dc0d633$var$redactConfig(config, redactKeys) {
    var lowerKeys = new Set(redactKeys.map(function(k) {
        return String(k).toLowerCase();
    }));
    var seen = [];
    var visit = function(source) {
        if (source === null || (typeof source === "undefined" ? "undefined" : (0, $15ae7fd16c0fe95b$export$71511d61b312f219)(source)) !== 'object') return source;
        if ((0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).isBuffer(source)) return source;
        if (seen.indexOf(source) !== -1) return undefined;
        if (source instanceof (0, $027c52967d4f7f5c$export$2e2bcd8739ae039)) source = source.toJSON();
        seen.push(source);
        var result;
        if ((0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).isArray(source)) {
            result = [];
            source.forEach(function(v, i) {
                var reducedValue = visit(v);
                if (!(0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).isUndefined(reducedValue)) result[i] = reducedValue;
            });
        } else {
            if (!(0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).isPlainObject(source) && $781d5d445dc0d633$var$hasOwnOrPrototypeToJSON(source)) {
                seen.pop();
                return source;
            }
            result = Object.create(null);
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = Object.entries(source)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var _step_value = (0, $c940fad574a3594c$export$71511d61b312f219)(_step.value, 2), key = _step_value[0], value = _step_value[1];
                    var reducedValue = lowerKeys.has(key.toLowerCase()) ? $781d5d445dc0d633$var$REDACTED : visit(value);
                    if (!(0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).isUndefined(reducedValue)) result[key] = reducedValue;
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                        _iterator["return"]();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
        seen.pop();
        return result;
    };
    return visit(config);
}
var $781d5d445dc0d633$var$AxiosError = /*#__PURE__*/ function(Error1) {
    (0, $001a6eca05b809d8$export$71511d61b312f219)(AxiosError, Error1);
    function AxiosError(message, code, config, request, response) {
        (0, $27b4cf4927316b66$export$71511d61b312f219)(this, AxiosError);
        var _this;
        _this = (0, $c3d1220ab604b036$export$71511d61b312f219)(this, AxiosError, [
            message
        ]);
        // Make message enumerable to maintain backward compatibility
        // The native Error constructor sets message as non-enumerable,
        // but axios < v1.13.3 had it as enumerable
        Object.defineProperty(_this, 'message', {
            // Null-proto descriptor so a polluted Object.prototype.get cannot turn
            // this data descriptor into an accessor descriptor on the way in.
            __proto__: null,
            value: message,
            enumerable: true,
            writable: true,
            configurable: true
        });
        _this.name = 'AxiosError';
        _this.isAxiosError = true;
        code && (_this.code = code);
        config && (_this.config = config);
        request && (_this.request = request);
        if (response) {
            _this.response = response;
            _this.status = response.status;
        }
        return _this;
    }
    (0, $9ec8be00d480deaf$export$71511d61b312f219)(AxiosError, [
        {
            key: "toJSON",
            value: function toJSON() {
                // Opt-in redaction: when the request config carries a `redact` array, the
                // value of any matching key (case-insensitive, at any depth) is replaced
                // with REDACTED in the serialized snapshot. Undefined or empty leaves the
                // existing serialization behavior unchanged.
                var config = this.config;
                var redactKeys = config && (0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).hasOwnProp(config, 'redact') ? config.redact : undefined;
                var serializedConfig = (0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).isArray(redactKeys) && redactKeys.length > 0 ? $781d5d445dc0d633$var$redactConfig(config, redactKeys) : (0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).toJSONObject(config);
                return {
                    // Standard
                    message: this.message,
                    name: this.name,
                    // Microsoft
                    description: this.description,
                    number: this.number,
                    // Mozilla
                    fileName: this.fileName,
                    lineNumber: this.lineNumber,
                    columnNumber: this.columnNumber,
                    stack: this.stack,
                    // Axios
                    config: serializedConfig,
                    code: this.code,
                    status: this.status
                };
            }
        }
    ], [
        {
            key: "from",
            value: function from(error, code, config, request, response, customProps) {
                var axiosError = new AxiosError(error.message, code || error.code, config, request, response);
                axiosError.cause = error;
                axiosError.name = error.name;
                // Preserve status from the original error if not already set from response
                if (error.status != null && axiosError.status == null) axiosError.status = error.status;
                customProps && Object.assign(axiosError, customProps);
                return axiosError;
            }
        }
    ]);
    return AxiosError;
}((0, $b0e767267984ab71$export$71511d61b312f219)(Error));
// This can be changed to static properties as soon as the parser options in .eslint.cjs are updated.
$781d5d445dc0d633$var$AxiosError.ERR_BAD_OPTION_VALUE = 'ERR_BAD_OPTION_VALUE';
$781d5d445dc0d633$var$AxiosError.ERR_BAD_OPTION = 'ERR_BAD_OPTION';
$781d5d445dc0d633$var$AxiosError.ECONNABORTED = 'ECONNABORTED';
$781d5d445dc0d633$var$AxiosError.ETIMEDOUT = 'ETIMEDOUT';
$781d5d445dc0d633$var$AxiosError.ECONNREFUSED = 'ECONNREFUSED';
$781d5d445dc0d633$var$AxiosError.ERR_NETWORK = 'ERR_NETWORK';
$781d5d445dc0d633$var$AxiosError.ERR_FR_TOO_MANY_REDIRECTS = 'ERR_FR_TOO_MANY_REDIRECTS';
$781d5d445dc0d633$var$AxiosError.ERR_DEPRECATED = 'ERR_DEPRECATED';
$781d5d445dc0d633$var$AxiosError.ERR_BAD_RESPONSE = 'ERR_BAD_RESPONSE';
$781d5d445dc0d633$var$AxiosError.ERR_BAD_REQUEST = 'ERR_BAD_REQUEST';
$781d5d445dc0d633$var$AxiosError.ERR_CANCELED = 'ERR_CANCELED';
$781d5d445dc0d633$var$AxiosError.ERR_NOT_SUPPORT = 'ERR_NOT_SUPPORT';
$781d5d445dc0d633$var$AxiosError.ERR_INVALID_URL = 'ERR_INVALID_URL';
$781d5d445dc0d633$var$AxiosError.ERR_FORM_DATA_DEPTH_EXCEEDED = 'ERR_FORM_DATA_DEPTH_EXCEEDED';
var $781d5d445dc0d633$export$2e2bcd8739ae039 = $781d5d445dc0d633$var$AxiosError;


// eslint-disable-next-line strict
var $ae65935d5d170552$export$2e2bcd8739ae039 = null;


/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ 




var $812cf9b5c5174ce8$export$a143d493d941bafc;
var $812cf9b5c5174ce8$export$e4cf37d7f6fb9e0a;
var $812cf9b5c5174ce8$export$f99ded8fe4b79145;
var $812cf9b5c5174ce8$export$599f31c3813fae4d;
'use strict';
var $c1cd64402f75cd64$export$a48f0734ac7c2329;
var $c1cd64402f75cd64$export$d622b2ad8d90c771;
var $c1cd64402f75cd64$export$6100ba28696e12de;
'use strict';
$c1cd64402f75cd64$export$a48f0734ac7c2329 = $c1cd64402f75cd64$var$byteLength;
$c1cd64402f75cd64$export$d622b2ad8d90c771 = $c1cd64402f75cd64$var$toByteArray;
$c1cd64402f75cd64$export$6100ba28696e12de = $c1cd64402f75cd64$var$fromByteArray;
var $c1cd64402f75cd64$var$lookup = [];
var $c1cd64402f75cd64$var$revLookup = [];
var $c1cd64402f75cd64$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $c1cd64402f75cd64$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $c1cd64402f75cd64$var$i = 0, $c1cd64402f75cd64$var$len = $c1cd64402f75cd64$var$code.length; $c1cd64402f75cd64$var$i < $c1cd64402f75cd64$var$len; ++$c1cd64402f75cd64$var$i){
    $c1cd64402f75cd64$var$lookup[$c1cd64402f75cd64$var$i] = $c1cd64402f75cd64$var$code[$c1cd64402f75cd64$var$i];
    $c1cd64402f75cd64$var$revLookup[$c1cd64402f75cd64$var$code.charCodeAt($c1cd64402f75cd64$var$i)] = $c1cd64402f75cd64$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$c1cd64402f75cd64$var$revLookup['-'.charCodeAt(0)] = 62;
$c1cd64402f75cd64$var$revLookup['_'.charCodeAt(0)] = 63;
function $c1cd64402f75cd64$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $c1cd64402f75cd64$var$byteLength(b64) {
    var lens = $c1cd64402f75cd64$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $c1cd64402f75cd64$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $c1cd64402f75cd64$var$toByteArray(b64) {
    var tmp;
    var lens = $c1cd64402f75cd64$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $c1cd64402f75cd64$var$Arr($c1cd64402f75cd64$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $c1cd64402f75cd64$var$revLookup[b64.charCodeAt(i)] << 18 | $c1cd64402f75cd64$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $c1cd64402f75cd64$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $c1cd64402f75cd64$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $c1cd64402f75cd64$var$revLookup[b64.charCodeAt(i)] << 2 | $c1cd64402f75cd64$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $c1cd64402f75cd64$var$revLookup[b64.charCodeAt(i)] << 10 | $c1cd64402f75cd64$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $c1cd64402f75cd64$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $c1cd64402f75cd64$var$tripletToBase64(num) {
    return $c1cd64402f75cd64$var$lookup[num >> 18 & 0x3F] + $c1cd64402f75cd64$var$lookup[num >> 12 & 0x3F] + $c1cd64402f75cd64$var$lookup[num >> 6 & 0x3F] + $c1cd64402f75cd64$var$lookup[num & 0x3F];
}
function $c1cd64402f75cd64$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($c1cd64402f75cd64$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $c1cd64402f75cd64$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($c1cd64402f75cd64$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($c1cd64402f75cd64$var$lookup[tmp >> 2] + $c1cd64402f75cd64$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($c1cd64402f75cd64$var$lookup[tmp >> 10] + $c1cd64402f75cd64$var$lookup[tmp >> 4 & 0x3F] + $c1cd64402f75cd64$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $2dcaf9ea2b1d00a7$export$aafa59e2e03f2942;
var $2dcaf9ea2b1d00a7$export$68d8715fc104d294;
$2dcaf9ea2b1d00a7$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$2dcaf9ea2b1d00a7$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


var $812cf9b5c5174ce8$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$812cf9b5c5174ce8$export$a143d493d941bafc = $812cf9b5c5174ce8$var$Buffer;
$812cf9b5c5174ce8$export$e4cf37d7f6fb9e0a = $812cf9b5c5174ce8$var$SlowBuffer;
$812cf9b5c5174ce8$export$f99ded8fe4b79145 = 50;
var $812cf9b5c5174ce8$var$K_MAX_LENGTH = 0x7fffffff;
$812cf9b5c5174ce8$export$599f31c3813fae4d = $812cf9b5c5174ce8$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $812cf9b5c5174ce8$var$Buffer.TYPED_ARRAY_SUPPORT = $812cf9b5c5174ce8$var$typedArraySupport();
if (!$812cf9b5c5174ce8$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $812cf9b5c5174ce8$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function foo() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($812cf9b5c5174ce8$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function get() {
        if (!$812cf9b5c5174ce8$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($812cf9b5c5174ce8$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function get() {
        if (!$812cf9b5c5174ce8$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $812cf9b5c5174ce8$var$createBuffer(length) {
    if (length > $812cf9b5c5174ce8$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $812cf9b5c5174ce8$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $812cf9b5c5174ce8$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $812cf9b5c5174ce8$var$allocUnsafe(arg);
    }
    return $812cf9b5c5174ce8$var$from(arg, encodingOrOffset, length);
}
$812cf9b5c5174ce8$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $812cf9b5c5174ce8$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $812cf9b5c5174ce8$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $812cf9b5c5174ce8$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + (typeof value === "undefined" ? "undefined" : (0, $15ae7fd16c0fe95b$export$71511d61b312f219)(value)));
    if ($812cf9b5c5174ce8$var$isInstance(value, ArrayBuffer) || value && $812cf9b5c5174ce8$var$isInstance(value.buffer, ArrayBuffer)) return $812cf9b5c5174ce8$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($812cf9b5c5174ce8$var$isInstance(value, SharedArrayBuffer) || value && $812cf9b5c5174ce8$var$isInstance(value.buffer, SharedArrayBuffer))) return $812cf9b5c5174ce8$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $812cf9b5c5174ce8$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $812cf9b5c5174ce8$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $812cf9b5c5174ce8$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + (typeof value === "undefined" ? "undefined" : (0, $15ae7fd16c0fe95b$export$71511d61b312f219)(value)));
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $812cf9b5c5174ce8$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $812cf9b5c5174ce8$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($812cf9b5c5174ce8$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($812cf9b5c5174ce8$var$Buffer, Uint8Array);
function $812cf9b5c5174ce8$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $812cf9b5c5174ce8$var$alloc(size, fill, encoding) {
    $812cf9b5c5174ce8$var$assertSize(size);
    if (size <= 0) return $812cf9b5c5174ce8$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $812cf9b5c5174ce8$var$createBuffer(size).fill(fill, encoding) : $812cf9b5c5174ce8$var$createBuffer(size).fill(fill);
    return $812cf9b5c5174ce8$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $812cf9b5c5174ce8$var$Buffer.alloc = function(size, fill, encoding) {
    return $812cf9b5c5174ce8$var$alloc(size, fill, encoding);
};
function $812cf9b5c5174ce8$var$allocUnsafe(size) {
    $812cf9b5c5174ce8$var$assertSize(size);
    return $812cf9b5c5174ce8$var$createBuffer(size < 0 ? 0 : $812cf9b5c5174ce8$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $812cf9b5c5174ce8$var$Buffer.allocUnsafe = function(size) {
    return $812cf9b5c5174ce8$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $812cf9b5c5174ce8$var$Buffer.allocUnsafeSlow = function(size) {
    return $812cf9b5c5174ce8$var$allocUnsafe(size);
};
function $812cf9b5c5174ce8$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$812cf9b5c5174ce8$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    var length = $812cf9b5c5174ce8$var$byteLength(string, encoding) | 0;
    var buf = $812cf9b5c5174ce8$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $812cf9b5c5174ce8$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $812cf9b5c5174ce8$var$checked(array.length) | 0;
    var buf = $812cf9b5c5174ce8$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $812cf9b5c5174ce8$var$fromArrayView(arrayView) {
    if ($812cf9b5c5174ce8$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $812cf9b5c5174ce8$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $812cf9b5c5174ce8$var$fromArrayLike(arrayView);
}
function $812cf9b5c5174ce8$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $812cf9b5c5174ce8$var$Buffer.prototype);
    return buf;
}
function $812cf9b5c5174ce8$var$fromObject(obj) {
    if ($812cf9b5c5174ce8$var$Buffer.isBuffer(obj)) {
        var len = $812cf9b5c5174ce8$var$checked(obj.length) | 0;
        var buf = $812cf9b5c5174ce8$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $812cf9b5c5174ce8$var$numberIsNaN(obj.length)) return $812cf9b5c5174ce8$var$createBuffer(0);
        return $812cf9b5c5174ce8$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $812cf9b5c5174ce8$var$fromArrayLike(obj.data);
}
function $812cf9b5c5174ce8$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $812cf9b5c5174ce8$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $812cf9b5c5174ce8$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $812cf9b5c5174ce8$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $812cf9b5c5174ce8$var$Buffer.alloc(+length);
}
$812cf9b5c5174ce8$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $812cf9b5c5174ce8$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$812cf9b5c5174ce8$var$Buffer.compare = function compare(a, b) {
    if ($812cf9b5c5174ce8$var$isInstance(a, Uint8Array)) a = $812cf9b5c5174ce8$var$Buffer.from(a, a.offset, a.byteLength);
    if ($812cf9b5c5174ce8$var$isInstance(b, Uint8Array)) b = $812cf9b5c5174ce8$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$812cf9b5c5174ce8$var$Buffer.isBuffer(a) || !$812cf9b5c5174ce8$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$812cf9b5c5174ce8$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$812cf9b5c5174ce8$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $812cf9b5c5174ce8$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $812cf9b5c5174ce8$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($812cf9b5c5174ce8$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$812cf9b5c5174ce8$var$Buffer.isBuffer(buf)) buf = $812cf9b5c5174ce8$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$812cf9b5c5174ce8$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $812cf9b5c5174ce8$var$byteLength(string, encoding) {
    if ($812cf9b5c5174ce8$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $812cf9b5c5174ce8$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + (typeof string === "undefined" ? "undefined" : (0, $15ae7fd16c0fe95b$export$71511d61b312f219)(string)));
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $812cf9b5c5174ce8$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $812cf9b5c5174ce8$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $812cf9b5c5174ce8$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$812cf9b5c5174ce8$var$Buffer.byteLength = $812cf9b5c5174ce8$var$byteLength;
function $812cf9b5c5174ce8$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $812cf9b5c5174ce8$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $812cf9b5c5174ce8$var$utf8Slice(this, start, end);
        case 'ascii':
            return $812cf9b5c5174ce8$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $812cf9b5c5174ce8$var$latin1Slice(this, start, end);
        case 'base64':
            return $812cf9b5c5174ce8$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $812cf9b5c5174ce8$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$812cf9b5c5174ce8$var$Buffer.prototype._isBuffer = true;
function $812cf9b5c5174ce8$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$812cf9b5c5174ce8$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(var i = 0; i < len; i += 2)$812cf9b5c5174ce8$var$swap(this, i, i + 1);
    return this;
};
$812cf9b5c5174ce8$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(var i = 0; i < len; i += 4){
        $812cf9b5c5174ce8$var$swap(this, i, i + 3);
        $812cf9b5c5174ce8$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$812cf9b5c5174ce8$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(var i = 0; i < len; i += 8){
        $812cf9b5c5174ce8$var$swap(this, i, i + 7);
        $812cf9b5c5174ce8$var$swap(this, i + 1, i + 6);
        $812cf9b5c5174ce8$var$swap(this, i + 2, i + 5);
        $812cf9b5c5174ce8$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$812cf9b5c5174ce8$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $812cf9b5c5174ce8$var$utf8Slice(this, 0, length);
    return $812cf9b5c5174ce8$var$slowToString.apply(this, arguments);
};
$812cf9b5c5174ce8$var$Buffer.prototype.toLocaleString = $812cf9b5c5174ce8$var$Buffer.prototype.toString;
$812cf9b5c5174ce8$var$Buffer.prototype.equals = function equals(b) {
    if (!$812cf9b5c5174ce8$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $812cf9b5c5174ce8$var$Buffer.compare(this, b) === 0;
};
$812cf9b5c5174ce8$var$Buffer.prototype.inspect = function inspect() {
    var str = '';
    var max = $812cf9b5c5174ce8$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($812cf9b5c5174ce8$var$customInspectSymbol) $812cf9b5c5174ce8$var$Buffer.prototype[$812cf9b5c5174ce8$var$customInspectSymbol] = $812cf9b5c5174ce8$var$Buffer.prototype.inspect;
$812cf9b5c5174ce8$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($812cf9b5c5174ce8$var$isInstance(target, Uint8Array)) target = $812cf9b5c5174ce8$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$812cf9b5c5174ce8$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + (typeof target === "undefined" ? "undefined" : (0, $15ae7fd16c0fe95b$export$71511d61b312f219)(target)));
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $812cf9b5c5174ce8$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($812cf9b5c5174ce8$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $812cf9b5c5174ce8$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($812cf9b5c5174ce8$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $812cf9b5c5174ce8$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $812cf9b5c5174ce8$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $812cf9b5c5174ce8$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$812cf9b5c5174ce8$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$812cf9b5c5174ce8$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $812cf9b5c5174ce8$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$812cf9b5c5174ce8$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $812cf9b5c5174ce8$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $812cf9b5c5174ce8$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    var i;
    for(i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($812cf9b5c5174ce8$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $812cf9b5c5174ce8$var$utf8Write(buf, string, offset, length) {
    return $812cf9b5c5174ce8$var$blitBuffer($812cf9b5c5174ce8$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $812cf9b5c5174ce8$var$asciiWrite(buf, string, offset, length) {
    return $812cf9b5c5174ce8$var$blitBuffer($812cf9b5c5174ce8$var$asciiToBytes(string), buf, offset, length);
}
function $812cf9b5c5174ce8$var$base64Write(buf, string, offset, length) {
    return $812cf9b5c5174ce8$var$blitBuffer($812cf9b5c5174ce8$var$base64ToBytes(string), buf, offset, length);
}
function $812cf9b5c5174ce8$var$ucs2Write(buf, string, offset, length) {
    return $812cf9b5c5174ce8$var$blitBuffer($812cf9b5c5174ce8$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$812cf9b5c5174ce8$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $812cf9b5c5174ce8$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $812cf9b5c5174ce8$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $812cf9b5c5174ce8$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $812cf9b5c5174ce8$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $812cf9b5c5174ce8$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$812cf9b5c5174ce8$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $812cf9b5c5174ce8$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $c1cd64402f75cd64$export$6100ba28696e12de(buf);
    else return $c1cd64402f75cd64$export$6100ba28696e12de(buf.slice(start, end));
}
function $812cf9b5c5174ce8$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte = void 0, thirdByte = void 0, fourthByte = void 0, tempCodePoint = void 0;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $812cf9b5c5174ce8$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $812cf9b5c5174ce8$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $812cf9b5c5174ce8$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $812cf9b5c5174ce8$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = '';
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $812cf9b5c5174ce8$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $812cf9b5c5174ce8$var$asciiSlice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $812cf9b5c5174ce8$var$latin1Slice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $812cf9b5c5174ce8$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = '';
    for(var i = start; i < end; ++i)out += $812cf9b5c5174ce8$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $812cf9b5c5174ce8$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$812cf9b5c5174ce8$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $812cf9b5c5174ce8$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $812cf9b5c5174ce8$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$812cf9b5c5174ce8$var$Buffer.prototype.readUintLE = $812cf9b5c5174ce8$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $812cf9b5c5174ce8$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$812cf9b5c5174ce8$var$Buffer.prototype.readUintBE = $812cf9b5c5174ce8$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $812cf9b5c5174ce8$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$812cf9b5c5174ce8$var$Buffer.prototype.readUint8 = $812cf9b5c5174ce8$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $812cf9b5c5174ce8$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$812cf9b5c5174ce8$var$Buffer.prototype.readUint16LE = $812cf9b5c5174ce8$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $812cf9b5c5174ce8$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$812cf9b5c5174ce8$var$Buffer.prototype.readUint16BE = $812cf9b5c5174ce8$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $812cf9b5c5174ce8$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$812cf9b5c5174ce8$var$Buffer.prototype.readUint32LE = $812cf9b5c5174ce8$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $812cf9b5c5174ce8$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$812cf9b5c5174ce8$var$Buffer.prototype.readUint32BE = $812cf9b5c5174ce8$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $812cf9b5c5174ce8$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$812cf9b5c5174ce8$var$Buffer.prototype.readBigUInt64LE = $812cf9b5c5174ce8$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $812cf9b5c5174ce8$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $812cf9b5c5174ce8$var$boundsError(offset, this.length - 8);
    var lo = first + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 24);
    var hi = this[++offset] + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + last * Math.pow(2, 24);
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$812cf9b5c5174ce8$var$Buffer.prototype.readBigUInt64BE = $812cf9b5c5174ce8$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $812cf9b5c5174ce8$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $812cf9b5c5174ce8$var$boundsError(offset, this.length - 8);
    var hi = first * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + this[++offset];
    var lo = this[++offset] * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$812cf9b5c5174ce8$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $812cf9b5c5174ce8$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$812cf9b5c5174ce8$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $812cf9b5c5174ce8$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$812cf9b5c5174ce8$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $812cf9b5c5174ce8$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$812cf9b5c5174ce8$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $812cf9b5c5174ce8$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$812cf9b5c5174ce8$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $812cf9b5c5174ce8$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$812cf9b5c5174ce8$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $812cf9b5c5174ce8$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$812cf9b5c5174ce8$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $812cf9b5c5174ce8$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$812cf9b5c5174ce8$var$Buffer.prototype.readBigInt64LE = $812cf9b5c5174ce8$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $812cf9b5c5174ce8$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $812cf9b5c5174ce8$var$boundsError(offset, this.length - 8);
    var val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * Math.pow(2, 16) + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 24));
});
$812cf9b5c5174ce8$var$Buffer.prototype.readBigInt64BE = $812cf9b5c5174ce8$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $812cf9b5c5174ce8$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $812cf9b5c5174ce8$var$boundsError(offset, this.length - 8);
    var val = (first << 24) + // Overflow
    this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + last);
});
$812cf9b5c5174ce8$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $812cf9b5c5174ce8$var$checkOffset(offset, 4, this.length);
    return $2dcaf9ea2b1d00a7$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$812cf9b5c5174ce8$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $812cf9b5c5174ce8$var$checkOffset(offset, 4, this.length);
    return $2dcaf9ea2b1d00a7$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$812cf9b5c5174ce8$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $812cf9b5c5174ce8$var$checkOffset(offset, 8, this.length);
    return $2dcaf9ea2b1d00a7$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$812cf9b5c5174ce8$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $812cf9b5c5174ce8$var$checkOffset(offset, 8, this.length);
    return $2dcaf9ea2b1d00a7$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $812cf9b5c5174ce8$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$812cf9b5c5174ce8$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$812cf9b5c5174ce8$var$Buffer.prototype.writeUintLE = $812cf9b5c5174ce8$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $812cf9b5c5174ce8$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$812cf9b5c5174ce8$var$Buffer.prototype.writeUintBE = $812cf9b5c5174ce8$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $812cf9b5c5174ce8$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$812cf9b5c5174ce8$var$Buffer.prototype.writeUint8 = $812cf9b5c5174ce8$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $812cf9b5c5174ce8$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$812cf9b5c5174ce8$var$Buffer.prototype.writeUint16LE = $812cf9b5c5174ce8$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $812cf9b5c5174ce8$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$812cf9b5c5174ce8$var$Buffer.prototype.writeUint16BE = $812cf9b5c5174ce8$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $812cf9b5c5174ce8$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$812cf9b5c5174ce8$var$Buffer.prototype.writeUint32LE = $812cf9b5c5174ce8$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $812cf9b5c5174ce8$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$812cf9b5c5174ce8$var$Buffer.prototype.writeUint32BE = $812cf9b5c5174ce8$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $812cf9b5c5174ce8$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $812cf9b5c5174ce8$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $812cf9b5c5174ce8$var$checkIntBI(value, min, max, buf, offset, 7);
    var lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    var hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $812cf9b5c5174ce8$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $812cf9b5c5174ce8$var$checkIntBI(value, min, max, buf, offset, 7);
    var lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    var hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$812cf9b5c5174ce8$var$Buffer.prototype.writeBigUInt64LE = $812cf9b5c5174ce8$var$defineBigIntMethod(function writeBigUInt64LE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $812cf9b5c5174ce8$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$812cf9b5c5174ce8$var$Buffer.prototype.writeBigUInt64BE = $812cf9b5c5174ce8$var$defineBigIntMethod(function writeBigUInt64BE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $812cf9b5c5174ce8$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$812cf9b5c5174ce8$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $812cf9b5c5174ce8$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$812cf9b5c5174ce8$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $812cf9b5c5174ce8$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$812cf9b5c5174ce8$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $812cf9b5c5174ce8$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$812cf9b5c5174ce8$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $812cf9b5c5174ce8$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$812cf9b5c5174ce8$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $812cf9b5c5174ce8$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$812cf9b5c5174ce8$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $812cf9b5c5174ce8$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$812cf9b5c5174ce8$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $812cf9b5c5174ce8$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$812cf9b5c5174ce8$var$Buffer.prototype.writeBigInt64LE = $812cf9b5c5174ce8$var$defineBigIntMethod(function writeBigInt64LE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $812cf9b5c5174ce8$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$812cf9b5c5174ce8$var$Buffer.prototype.writeBigInt64BE = $812cf9b5c5174ce8$var$defineBigIntMethod(function writeBigInt64BE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $812cf9b5c5174ce8$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $812cf9b5c5174ce8$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $812cf9b5c5174ce8$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $812cf9b5c5174ce8$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $2dcaf9ea2b1d00a7$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$812cf9b5c5174ce8$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $812cf9b5c5174ce8$var$writeFloat(this, value, offset, true, noAssert);
};
$812cf9b5c5174ce8$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $812cf9b5c5174ce8$var$writeFloat(this, value, offset, false, noAssert);
};
function $812cf9b5c5174ce8$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $812cf9b5c5174ce8$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $2dcaf9ea2b1d00a7$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$812cf9b5c5174ce8$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $812cf9b5c5174ce8$var$writeDouble(this, value, offset, true, noAssert);
};
$812cf9b5c5174ce8$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $812cf9b5c5174ce8$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$812cf9b5c5174ce8$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$812cf9b5c5174ce8$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$812cf9b5c5174ce8$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$812cf9b5c5174ce8$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $812cf9b5c5174ce8$var$Buffer.isBuffer(val) ? val : $812cf9b5c5174ce8$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
var $812cf9b5c5174ce8$var$errors = {};
function $812cf9b5c5174ce8$var$E(sym, getMessage, Base) {
    $812cf9b5c5174ce8$var$errors[sym] = /*#__PURE__*/ function(Base) {
        (0, $001a6eca05b809d8$export$71511d61b312f219)(NodeError, Base);
        function NodeError() {
            (0, $27b4cf4927316b66$export$71511d61b312f219)(this, NodeError);
            var _this;
            _this = (0, $c3d1220ab604b036$export$71511d61b312f219)(this, NodeError);
            Object.defineProperty(_this, 'message', {
                value: getMessage.apply(_this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            _this.name = "".concat(_this.name, " [").concat(sym, "]");
            // Access the stack to generate the error message including the error code
            // from the name.
            _this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete _this.name;
            return _this;
        }
        (0, $9ec8be00d480deaf$export$71511d61b312f219)(NodeError, [
            {
                key: "code",
                get: function get() {
                    return sym;
                },
                set: function set(value) {
                    Object.defineProperty(this, 'code', {
                        configurable: true,
                        enumerable: true,
                        value: value,
                        writable: true
                    });
                }
            },
            {
                key: "toString",
                value: function toString() {
                    return "".concat(this.name, " [").concat(sym, "]: ").concat(this.message);
                }
            }
        ]);
        return NodeError;
    }(Base);
}
$812cf9b5c5174ce8$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return "".concat(name, " is outside of buffer bounds");
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$812cf9b5c5174ce8$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return 'The "'.concat(name, '" argument must be of type number. Received type ').concat(typeof actual === "undefined" ? "undefined" : (0, $15ae7fd16c0fe95b$export$71511d61b312f219)(actual));
}, TypeError);
$812cf9b5c5174ce8$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    var msg = 'The value of "'.concat(str, '" is out of range.');
    var received = input;
    if (Number.isInteger(input) && Math.abs(input) > Math.pow(2, 32)) received = $812cf9b5c5174ce8$var$addNumericalSeparator(String(input));
    else if ((typeof input === "undefined" ? "undefined" : (0, $15ae7fd16c0fe95b$export$71511d61b312f219)(input)) === 'bigint') {
        received = String(input);
        if (input > Math.pow(BigInt(2), BigInt(32)) || input < -Math.pow(BigInt(2), BigInt(32))) received = $812cf9b5c5174ce8$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += " It must be ".concat(range, ". Received ").concat(received);
    return msg;
}, RangeError);
function $812cf9b5c5174ce8$var$addNumericalSeparator(val) {
    var res = '';
    var i = val.length;
    var start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = "_".concat(val.slice(i - 3, i)).concat(res);
    return "".concat(val.slice(0, i)).concat(res);
}
// CHECK FUNCTIONS
// ===============
function $812cf9b5c5174ce8$var$checkBounds(buf, offset, byteLength) {
    $812cf9b5c5174ce8$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $812cf9b5c5174ce8$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $812cf9b5c5174ce8$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        var n = (typeof min === "undefined" ? "undefined" : (0, $15ae7fd16c0fe95b$export$71511d61b312f219)(min)) === 'bigint' ? 'n' : '';
        var range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = ">= 0".concat(n, " and < 2").concat(n, " ** ").concat((byteLength + 1) * 8).concat(n);
            else range = ">= -(2".concat(n, " ** ").concat((byteLength + 1) * 8 - 1).concat(n, ") and < 2 ** ") + "".concat((byteLength + 1) * 8 - 1).concat(n);
        } else range = ">= ".concat(min).concat(n, " and <= ").concat(max).concat(n);
        throw new $812cf9b5c5174ce8$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $812cf9b5c5174ce8$var$checkBounds(buf, offset, byteLength);
}
function $812cf9b5c5174ce8$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $812cf9b5c5174ce8$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $812cf9b5c5174ce8$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $812cf9b5c5174ce8$var$validateNumber(value, type);
        throw new $812cf9b5c5174ce8$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $812cf9b5c5174ce8$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $812cf9b5c5174ce8$var$errors.ERR_OUT_OF_RANGE(type || 'offset', ">= ".concat(type ? 1 : 0, " and <= ").concat(length), value);
}
// HELPER FUNCTIONS
// ================
var $812cf9b5c5174ce8$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $812cf9b5c5174ce8$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($812cf9b5c5174ce8$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $812cf9b5c5174ce8$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $812cf9b5c5174ce8$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $812cf9b5c5174ce8$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $812cf9b5c5174ce8$var$base64ToBytes(str) {
    return $c1cd64402f75cd64$export$d622b2ad8d90c771($812cf9b5c5174ce8$var$base64clean(str));
}
function $812cf9b5c5174ce8$var$blitBuffer(src, dst, offset, length) {
    var i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $812cf9b5c5174ce8$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $812cf9b5c5174ce8$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $812cf9b5c5174ce8$var$hexSliceLookupTable = function() {
    var alphabet = '0123456789abcdef';
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $812cf9b5c5174ce8$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $812cf9b5c5174ce8$var$BufferBigIntNotDefined : fn;
}
function $812cf9b5c5174ce8$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}


var $49a9beed7bc31dae$require$Buffer = $812cf9b5c5174ce8$export$a143d493d941bafc;
'use strict';
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $49a9beed7bc31dae$var$isVisitable(thing) {
    return (0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).isPlainObject(thing) || (0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $49a9beed7bc31dae$var$removeBrackets(key) {
    return (0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).endsWith(key, '[]') ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $49a9beed7bc31dae$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $49a9beed7bc31dae$var$removeBrackets(token);
        return !dots && i ? '[' + token + ']' : token;
    }).join(dots ? '.' : '');
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $49a9beed7bc31dae$var$isFlatArray(arr) {
    return (0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).isArray(arr) && !arr.some($49a9beed7bc31dae$var$isVisitable);
}
var $49a9beed7bc31dae$var$predicates = (0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).toFlatObject((0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $49a9beed7bc31dae$var$toFormData(obj, formData, options) {
    if (!(0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError('target must be an object');
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $ae65935d5d170552$export$2e2bcd8739ae039) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).isUndefined(source[option]);
    });
    var metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    var visitor = options.visitor || defaultVisitor;
    var dots = options.dots;
    var indexes = options.indexes;
    var _Blob = options.Blob || typeof Blob !== 'undefined' && Blob;
    var maxDepth = options.maxDepth === undefined ? 100 : options.maxDepth;
    var useBlob = _Blob && (0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).isSpecCompliantForm(formData);
    if (!(0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).isFunction(visitor)) throw new TypeError('visitor must be a function');
    function convertValue(value) {
        if (value === null) return '';
        if ((0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).isDate(value)) return value.toISOString();
        if ((0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).isBoolean(value)) return value.toString();
        if (!useBlob && (0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).isBlob(value)) throw new (0, $781d5d445dc0d633$export$2e2bcd8739ae039)('Blob is not supported. Use a Buffer instead.');
        if ((0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).isArrayBuffer(value) || (0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).isTypedArray(value)) return useBlob && typeof Blob === 'function' ? new Blob([
            value
        ]) : $49a9beed7bc31dae$require$Buffer.from(value);
        return value;
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        var arr = value;
        if ((0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).isReactNative(formData) && (0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).isReactNativeBlob(value)) {
            formData.append($49a9beed7bc31dae$var$renderKey(path, key, dots), convertValue(value));
            return false;
        }
        if (value && !path && (typeof value === "undefined" ? "undefined" : (0, $15ae7fd16c0fe95b$export$71511d61b312f219)(value)) === 'object') {
            if ((0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).endsWith(key, '{}')) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = JSON.stringify(value);
            } else if ((0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).isArray(value) && $49a9beed7bc31dae$var$isFlatArray(value) || ((0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).isFileList(value) || (0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).endsWith(key, '[]')) && (arr = (0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $49a9beed7bc31dae$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $49a9beed7bc31dae$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + '[]', convertValue(el));
                });
                return false;
            }
        }
        if ($49a9beed7bc31dae$var$isVisitable(value)) return true;
        formData.append($49a9beed7bc31dae$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    var stack = [];
    var exposedHelpers = Object.assign($49a9beed7bc31dae$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $49a9beed7bc31dae$var$isVisitable
    });
    function build(value, path) {
        var depth = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
        if ((0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).isUndefined(value)) return;
        if (depth > maxDepth) throw new (0, $781d5d445dc0d633$export$2e2bcd8739ae039)('Object is too deeply nested (' + depth + ' levels). Max depth: ' + maxDepth, (0, $781d5d445dc0d633$export$2e2bcd8739ae039).ERR_FORM_DATA_DEPTH_EXCEEDED);
        if (stack.indexOf(value) !== -1) throw Error('Circular reference detected in ' + path.join('.'));
        stack.push(value);
        (0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).forEach(value, function each(el, key) {
            var result = !((0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ], depth + 1);
        });
        stack.pop();
    }
    if (!(0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError('data must be an object');
    build(obj);
    return formData;
}
var $49a9beed7bc31dae$export$2e2bcd8739ae039 = $49a9beed7bc31dae$var$toFormData;


'use strict';
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $a96eeea79a91e196$var$encode(str) {
    var charMap = {
        '!': '%21',
        "'": '%27',
        '(': '%28',
        ')': '%29',
        '~': '%7E',
        '%20': '+'
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $a96eeea79a91e196$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $49a9beed7bc31dae$export$2e2bcd8739ae039)(params, this, options);
}
var $a96eeea79a91e196$var$prototype = $a96eeea79a91e196$var$AxiosURLSearchParams.prototype;
$a96eeea79a91e196$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$a96eeea79a91e196$var$prototype.toString = function toString(encoder) {
    var _encode = encoder ? function _encode(value) {
        return encoder.call(this, value, $a96eeea79a91e196$var$encode);
    } : $a96eeea79a91e196$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + '=' + _encode(pair[1]);
    }, '').join('&');
};
var $a96eeea79a91e196$export$2e2bcd8739ae039 = $a96eeea79a91e196$var$AxiosURLSearchParams;


'use strict';
function $99de190d72ac4f4a$export$c564cdbbe6da493(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+');
}
function $99de190d72ac4f4a$export$2e2bcd8739ae039(url, params, options) {
    if (!params) return url;
    var _encode = options && options.encode || $99de190d72ac4f4a$export$c564cdbbe6da493;
    var _options = (0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).isFunction(options) ? {
        serialize: options
    } : options;
    var serializeFn = _options && _options.serialize;
    var serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, _options);
    else serializedParams = (0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).isURLSearchParams(params) ? params.toString() : new (0, $a96eeea79a91e196$export$2e2bcd8739ae039)(params, _options).toString(_encode);
    if (serializedParams) {
        var hashmarkIndex = url.indexOf('#');
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
    }
    return url;
}





'use strict';
var $7ad406f9763aae38$var$InterceptorManager = /*#__PURE__*/ function() {
    function InterceptorManager() {
        (0, $27b4cf4927316b66$export$71511d61b312f219)(this, InterceptorManager);
        this.handlers = [];
    }
    (0, $9ec8be00d480deaf$export$71511d61b312f219)(InterceptorManager, [
        {
            /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   * @param {Object} options The options for the interceptor, synchronous and runWhen
   *
   * @return {Number} An ID used to remove interceptor later
   */ key: "use",
            value: function use(fulfilled, rejected, options) {
                this.handlers.push({
                    fulfilled: fulfilled,
                    rejected: rejected,
                    synchronous: options ? options.synchronous : false,
                    runWhen: options ? options.runWhen : null
                });
                return this.handlers.length - 1;
            }
        },
        {
            /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {void}
   */ key: "eject",
            value: function eject(id) {
                if (this.handlers[id]) this.handlers[id] = null;
            }
        },
        {
            /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ key: "clear",
            value: function clear() {
                if (this.handlers) this.handlers = [];
            }
        },
        {
            /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ key: "forEach",
            value: function forEach(fn) {
                (0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).forEach(this.handlers, function forEachHandler(h) {
                    if (h !== null) fn(h);
                });
            }
        }
    ]);
    return InterceptorManager;
}();
var $7ad406f9763aae38$export$2e2bcd8739ae039 = $7ad406f9763aae38$var$InterceptorManager;





'use strict';
var $4f1fbd47c7daaec2$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false,
    legacyInterceptorReqResOrdering: true
};



function $bfe84793eadce7a5$export$71511d61b312f219(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}


function $a1640dbfa76e87bd$export$71511d61b312f219(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $bfe84793eadce7a5$export$71511d61b312f219)(target, key, source[key]);
        });
    }
    return target;
}






'use strict';
var $01e3cb9b96d8f543$export$2e2bcd8739ae039 = typeof URLSearchParams !== 'undefined' ? URLSearchParams : (0, $a96eeea79a91e196$export$2e2bcd8739ae039);


'use strict';
var $904f3e27599de4a7$export$2e2bcd8739ae039 = typeof FormData !== 'undefined' ? FormData : null;


'use strict';
var $1c26159e005bb0d1$export$2e2bcd8739ae039 = typeof Blob !== 'undefined' ? Blob : null;


var $981288facdb174aa$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: (0, $01e3cb9b96d8f543$export$2e2bcd8739ae039),
        FormData: (0, $904f3e27599de4a7$export$2e2bcd8739ae039),
        Blob: (0, $1c26159e005bb0d1$export$2e2bcd8739ae039)
    },
    protocols: [
        'http',
        'https',
        'file',
        'blob',
        'url',
        'data'
    ]
};


var $4bff224049d751f2$exports = {};

$parcel$export($4bff224049d751f2$exports, "hasBrowserEnv", function () { return $4bff224049d751f2$export$c4996c4b7b93b0bf; });
$parcel$export($4bff224049d751f2$exports, "navigator", function () { return $4bff224049d751f2$export$ec7c8efa7f5790ae; });
$parcel$export($4bff224049d751f2$exports, "hasStandardBrowserEnv", function () { return $4bff224049d751f2$export$c0bcc9250309d66; });
$parcel$export($4bff224049d751f2$exports, "hasStandardBrowserWebWorkerEnv", function () { return $4bff224049d751f2$export$c81692cf5af97dac; });
$parcel$export($4bff224049d751f2$exports, "origin", function () { return $4bff224049d751f2$export$f710a83a91838a36; });

var $4bff224049d751f2$export$c4996c4b7b93b0bf = typeof window !== 'undefined' && typeof document !== 'undefined';
var $4bff224049d751f2$export$ec7c8efa7f5790ae = (typeof navigator === "undefined" ? "undefined" : (0, $15ae7fd16c0fe95b$export$71511d61b312f219)(navigator)) === 'object' && navigator || undefined;
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ var $4bff224049d751f2$export$c0bcc9250309d66 = $4bff224049d751f2$export$c4996c4b7b93b0bf && (!$4bff224049d751f2$export$ec7c8efa7f5790ae || [
    'ReactNative',
    'NativeScript',
    'NS'
].indexOf($4bff224049d751f2$export$ec7c8efa7f5790ae.product) < 0);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ var $4bff224049d751f2$export$c81692cf5af97dac = function() {
    return typeof WorkerGlobalScope !== 'undefined' && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === 'function';
}();
var $4bff224049d751f2$export$f710a83a91838a36 = $4bff224049d751f2$export$c4996c4b7b93b0bf && window.location.href || 'http://localhost';


var $b8e26be6780b0fac$export$2e2bcd8739ae039 = (0, $a1640dbfa76e87bd$export$71511d61b312f219)({}, $4bff224049d751f2$exports, (0, $981288facdb174aa$export$2e2bcd8739ae039));


'use strict';
function $9d932868578bccc2$export$2e2bcd8739ae039(data, options) {
    return (0, $49a9beed7bc31dae$export$2e2bcd8739ae039)(data, new (0, $b8e26be6780b0fac$export$2e2bcd8739ae039).classes.URLSearchParams(), (0, $a1640dbfa76e87bd$export$71511d61b312f219)({
        visitor: function visitor(value, key, path, helpers) {
            if ((0, $b8e26be6780b0fac$export$2e2bcd8739ae039).isNode && (0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).isBuffer(value)) {
                this.append(key, value.toString('base64'));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        }
    }, options));
}




'use strict';
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $fb53b50c26be7261$var$parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    return (0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).matchAll(/\w+|\[(\w*)]/g, name).map(function(match) {
        return match[0] === '[]' ? '' : match[1] || match[0];
    });
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $fb53b50c26be7261$var$arrayToObject(arr) {
    var obj = {};
    var keys = Object.keys(arr);
    var i;
    var len = keys.length;
    var key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $fb53b50c26be7261$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        var name = path[index++];
        if (name === '__proto__') return true;
        var isNumericKey = Number.isFinite(+name);
        var isLast = index >= path.length;
        name = !name && (0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).hasOwnProp(target, name)) target[name] = (0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).isArray(target[name]) ? target[name].concat(value) : [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!(0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).hasOwnProp(target, name) || !(0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).isObject(target[name])) target[name] = [];
        var result = buildPath(path, value, target[name], index);
        if (result && (0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).isArray(target[name])) target[name] = $fb53b50c26be7261$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).isFormData(formData) && (0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).isFunction(formData.entries)) {
        var obj = {};
        (0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).forEachEntry(formData, function(name, value) {
            buildPath($fb53b50c26be7261$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $fb53b50c26be7261$export$2e2bcd8739ae039 = $fb53b50c26be7261$var$formDataToJSON;


'use strict';
var $9a9eabebd13760ea$var$own = function(obj, key) {
    return obj != null && (0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).hasOwnProp(obj, key) ? obj[key] : undefined;
};
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $9a9eabebd13760ea$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).trim(rawValue);
    } catch (e) {
        if (e.name !== 'SyntaxError') throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
var $9a9eabebd13760ea$var$defaults = {
    transitional: (0, $4f1fbd47c7daaec2$export$2e2bcd8739ae039),
    adapter: [
        'xhr',
        'http',
        'fetch'
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            var contentType = headers.getContentType() || '';
            var hasJSONContentType = contentType.indexOf('application/json') > -1;
            var isObjectPayload = (0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).isObject(data);
            if (isObjectPayload && (0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).isHTMLForm(data)) data = new FormData(data);
            var isFormData = (0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify((0, $fb53b50c26be7261$export$2e2bcd8739ae039)(data)) : data;
            if ((0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).isArrayBuffer(data) || (0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).isBuffer(data) || (0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).isStream(data) || (0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).isFile(data) || (0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).isBlob(data) || (0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if ((0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).isArrayBufferView(data)) return data.buffer;
            if ((0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).isURLSearchParams(data)) {
                headers.setContentType('application/x-www-form-urlencoded;charset=utf-8', false);
                return data.toString();
            }
            var isFileList;
            if (isObjectPayload) {
                var formSerializer = $9a9eabebd13760ea$var$own(this, 'formSerializer');
                if (contentType.indexOf('application/x-www-form-urlencoded') > -1) return (0, $9d932868578bccc2$export$2e2bcd8739ae039)(data, formSerializer).toString();
                if ((isFileList = (0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).isFileList(data)) || contentType.indexOf('multipart/form-data') > -1) {
                    var env = $9a9eabebd13760ea$var$own(this, 'env');
                    var _FormData = env && env.FormData;
                    return (0, $49a9beed7bc31dae$export$2e2bcd8739ae039)(isFileList ? {
                        'files[]': data
                    } : data, _FormData && new _FormData(), formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType('application/json', false);
                return $9a9eabebd13760ea$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            var transitional = $9a9eabebd13760ea$var$own(this, 'transitional') || $9a9eabebd13760ea$var$defaults.transitional;
            var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            var responseType = $9a9eabebd13760ea$var$own(this, 'responseType');
            var JSONRequested = responseType === 'json';
            if ((0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).isResponse(data) || (0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if (data && (0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).isString(data) && (forcedJSONParsing && !responseType || JSONRequested)) {
                var silentJSONParsing = transitional && transitional.silentJSONParsing;
                var strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data, $9a9eabebd13760ea$var$own(this, 'parseReviver'));
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === 'SyntaxError') throw (0, $781d5d445dc0d633$export$2e2bcd8739ae039).from(e, (0, $781d5d445dc0d633$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, this, null, $9a9eabebd13760ea$var$own(this, 'response'));
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $b8e26be6780b0fac$export$2e2bcd8739ae039).classes.FormData,
        Blob: (0, $b8e26be6780b0fac$export$2e2bcd8739ae039).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            Accept: 'application/json, text/plain, */*',
            'Content-Type': undefined
        }
    }
};
(0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).forEach([
    'delete',
    'get',
    'head',
    'post',
    'put',
    'patch',
    'query'
], function(method) {
    $9a9eabebd13760ea$var$defaults.headers[method] = {};
});
var $9a9eabebd13760ea$export$2e2bcd8739ae039 = $9a9eabebd13760ea$var$defaults;



'use strict';
function $d421006f298e0907$export$2e2bcd8739ae039(fns, response) {
    var config = this || (0, $9a9eabebd13760ea$export$2e2bcd8739ae039);
    var context = response || config;
    var headers = (0, $027c52967d4f7f5c$export$2e2bcd8739ae039).from(context.headers);
    var data = context.data;
    (0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}


'use strict';
function $04ca7e0fcb50dd8a$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}







'use strict';
var $deb8b523360309d3$var$CanceledError = /*#__PURE__*/ function(AxiosError1) {
    (0, $001a6eca05b809d8$export$71511d61b312f219)(CanceledError, AxiosError1);
    function CanceledError(message, config, request) {
        (0, $27b4cf4927316b66$export$71511d61b312f219)(this, CanceledError);
        var _this;
        _this = (0, $c3d1220ab604b036$export$71511d61b312f219)(this, CanceledError, [
            message == null ? 'canceled' : message,
            (0, $781d5d445dc0d633$export$2e2bcd8739ae039).ERR_CANCELED,
            config,
            request
        ]);
        _this.name = 'CanceledError';
        _this.__CANCEL__ = true;
        return _this;
    }
    return CanceledError;
}((0, $781d5d445dc0d633$export$2e2bcd8739ae039));
var $deb8b523360309d3$export$2e2bcd8739ae039 = $deb8b523360309d3$var$CanceledError;









'use strict';
function $fa6ddd8972b1eef7$export$2e2bcd8739ae039(resolve, reject, response) {
    var validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $781d5d445dc0d633$export$2e2bcd8739ae039)('Request failed with status code ' + response.status, response.status >= 400 && response.status < 500 ? (0, $781d5d445dc0d633$export$2e2bcd8739ae039).ERR_BAD_REQUEST : (0, $781d5d445dc0d633$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, response.config, response.request, response));
}





'use strict';
function $58ae0ab5a1b8cc6b$export$2e2bcd8739ae039(url) {
    var match = /^([-+\w]{1,25}):(?:\/\/)?/.exec(url);
    return match && match[1] || '';
}






'use strict';
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $4c0ddbe9b73f253e$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    var bytes = new Array(samplesCount);
    var timestamps = new Array(samplesCount);
    var head = 0;
    var tail = 0;
    var firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        var now = Date.now();
        var startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        var i = tail;
        var bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        var passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $4c0ddbe9b73f253e$export$2e2bcd8739ae039 = $4c0ddbe9b73f253e$var$speedometer;


/**
 * Throttle decorator
 * @param {Function} fn
 * @param {Number} freq
 * @return {Function}
 */ 
function $92257bafb342535a$var$throttle(fn, freq) {
    var timestamp = 0;
    var threshold = 1000 / freq;
    var lastArgs;
    var timer;
    var invoke = function(args) {
        var now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now();
        timestamp = now;
        lastArgs = null;
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
        fn.apply(void 0, (0, $9b2c00b55773b429$export$71511d61b312f219)(args));
    };
    var throttled = function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var now = Date.now();
        var passed = now - timestamp;
        if (passed >= threshold) invoke(args, now);
        else {
            lastArgs = args;
            if (!timer) timer = setTimeout(function() {
                timer = null;
                invoke(lastArgs);
            }, threshold - passed);
        }
    };
    var flush = function() {
        return lastArgs && invoke(lastArgs);
    };
    return [
        throttled,
        flush
    ];
}
var $92257bafb342535a$export$2e2bcd8739ae039 = $92257bafb342535a$var$throttle;



var $b0e463ffe46d623a$export$c1b28109d46c3592 = function(listener, isDownloadStream) {
    var freq = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 3;
    var bytesNotified = 0;
    var _speedometer = (0, $4c0ddbe9b73f253e$export$2e2bcd8739ae039)(50, 250);
    return (0, $92257bafb342535a$export$2e2bcd8739ae039)(function(e) {
        if (!e || typeof e.loaded !== 'number') return;
        var rawLoaded = e.loaded;
        var total = e.lengthComputable ? e.total : undefined;
        var loaded = total != null ? Math.min(rawLoaded, total) : rawLoaded;
        var progressBytes = Math.max(0, loaded - bytesNotified);
        var rate = _speedometer(progressBytes);
        bytesNotified = Math.max(bytesNotified, loaded);
        var data = (0, $bfe84793eadce7a5$export$71511d61b312f219)({
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total ? (total - loaded) / rate : undefined,
            event: e,
            lengthComputable: total != null
        }, isDownloadStream ? 'download' : 'upload', true);
        listener(data);
    }, freq);
};
var $b0e463ffe46d623a$export$d9fadd12586c18d6 = function(total, throttled) {
    var lengthComputable = total != null;
    return [
        function(loaded) {
            return throttled[0]({
                lengthComputable: lengthComputable,
                total: total,
                loaded: loaded
            });
        },
        throttled[1]
    ];
};
var $b0e463ffe46d623a$export$5d35863c355a22a9 = function(fn) {
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return (0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).asap(function() {
            return fn.apply(void 0, (0, $9b2c00b55773b429$export$71511d61b312f219)(args));
        });
    };
};






var $9fba31ebc8758cef$export$2e2bcd8739ae039 = (0, $b8e26be6780b0fac$export$2e2bcd8739ae039).hasStandardBrowserEnv ? function(origin, isMSIE) {
    return function(url) {
        url = new URL(url, (0, $b8e26be6780b0fac$export$2e2bcd8739ae039).origin);
        return origin.protocol === url.protocol && origin.host === url.host && (isMSIE || origin.port === url.port);
    };
}(new URL((0, $b8e26be6780b0fac$export$2e2bcd8739ae039).origin), (0, $b8e26be6780b0fac$export$2e2bcd8739ae039).navigator && /(msie|trident)/i.test((0, $b8e26be6780b0fac$export$2e2bcd8739ae039).navigator.userAgent)) : function() {
    return true;
};




var $c325bfe5f8724d7d$export$2e2bcd8739ae039 = (0, $b8e26be6780b0fac$export$2e2bcd8739ae039).hasStandardBrowserEnv ? {
    write: function(name, value, expires, path, domain, secure, sameSite) {
        if (typeof document === 'undefined') return;
        var cookie = [
            "".concat(name, "=").concat(encodeURIComponent(value))
        ];
        if ((0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).isNumber(expires)) cookie.push("expires=".concat(new Date(expires).toUTCString()));
        if ((0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).isString(path)) cookie.push("path=".concat(path));
        if ((0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).isString(domain)) cookie.push("domain=".concat(domain));
        if (secure === true) cookie.push('secure');
        if ((0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).isString(sameSite)) cookie.push("SameSite=".concat(sameSite));
        document.cookie = cookie.join('; ');
    },
    read: function(name) {
        if (typeof document === 'undefined') return null;
        // Match name=value by splitting on the semicolon separator instead of building a
        // RegExp from `name` — interpolating an unescaped string into a RegExp would let
        // metacharacters (e.g. `.+?` in an attacker-influenced cookie name) cause ReDoS or
        // match the wrong cookie. Browsers may serialize cookie pairs as either ";" or
        // "; ", so ignore optional whitespace before each cookie name.
        var cookies = document.cookie.split(';');
        for(var i = 0; i < cookies.length; i++){
            var cookie = cookies[i].replace(/^\s+/, '');
            var eq = cookie.indexOf('=');
            if (eq !== -1 && cookie.slice(0, eq) === name) return decodeURIComponent(cookie.slice(eq + 1));
        }
        return null;
    },
    remove: function(name) {
        this.write(name, '', Date.now() - 86400000, '/');
    }
} : {
    write: function() {},
    read: function() {
        return null;
    },
    remove: function() {}
};


'use strict';
function $fc84bf53a437e5aa$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    if (typeof url !== 'string') return false;
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}


'use strict';
function $6bec9f077e590c1a$export$2e2bcd8739ae039(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/?\/$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
}


'use strict';
function $e4de6ed9cce1530d$export$2e2bcd8739ae039(baseURL, requestedURL, allowAbsoluteUrls) {
    var isRelativeUrl = !(0, $fc84bf53a437e5aa$export$2e2bcd8739ae039)(requestedURL);
    if (baseURL && (isRelativeUrl || allowAbsoluteUrls === false)) return (0, $6bec9f077e590c1a$export$2e2bcd8739ae039)(baseURL, requestedURL);
    return requestedURL;
}





'use strict';
var $807c7b5a8b6039d6$var$headersToObject = function(thing) {
    return thing instanceof (0, $027c52967d4f7f5c$export$2e2bcd8739ae039) ? (0, $a1640dbfa76e87bd$export$71511d61b312f219)({}, thing) : thing;
};
function $807c7b5a8b6039d6$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    // Use a null-prototype object so that downstream reads such as `config.auth`
    // or `config.baseURL` cannot inherit polluted values from Object.prototype.
    // `hasOwnProperty` is restored as a non-enumerable own slot to preserve
    // ergonomics for user code that relies on it.
    var config = Object.create(null);
    Object.defineProperty(config, 'hasOwnProperty', {
        // Null-proto descriptor so a polluted Object.prototype.get cannot turn
        // this data descriptor into an accessor descriptor on the way in.
        __proto__: null,
        value: Object.prototype.hasOwnProperty,
        enumerable: false,
        writable: true,
        configurable: true
    });
    function getMergedValue(target, source, prop, caseless) {
        if ((0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).isPlainObject(target) && (0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).merge({}, source);
        else if ((0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).isArray(source)) return source.slice();
        return source;
    }
    function mergeDeepProperties(a, b, prop, caseless) {
        if (!(0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(a, b, prop, caseless);
        else if (!(0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a, prop, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if ((0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).hasOwnProp(config2, prop)) return getMergedValue(a, b);
        else if ((0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).hasOwnProp(config1, prop)) return getMergedValue(undefined, a);
    }
    var mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        allowedSocketPaths: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: function(a, b, prop) {
            return mergeDeepProperties($807c7b5a8b6039d6$var$headersToObject(a), $807c7b5a8b6039d6$var$headersToObject(b), prop, true);
        }
    };
    (0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).forEach(Object.keys((0, $a1640dbfa76e87bd$export$71511d61b312f219)({}, config1, config2)), function computeConfigValue(prop) {
        if (prop === '__proto__' || prop === 'constructor' || prop === 'prototype') return;
        var merge = (0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).hasOwnProp(mergeMap, prop) ? mergeMap[prop] : mergeDeepProperties;
        var a = (0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).hasOwnProp(config1, prop) ? config1[prop] : undefined;
        var b = (0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).hasOwnProp(config2, prop) ? config2[prop] : undefined;
        var configValue = merge(a, b, prop);
        (0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
}




var $8909923d94361284$var$FORM_DATA_CONTENT_HEADERS = [
    'content-type',
    'content-length'
];
function $8909923d94361284$var$setFormDataHeaders(headers, formHeaders, policy) {
    if (policy !== 'content-only') {
        headers.set(formHeaders);
        return;
    }
    Object.entries(formHeaders).forEach(function(param) {
        var _param = (0, $c940fad574a3594c$export$71511d61b312f219)(param, 2), key = _param[0], val = _param[1];
        if ($8909923d94361284$var$FORM_DATA_CONTENT_HEADERS.includes(key.toLowerCase())) headers.set(key, val);
    });
}
/**
 * Encode a UTF-8 string to a Latin-1 byte string for use with btoa().
 * This is a modern replacement for the deprecated unescape(encodeURIComponent(str)) pattern.
 *
 * @param {string} str The string to encode
 *
 * @returns {string} UTF-8 bytes as a Latin-1 string
 */ var $8909923d94361284$var$encodeUTF8 = function(str) {
    return encodeURIComponent(str).replace(/%([0-9A-F]{2})/gi, function(_, hex) {
        return String.fromCharCode(parseInt(hex, 16));
    });
};
var $8909923d94361284$export$2e2bcd8739ae039 = function(config) {
    var newConfig = (0, $807c7b5a8b6039d6$export$2e2bcd8739ae039)({}, config);
    // Read only own properties to prevent prototype pollution gadgets
    // (e.g. Object.prototype.baseURL = 'https://evil.com').
    var own = function(key) {
        return (0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).hasOwnProp(newConfig, key) ? newConfig[key] : undefined;
    };
    var data = own('data');
    var withXSRFToken = own('withXSRFToken');
    var xsrfHeaderName = own('xsrfHeaderName');
    var xsrfCookieName = own('xsrfCookieName');
    var headers = own('headers');
    var auth = own('auth');
    var baseURL = own('baseURL');
    var allowAbsoluteUrls = own('allowAbsoluteUrls');
    var url = own('url');
    newConfig.headers = headers = (0, $027c52967d4f7f5c$export$2e2bcd8739ae039).from(headers);
    newConfig.url = (0, $99de190d72ac4f4a$export$2e2bcd8739ae039)((0, $e4de6ed9cce1530d$export$2e2bcd8739ae039)(baseURL, url, allowAbsoluteUrls), config.params, config.paramsSerializer);
    // HTTP basic authentication
    if (auth) headers.set('Authorization', 'Basic ' + btoa((auth.username || '') + ':' + (auth.password ? $8909923d94361284$var$encodeUTF8(auth.password) : '')));
    if ((0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).isFormData(data)) {
        if ((0, $b8e26be6780b0fac$export$2e2bcd8739ae039).hasStandardBrowserEnv || (0, $b8e26be6780b0fac$export$2e2bcd8739ae039).hasStandardBrowserWebWorkerEnv) headers.setContentType(undefined); // browser handles it
        else if ((0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).isFunction(data.getHeaders)) // Node.js FormData (like form-data package)
        $8909923d94361284$var$setFormDataHeaders(headers, data.getHeaders(), own('formDataHeaderPolicy'));
    }
    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if ((0, $b8e26be6780b0fac$export$2e2bcd8739ae039).hasStandardBrowserEnv) {
        if ((0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).isFunction(withXSRFToken)) withXSRFToken = withXSRFToken(newConfig);
        // Strict boolean check — prevents proto-pollution gadgets (e.g. Object.prototype.withXSRFToken = 1)
        // and misconfigurations (e.g. "false") from short-circuiting the same-origin check and leaking
        // the XSRF token cross-origin.
        var shouldSendXSRF = withXSRFToken === true || withXSRFToken == null && (0, $9fba31ebc8758cef$export$2e2bcd8739ae039)(newConfig.url);
        if (shouldSendXSRF) {
            var xsrfValue = xsrfHeaderName && xsrfCookieName && (0, $c325bfe5f8724d7d$export$2e2bcd8739ae039).read(xsrfCookieName);
            if (xsrfValue) headers.set(xsrfHeaderName, xsrfValue);
        }
    }
    return newConfig;
};



var $cf6cc3f5cc27a7c0$var$isXHRAdapterSupported = typeof XMLHttpRequest !== 'undefined';
var $cf6cc3f5cc27a7c0$export$2e2bcd8739ae039 = $cf6cc3f5cc27a7c0$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        var _config = (0, $8909923d94361284$export$2e2bcd8739ae039)(config);
        var requestData = _config.data;
        var requestHeaders = (0, $027c52967d4f7f5c$export$2e2bcd8739ae039).from(_config.headers).normalize();
        var responseType = _config.responseType, onUploadProgress = _config.onUploadProgress, onDownloadProgress = _config.onDownloadProgress;
        var onCanceled;
        var uploadThrottled, downloadThrottled;
        var flushUpload, flushDownload;
        function done() {
            flushUpload && flushUpload(); // flush events
            flushDownload && flushDownload(); // flush events
            _config.cancelToken && _config.cancelToken.unsubscribe(onCanceled);
            _config.signal && _config.signal.removeEventListener('abort', onCanceled);
        }
        var request = new XMLHttpRequest();
        request.open(_config.method.toUpperCase(), _config.url, true);
        // Set the request timeout in MS
        request.timeout = _config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            var responseHeaders = (0, $027c52967d4f7f5c$export$2e2bcd8739ae039).from('getAllResponseHeaders' in request && request.getAllResponseHeaders());
            var responseData = !responseType || responseType === 'text' || responseType === 'json' ? request.responseText : request.response;
            var response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $fa6ddd8972b1eef7$export$2e2bcd8739ae039)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ('onloadend' in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.startsWith('file:'))) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $781d5d445dc0d633$export$2e2bcd8739ae039)('Request aborted', (0, $781d5d445dc0d633$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            done();
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError(event) {
            // Browsers deliver a ProgressEvent in XHR onerror
            // (message may be empty; when present, surface it)
            // See https://developer.mozilla.org/docs/Web/API/XMLHttpRequest/error_event
            var msg = event && event.message ? event.message : 'Network Error';
            var err = new (0, $781d5d445dc0d633$export$2e2bcd8739ae039)(msg, (0, $781d5d445dc0d633$export$2e2bcd8739ae039).ERR_NETWORK, config, request);
            // attach the underlying event for consumers who want details
            err.event = event || null;
            reject(err);
            done();
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            var timeoutErrorMessage = _config.timeout ? 'timeout of ' + _config.timeout + 'ms exceeded' : 'timeout exceeded';
            var transitional = _config.transitional || (0, $4f1fbd47c7daaec2$export$2e2bcd8739ae039);
            if (_config.timeoutErrorMessage) timeoutErrorMessage = _config.timeoutErrorMessage;
            reject(new (0, $781d5d445dc0d633$export$2e2bcd8739ae039)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $781d5d445dc0d633$export$2e2bcd8739ae039).ETIMEDOUT : (0, $781d5d445dc0d633$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            done();
            // Clean up request
            request = null;
        };
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ('setRequestHeader' in request) (0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).forEach((0, $11e5b93840d3f7d6$export$c30c72bb7e677d54)(requestHeaders), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).isUndefined(_config.withCredentials)) request.withCredentials = !!_config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== 'json') request.responseType = _config.responseType;
        // Handle progress if needed
        if (onDownloadProgress) {
            var ref;
            ref = (0, $c940fad574a3594c$export$71511d61b312f219)((0, $b0e463ffe46d623a$export$c1b28109d46c3592)(onDownloadProgress, true), 2), downloadThrottled = ref[0], flushDownload = ref[1], ref;
            request.addEventListener('progress', downloadThrottled);
        }
        // Not all browsers support upload events
        if (onUploadProgress && request.upload) {
            var ref1;
            ref1 = (0, $c940fad574a3594c$export$71511d61b312f219)((0, $b0e463ffe46d623a$export$c1b28109d46c3592)(onUploadProgress), 2), uploadThrottled = ref1[0], flushUpload = ref1[1], ref1;
            request.upload.addEventListener('progress', uploadThrottled);
            request.upload.addEventListener('loadend', flushUpload);
        }
        if (_config.cancelToken || _config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = function(cancel) {
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $deb8b523360309d3$export$2e2bcd8739ae039)(null, config, request) : cancel);
                request.abort();
                done();
                request = null;
            };
            _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
            if (_config.signal) _config.signal.aborted ? onCanceled() : _config.signal.addEventListener('abort', onCanceled);
        }
        var protocol = (0, $58ae0ab5a1b8cc6b$export$2e2bcd8739ae039)(_config.url);
        if (protocol && !(0, $b8e26be6780b0fac$export$2e2bcd8739ae039).protocols.includes(protocol)) {
            reject(new (0, $781d5d445dc0d633$export$2e2bcd8739ae039)('Unsupported protocol ' + protocol + ':', (0, $781d5d445dc0d633$export$2e2bcd8739ae039).ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};




function $85ace02a75c67cbd$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $85ace02a75c67cbd$export$71511d61b312f219(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $85ace02a75c67cbd$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}











var $9d47c640525c16e1$var$composeSignals = function(signals, timeout) {
    signals = signals ? signals.filter(Boolean) : [];
    if (!timeout && !signals.length) return;
    var controller = new AbortController();
    var aborted = false;
    var onabort = function onabort(reason) {
        if (!aborted) {
            aborted = true;
            unsubscribe();
            var err = reason instanceof Error ? reason : this.reason;
            controller.abort(err instanceof (0, $781d5d445dc0d633$export$2e2bcd8739ae039) ? err : new (0, $deb8b523360309d3$export$2e2bcd8739ae039)(err instanceof Error ? err.message : err));
        }
    };
    var timer = timeout && setTimeout(function() {
        timer = null;
        onabort(new (0, $781d5d445dc0d633$export$2e2bcd8739ae039)("timeout of ".concat(timeout, "ms exceeded"), (0, $781d5d445dc0d633$export$2e2bcd8739ae039).ETIMEDOUT));
    }, timeout);
    var unsubscribe = function() {
        if (!signals) return;
        timer && clearTimeout(timer);
        timer = null;
        signals.forEach(function(signal) {
            signal.unsubscribe ? signal.unsubscribe(onabort) : signal.removeEventListener('abort', onabort);
        });
        signals = null;
    };
    signals.forEach(function(signal) {
        return signal.addEventListener('abort', onabort);
    });
    var signal = controller.signal;
    signal.unsubscribe = function() {
        return (0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).asap(unsubscribe);
    };
    return signal;
};
var $9d47c640525c16e1$export$2e2bcd8739ae039 = $9d47c640525c16e1$var$composeSignals;


function $6c17871d78583142$export$71511d61b312f219(value, /** 0: await 1: delegate */ kind) {
    this.v = value;
    this.k = kind;
}


function $7a4b56929b35613f$export$71511d61b312f219(inner) {
    var iter = {}, waiting = false;
    function pump(key, value) {
        waiting = true;
        value = new Promise(function(resolve) {
            resolve(inner[key](value));
        });
        return {
            done: false,
            value: new (0, $6c17871d78583142$export$71511d61b312f219)(value, /* kind: delegate */ 1)
        };
    }
    iter[typeof Symbol !== "undefined" && Symbol.iterator || "@@iterator"] = function() {
        return this;
    };
    iter.next = function(value) {
        if (waiting) {
            waiting = false;
            return value;
        }
        return pump("next", value);
    };
    if (typeof inner.throw === "function") iter.throw = function(value) {
        if (waiting) {
            waiting = false;
            throw value;
        }
        return pump("throw", value);
    };
    if (typeof inner.return === "function") iter.return = function(value) {
        if (waiting) {
            waiting = false;
            return value;
        }
        return pump("return", value);
    };
    return iter;
}


function $ac9556977d47be16$export$71511d61b312f219(iterable) {
    var method, async, sync, retry = 2;
    for("undefined" != typeof Symbol && (async = Symbol.asyncIterator, sync = Symbol.iterator); retry--;){
        if (async && null != (method = iterable[async])) return method.call(iterable);
        if (sync && null != (method = iterable[sync])) return new $ac9556977d47be16$var$AsyncFromSyncIterator(method.call(iterable));
        async = "@@asyncIterator", sync = "@@iterator";
    }
    throw new TypeError("Object is not async iterable");
}
function $ac9556977d47be16$var$AsyncFromSyncIterator(s) {
    function AsyncFromSyncIteratorContinuation(r) {
        if (Object(r) !== r) return Promise.reject(new TypeError(r + " is not an object."));
        var done = r.done;
        return Promise.resolve(r.value).then(function(value) {
            return {
                value: value,
                done: done
            };
        });
    }
    return $ac9556977d47be16$var$AsyncFromSyncIterator = function(s) {
        this.s = s, this.n = s.next;
    }, $ac9556977d47be16$var$AsyncFromSyncIterator.prototype = {
        s: null,
        n: null,
        next: function() {
            return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments));
        },
        return: function(value) {
            var ret = this.s.return;
            return void 0 === ret ? Promise.resolve({
                value: value,
                done: !0
            }) : AsyncFromSyncIteratorContinuation(ret.apply(this.s, arguments));
        },
        throw: function(value) {
            var thr = this.s.return;
            return void 0 === thr ? Promise.reject(value) : AsyncFromSyncIteratorContinuation(thr.apply(this.s, arguments));
        }
    }, new $ac9556977d47be16$var$AsyncFromSyncIterator(s);
}




function $9ddf1f92d2837134$export$71511d61b312f219(value) {
    return new (0, $6c17871d78583142$export$71511d61b312f219)(value, /* kind: await */ 0);
}



function $f21ec990d9a3c04e$export$71511d61b312f219(gen) {
    var front, back;
    function send(key, arg) {
        return new Promise(function(resolve, reject) {
            var request = {
                key: key,
                arg: arg,
                resolve: resolve,
                reject: reject,
                next: null
            };
            if (back) back = back.next = request;
            else {
                front = back = request;
                resume(key, arg);
            }
        });
    }
    function resume(key, arg) {
        try {
            var result = gen[key](arg);
            var value = result.value;
            var overloaded = value instanceof (0, $6c17871d78583142$export$71511d61b312f219);
            Promise.resolve(overloaded ? value.v : value).then(function(arg) {
                if (overloaded) {
                    var nextKey = key === "return" ? "return" : "next";
                    if (!value.k || arg.done) return resume(nextKey, arg);
                    else arg = gen[nextKey](arg).value;
                }
                settle(result.done ? "return" : "normal", arg);
            }, function(err) {
                resume("throw", err);
            });
        } catch (err) {
            settle("throw", err);
        }
    }
    function settle(type, value) {
        switch(type){
            case "return":
                front.resolve({
                    value: value,
                    done: true
                });
                break;
            case "throw":
                front.reject(value);
                break;
            default:
                front.resolve({
                    value: value,
                    done: false
                });
                break;
        }
        front = front.next;
        if (front) resume(front.key, front.arg);
        else back = null;
    }
    this._invoke = send;
    if (typeof gen.return !== "function") this.return = undefined;
}
$f21ec990d9a3c04e$export$71511d61b312f219.prototype[typeof Symbol === "function" && Symbol.asyncIterator || "@@asyncIterator"] = function() {
    return this;
};
$f21ec990d9a3c04e$export$71511d61b312f219.prototype.next = function(arg) {
    return this._invoke("next", arg);
};
$f21ec990d9a3c04e$export$71511d61b312f219.prototype.throw = function(arg) {
    return this._invoke("throw", arg);
};
$f21ec990d9a3c04e$export$71511d61b312f219.prototype.return = function(arg) {
    return this._invoke("return", arg);
};


function $b5b23e39536c9967$export$71511d61b312f219(fn) {
    return function() {
        return new (0, $f21ec990d9a3c04e$export$71511d61b312f219)(fn.apply(this, arguments));
    };
}



/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ 
var $334981cc2ac82e75$var$extendStatics = function extendStatics1(d, b) {
    $334981cc2ac82e75$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $334981cc2ac82e75$var$extendStatics(d, b);
};
function $334981cc2ac82e75$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $334981cc2ac82e75$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $334981cc2ac82e75$export$18ce0697a983be9b = function __assign1() {
    $334981cc2ac82e75$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $334981cc2ac82e75$export$18ce0697a983be9b.apply(this, arguments);
};
function $334981cc2ac82e75$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $334981cc2ac82e75$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if ((typeof Reflect === "undefined" ? "undefined" : (0, $15ae7fd16c0fe95b$export$71511d61b312f219)(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $334981cc2ac82e75$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $334981cc2ac82e75$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || (typeof result === "undefined" ? "undefined" : (0, $15ae7fd16c0fe95b$export$71511d61b312f219)(result)) !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $334981cc2ac82e75$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $334981cc2ac82e75$export$6a2a36740a146cb8(x) {
    return (typeof x === "undefined" ? "undefined" : (0, $15ae7fd16c0fe95b$export$71511d61b312f219)(x)) === "symbol" ? x : "".concat(x);
}
function $334981cc2ac82e75$export$d1a06452d3489bc7(f, name, prefix) {
    if ((typeof name === "undefined" ? "undefined" : (0, $15ae7fd16c0fe95b$export$71511d61b312f219)(name)) === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $334981cc2ac82e75$export$f1db080c865becb9(metadataKey, metadataValue) {
    if ((typeof Reflect === "undefined" ? "undefined" : (0, $15ae7fd16c0fe95b$export$71511d61b312f219)(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $334981cc2ac82e75$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $334981cc2ac82e75$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $334981cc2ac82e75$export$45d3717a4c69092e = Object.create ? function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $334981cc2ac82e75$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $334981cc2ac82e75$export$45d3717a4c69092e(o, m, p);
}
function $334981cc2ac82e75$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $334981cc2ac82e75$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $334981cc2ac82e75$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($334981cc2ac82e75$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $334981cc2ac82e75$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $334981cc2ac82e75$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $334981cc2ac82e75$export$10c90e4f7922046c(v) {
    return this instanceof $334981cc2ac82e75$export$10c90e4f7922046c ? (this.v = v, this) : new $334981cc2ac82e75$export$10c90e4f7922046c(v);
}
function $334981cc2ac82e75$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $334981cc2ac82e75$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $334981cc2ac82e75$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $334981cc2ac82e75$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $334981cc2ac82e75$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $334981cc2ac82e75$export$19a8beecd37a4c45 === "function" ? $334981cc2ac82e75$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $334981cc2ac82e75$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $334981cc2ac82e75$var$__setModuleDefault = Object.create ? function __setModuleDefault(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $334981cc2ac82e75$var$ownKeys = function ownKeys1(o) {
    $334981cc2ac82e75$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $334981cc2ac82e75$var$ownKeys(o);
};
function $334981cc2ac82e75$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $334981cc2ac82e75$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $334981cc2ac82e75$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $334981cc2ac82e75$var$__setModuleDefault(result, mod);
    return result;
}
function $334981cc2ac82e75$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
}
function $334981cc2ac82e75$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $334981cc2ac82e75$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $334981cc2ac82e75$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || (typeof receiver === "undefined" ? "undefined" : (0, $15ae7fd16c0fe95b$export$71511d61b312f219)(receiver)) !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $334981cc2ac82e75$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if ((typeof value === "undefined" ? "undefined" : (0, $15ae7fd16c0fe95b$export$71511d61b312f219)(value)) !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function dispose() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $334981cc2ac82e75$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function _SuppressedError(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $334981cc2ac82e75$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $334981cc2ac82e75$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $334981cc2ac82e75$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $334981cc2ac82e75$export$2e2bcd8739ae039 = {
    __extends: $334981cc2ac82e75$export$a8ba968b8961cb8a,
    __assign: $334981cc2ac82e75$export$18ce0697a983be9b,
    __rest: $334981cc2ac82e75$export$3c9a16f847548506,
    __decorate: $334981cc2ac82e75$export$29e00dfd3077644b,
    __param: $334981cc2ac82e75$export$d5ad3fd78186038f,
    __esDecorate: $334981cc2ac82e75$export$3a84e1ae4e97e9b0,
    __runInitializers: $334981cc2ac82e75$export$d831c04e792af3d,
    __propKey: $334981cc2ac82e75$export$6a2a36740a146cb8,
    __setFunctionName: $334981cc2ac82e75$export$d1a06452d3489bc7,
    __metadata: $334981cc2ac82e75$export$f1db080c865becb9,
    __awaiter: $334981cc2ac82e75$export$1050f835b63b671e,
    __generator: $334981cc2ac82e75$export$67ebef60e6f28a6,
    __createBinding: $334981cc2ac82e75$export$45d3717a4c69092e,
    __exportStar: $334981cc2ac82e75$export$f33643c0debef087,
    __values: $334981cc2ac82e75$export$19a8beecd37a4c45,
    __read: $334981cc2ac82e75$export$8d051b38c9118094,
    __spread: $334981cc2ac82e75$export$afc72e2116322959,
    __spreadArrays: $334981cc2ac82e75$export$6388937ca91ccae8,
    __spreadArray: $334981cc2ac82e75$export$1216008129fb82ed,
    __await: $334981cc2ac82e75$export$10c90e4f7922046c,
    __asyncGenerator: $334981cc2ac82e75$export$e427f37a30a4de9b,
    __asyncDelegator: $334981cc2ac82e75$export$bbd80228419bb833,
    __asyncValues: $334981cc2ac82e75$export$e3b29a3d6162315f,
    __makeTemplateObject: $334981cc2ac82e75$export$4fb47efe1390b86f,
    __importStar: $334981cc2ac82e75$export$c21735bcef00d192,
    __importDefault: $334981cc2ac82e75$export$da59b14a69baef04,
    __classPrivateFieldGet: $334981cc2ac82e75$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $334981cc2ac82e75$export$d40a35129aaff81f,
    __classPrivateFieldIn: $334981cc2ac82e75$export$81fdc39f203e4e04,
    __addDisposableResource: $334981cc2ac82e75$export$88ac25d8e944e405,
    __disposeResources: $334981cc2ac82e75$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $334981cc2ac82e75$export$889dfb5d17574b0b
};


var $9d34a67db7b84a1e$export$71b051935044bd5d = function streamChunk(chunk, chunkSize) {
    var len, pos, end;
    return (0, $ca8679453dfc275b$export$71511d61b312f219)(this, function(_state) {
        switch(_state.label){
            case 0:
                len = chunk.byteLength;
                if (!(!chunkSize || len < chunkSize)) return [
                    3,
                    2
                ];
                return [
                    4,
                    chunk
                ];
            case 1:
                _state.sent();
                return [
                    2
                ];
            case 2:
                pos = 0;
                _state.label = 3;
            case 3:
                if (!(pos < len)) return [
                    3,
                    5
                ];
                end = pos + chunkSize;
                return [
                    4,
                    chunk.slice(pos, end)
                ];
            case 4:
                _state.sent();
                pos = end;
                return [
                    3,
                    3
                ];
            case 5:
                return [
                    2
                ];
        }
    });
};
var $9d34a67db7b84a1e$export$f9f241124ee3198e = function readBytes(iterable, chunkSize) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b5b23e39536c9967$export$71511d61b312f219)(function() {
        var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, chunk, err;
        return (0, $ca8679453dfc275b$export$71511d61b312f219)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        7,
                        8,
                        13
                    ]);
                    _iterator = (0, $ac9556977d47be16$export$71511d61b312f219)($9d34a67db7b84a1e$var$readStream(iterable));
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        (0, $9ddf1f92d2837134$export$71511d61b312f219)(_iterator.next())
                    ];
                case 3:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        6
                    ];
                    _value = _step.value;
                    chunk = _value;
                    return [
                        5,
                        (0, $334981cc2ac82e75$export$19a8beecd37a4c45)((0, $7a4b56929b35613f$export$71511d61b312f219)((0, $ac9556977d47be16$export$71511d61b312f219)($9d34a67db7b84a1e$export$71b051935044bd5d(chunk, chunkSize))))
                    ];
                case 4:
                    _state.sent();
                    _state.label = 5;
                case 5:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        2
                    ];
                case 6:
                    return [
                        3,
                        13
                    ];
                case 7:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        13
                    ];
                case 8:
                    _state.trys.push([
                        8,
                        ,
                        11,
                        12
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        10
                    ];
                    return [
                        4,
                        (0, $9ddf1f92d2837134$export$71511d61b312f219)(_iterator["return"]())
                    ];
                case 9:
                    _state.sent();
                    _state.label = 10;
                case 10:
                    return [
                        3,
                        12
                    ];
                case 11:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 12:
                    return [
                        7
                    ];
                case 13:
                    return [
                        2
                    ];
            }
        });
    })();
};
var $9d34a67db7b84a1e$var$readStream = function readStream(stream) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b5b23e39536c9967$export$71511d61b312f219)(function() {
        var reader, _ref, done, value;
        return (0, $ca8679453dfc275b$export$71511d61b312f219)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!stream[Symbol.asyncIterator]) return [
                        3,
                        2
                    ];
                    return [
                        5,
                        (0, $334981cc2ac82e75$export$19a8beecd37a4c45)((0, $7a4b56929b35613f$export$71511d61b312f219)((0, $ac9556977d47be16$export$71511d61b312f219)(stream)))
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
                case 2:
                    reader = stream.getReader();
                    _state.label = 3;
                case 3:
                    _state.trys.push([
                        3,
                        ,
                        9,
                        11
                    ]);
                    _state.label = 4;
                case 4:
                    return [
                        4,
                        (0, $9ddf1f92d2837134$export$71511d61b312f219)(reader.read())
                    ];
                case 5:
                    _ref = _state.sent(), done = _ref.done, value = _ref.value;
                    if (done) return [
                        3,
                        8
                    ];
                    return [
                        4,
                        value
                    ];
                case 6:
                    _state.sent();
                    _state.label = 7;
                case 7:
                    return [
                        3,
                        4
                    ];
                case 8:
                    return [
                        3,
                        11
                    ];
                case 9:
                    return [
                        4,
                        (0, $9ddf1f92d2837134$export$71511d61b312f219)(reader.cancel())
                    ];
                case 10:
                    _state.sent();
                    return [
                        7
                    ];
                case 11:
                    return [
                        2
                    ];
            }
        });
    })();
};
var $9d34a67db7b84a1e$export$b0119225647bd83 = function(stream, chunkSize, onProgress, onFinish) {
    var iterator = $9d34a67db7b84a1e$export$f9f241124ee3198e(stream, chunkSize);
    var bytes = 0;
    var done;
    var _onFinish = function(e) {
        if (!done) {
            done = true;
            onFinish && onFinish(e);
        }
    };
    return new ReadableStream({
        pull: function(controller) {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $03857362ebfa6f2c$export$71511d61b312f219)(function() {
                var _ref, done, value, len, loadedBytes, err;
                return (0, $ca8679453dfc275b$export$71511d61b312f219)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4,
                                iterator.next()
                            ];
                        case 1:
                            _ref = _state.sent(), done = _ref.done, value = _ref.value;
                            if (done) {
                                _onFinish();
                                controller.close();
                                return [
                                    2
                                ];
                            }
                            len = value.byteLength;
                            if (onProgress) {
                                loadedBytes = bytes += len;
                                onProgress(loadedBytes);
                            }
                            controller.enqueue(new Uint8Array(value));
                            return [
                                3,
                                3
                            ];
                        case 2:
                            err = _state.sent();
                            _onFinish(err);
                            throw err;
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            })();
        },
        cancel: function(reason) {
            _onFinish(reason);
            return iterator["return"]();
        }
    }, {
        highWaterMark: 2
    });
};






/**
 * Estimate decoded byte length of a data:// URL *without* allocating large buffers.
 * - For base64: compute exact decoded size using length and padding;
 *               handle %XX at the character-count level (no string allocation).
 * - For non-base64: use UTF-8 byteLength of the encoded body as a safe upper bound.
 *
 * @param {string} url
 * @returns {number}
 */ 
var $3a6c6508c69b6671$require$Buffer = $812cf9b5c5174ce8$export$a143d493d941bafc;
function $3a6c6508c69b6671$export$2e2bcd8739ae039(url) {
    if (!url || typeof url !== 'string') return 0;
    if (!url.startsWith('data:')) return 0;
    var comma = url.indexOf(',');
    if (comma < 0) return 0;
    var meta = url.slice(5, comma);
    var body = url.slice(comma + 1);
    var isBase64 = /;base64/i.test(meta);
    if (isBase64) {
        var effectiveLen = body.length;
        var len = body.length; // cache length
        for(var i = 0; i < len; i++)if (body.charCodeAt(i) === 37 /* '%' */  && i + 2 < len) {
            var a = body.charCodeAt(i + 1);
            var b = body.charCodeAt(i + 2);
            var isHex = (a >= 48 && a <= 57 || a >= 65 && a <= 70 || a >= 97 && a <= 102) && (b >= 48 && b <= 57 || b >= 65 && b <= 70 || b >= 97 && b <= 102);
            if (isHex) {
                effectiveLen -= 2;
                i += 2;
            }
        }
        var pad = 0;
        var idx = len - 1;
        var tailIsPct3D = function(j) {
            return j >= 2 && body.charCodeAt(j - 2) === 37 && // '%'
            body.charCodeAt(j - 1) === 51 && // '3'
            (body.charCodeAt(j) === 68 || body.charCodeAt(j) === 100);
        }; // 'D' or 'd'
        if (idx >= 0) {
            if (body.charCodeAt(idx) === 61 /* '=' */ ) {
                pad++;
                idx--;
            } else if (tailIsPct3D(idx)) {
                pad++;
                idx -= 3;
            }
        }
        if (pad === 1 && idx >= 0) {
            if (body.charCodeAt(idx) === 61 /* '=' */ ) pad++;
            else if (tailIsPct3D(idx)) pad++;
        }
        var groups = Math.floor(effectiveLen / 4);
        var bytes = groups * 3 - (pad || 0);
        return bytes > 0 ? bytes : 0;
    }
    if (typeof $3a6c6508c69b6671$require$Buffer !== 'undefined' && typeof $3a6c6508c69b6671$require$Buffer.byteLength === 'function') return $3a6c6508c69b6671$require$Buffer.byteLength(body, 'utf8');
    // Compute UTF-8 byte length directly from UTF-16 code units without allocating
    // a byte buffer (TextEncoder.encode would defeat the DoS guard on large bodies).
    // Using body.length here would undercount non-ASCII (e.g. '€' is 1 code unit
    // but 3 UTF-8 bytes).
    var bytes1 = 0;
    for(var i1 = 0, len1 = body.length; i1 < len1; i1++){
        var c = body.charCodeAt(i1);
        if (c < 0x80) bytes1 += 1;
        else if (c < 0x800) bytes1 += 2;
        else if (c >= 0xd800 && c <= 0xdbff && i1 + 1 < len1) {
            var next = body.charCodeAt(i1 + 1);
            if (next >= 0xdc00 && next <= 0xdfff) {
                bytes1 += 4;
                i1++;
            } else bytes1 += 3;
        } else bytes1 += 3;
    }
    return bytes1;
}


var $5fb60c46abcc7e9c$export$a4ad2735b021c132 = "1.16.1";



var $52de8754cf4d01ba$var$DEFAULT_CHUNK_SIZE = 65536;
var $52de8754cf4d01ba$var$isFunction = (0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).isFunction;
var $52de8754cf4d01ba$var$test = function(fn) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    try {
        return !!fn.apply(void 0, (0, $9b2c00b55773b429$export$71511d61b312f219)(args));
    } catch (e) {
        return false;
    }
};
var $52de8754cf4d01ba$var$factory = function(env) {
    var globalObject = (0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).global !== undefined && (0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).global !== null ? (0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).global : globalThis;
    var ReadableStream = globalObject.ReadableStream, TextEncoder = globalObject.TextEncoder;
    env = (0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).merge.call({
        skipUndefined: true
    }, {
        Request: globalObject.Request,
        Response: globalObject.Response
    }, env);
    var envFetch = env.fetch, Request = env.Request, Response = env.Response;
    var isFetchSupported = envFetch ? $52de8754cf4d01ba$var$isFunction(envFetch) : typeof fetch === 'function';
    var isRequestSupported = $52de8754cf4d01ba$var$isFunction(Request);
    var isResponseSupported = $52de8754cf4d01ba$var$isFunction(Response);
    if (!isFetchSupported) return false;
    var isReadableStreamSupported = isFetchSupported && $52de8754cf4d01ba$var$isFunction(ReadableStream);
    var encodeText = isFetchSupported && (typeof TextEncoder === 'function' ? function(encoder) {
        return function(str) {
            return encoder.encode(str);
        };
    }(new TextEncoder()) : function(str) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $03857362ebfa6f2c$export$71511d61b312f219)(function() {
            var _;
            return (0, $ca8679453dfc275b$export$71511d61b312f219)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _ = Uint8Array.bind;
                        return [
                            4,
                            new Request(str).arrayBuffer()
                        ];
                    case 1:
                        return [
                            2,
                            new (_.apply(Uint8Array, [
                                void 0,
                                _state.sent()
                            ]))
                        ];
                }
            });
        })();
    });
    var supportsRequestStream = isRequestSupported && isReadableStreamSupported && $52de8754cf4d01ba$var$test(function() {
        var duplexAccessed = false;
        var request = new Request((0, $b8e26be6780b0fac$export$2e2bcd8739ae039).origin, {
            body: new ReadableStream(),
            method: 'POST',
            get duplex () {
                duplexAccessed = true;
                return 'half';
            }
        });
        var hasContentType = request.headers.has('Content-Type');
        if (request.body != null) request.body.cancel();
        return duplexAccessed && !hasContentType;
    });
    var supportsResponseStream = isResponseSupported && isReadableStreamSupported && $52de8754cf4d01ba$var$test(function() {
        return (0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).isReadableStream(new Response('').body);
    });
    var resolvers = {
        stream: supportsResponseStream && function(res) {
            return res.body;
        }
    };
    isFetchSupported && function() {
        [
            'text',
            'arrayBuffer',
            'blob',
            'formData',
            'stream'
        ].forEach(function(type) {
            !resolvers[type] && (resolvers[type] = function(res, config) {
                var method = res && res[type];
                if (method) return method.call(res);
                throw new (0, $781d5d445dc0d633$export$2e2bcd8739ae039)("Response type '".concat(type, "' is not supported"), (0, $781d5d445dc0d633$export$2e2bcd8739ae039).ERR_NOT_SUPPORT, config);
            });
        });
    }();
    var getBodyLength = function(body) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $03857362ebfa6f2c$export$71511d61b312f219)(function() {
            var _request;
            return (0, $ca8679453dfc275b$export$71511d61b312f219)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (body == null) return [
                            2,
                            0
                        ];
                        if ((0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).isBlob(body)) return [
                            2,
                            body.size
                        ];
                        if (!(0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).isSpecCompliantForm(body)) return [
                            3,
                            2
                        ];
                        _request = new Request((0, $b8e26be6780b0fac$export$2e2bcd8739ae039).origin, {
                            method: 'POST',
                            body: body
                        });
                        return [
                            4,
                            _request.arrayBuffer()
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent().byteLength
                        ];
                    case 2:
                        if ((0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).isArrayBufferView(body) || (0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).isArrayBuffer(body)) return [
                            2,
                            body.byteLength
                        ];
                        if ((0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).isURLSearchParams(body)) body = body + '';
                        if (!(0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).isString(body)) return [
                            3,
                            4
                        ];
                        return [
                            4,
                            encodeText(body)
                        ];
                    case 3:
                        return [
                            2,
                            _state.sent().byteLength
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        })();
    };
    var resolveBodyLength = function(headers, body) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $03857362ebfa6f2c$export$71511d61b312f219)(function() {
            var length;
            return (0, $ca8679453dfc275b$export$71511d61b312f219)(this, function(_state) {
                length = (0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).toFiniteNumber(headers.getContentLength());
                return [
                    2,
                    length == null ? getBodyLength(body) : length
                ];
            });
        })();
    };
    return function(config) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $03857362ebfa6f2c$export$71511d61b312f219)(function() {
            var _resolveConfig, url, method, data, signal, cancelToken, timeout, onDownloadProgress, onUploadProgress, responseType, headers, _resolveConfig_withCredentials, withCredentials, fetchOptions, maxContentLength, maxBodyLength, hasMaxContentLength, hasMaxBodyLength, _fetch, composedSignal, request, unsubscribe, requestContentLength, estimated, outboundLength, _tmp, _request, contentTypeHeader, _progressEventDecorator, onProgress, flush, isCredentialsSupported, contentType, resolvedOptions, response, declaredLength, isStreamResponse, options, responseContentLength, _ref, onProgress1, flush1, bytesRead, onChunkProgress, responseData, materializedSize, err, canceledError;
            return (0, $ca8679453dfc275b$export$71511d61b312f219)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _resolveConfig = (0, $8909923d94361284$export$2e2bcd8739ae039)(config), url = _resolveConfig.url, method = _resolveConfig.method, data = _resolveConfig.data, signal = _resolveConfig.signal, cancelToken = _resolveConfig.cancelToken, timeout = _resolveConfig.timeout, onDownloadProgress = _resolveConfig.onDownloadProgress, onUploadProgress = _resolveConfig.onUploadProgress, responseType = _resolveConfig.responseType, headers = _resolveConfig.headers, _resolveConfig_withCredentials = _resolveConfig.withCredentials, withCredentials = _resolveConfig_withCredentials === void 0 ? 'same-origin' : _resolveConfig_withCredentials, fetchOptions = _resolveConfig.fetchOptions, maxContentLength = _resolveConfig.maxContentLength, maxBodyLength = _resolveConfig.maxBodyLength;
                        hasMaxContentLength = (0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).isNumber(maxContentLength) && maxContentLength > -1;
                        hasMaxBodyLength = (0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).isNumber(maxBodyLength) && maxBodyLength > -1;
                        _fetch = envFetch || fetch;
                        responseType = responseType ? (responseType + '').toLowerCase() : 'text';
                        composedSignal = (0, $9d47c640525c16e1$export$2e2bcd8739ae039)([
                            signal,
                            cancelToken && cancelToken.toAbortSignal()
                        ], timeout);
                        request = null;
                        unsubscribe = composedSignal && composedSignal.unsubscribe && function() {
                            composedSignal.unsubscribe();
                        };
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            9,
                            ,
                            10
                        ]);
                        // Enforce maxContentLength for data: URLs up-front so we never materialize
                        // an oversized payload. The HTTP adapter applies the same check (see http.js
                        // "if (protocol === 'data:')" branch).
                        if (hasMaxContentLength && typeof url === 'string' && url.startsWith('data:')) {
                            estimated = (0, $3a6c6508c69b6671$export$2e2bcd8739ae039)(url);
                            if (estimated > maxContentLength) throw new (0, $781d5d445dc0d633$export$2e2bcd8739ae039)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, $781d5d445dc0d633$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, config, request);
                        }
                        if (!(hasMaxBodyLength && method !== 'get' && method !== 'head')) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            resolveBodyLength(headers, data)
                        ];
                    case 2:
                        outboundLength = _state.sent();
                        if (typeof outboundLength === 'number' && isFinite(outboundLength) && outboundLength > maxBodyLength) throw new (0, $781d5d445dc0d633$export$2e2bcd8739ae039)('Request body larger than maxBodyLength limit', (0, $781d5d445dc0d633$export$2e2bcd8739ae039).ERR_BAD_REQUEST, config, request);
                        _state.label = 3;
                    case 3:
                        _tmp = onUploadProgress && supportsRequestStream && method !== 'get' && method !== 'head';
                        if (!_tmp) return [
                            3,
                            5
                        ];
                        return [
                            4,
                            resolveBodyLength(headers, data)
                        ];
                    case 4:
                        _tmp = (requestContentLength = _state.sent()) !== 0;
                        _state.label = 5;
                    case 5:
                        if (_tmp) {
                            _request = new Request(url, {
                                method: 'POST',
                                body: data,
                                duplex: 'half'
                            });
                            ;
                            if ((0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).isFormData(data) && (contentTypeHeader = _request.headers.get('content-type'))) headers.setContentType(contentTypeHeader);
                            if (_request.body) {
                                _progressEventDecorator = (0, $c940fad574a3594c$export$71511d61b312f219)((0, $b0e463ffe46d623a$export$d9fadd12586c18d6)(requestContentLength, (0, $b0e463ffe46d623a$export$c1b28109d46c3592)((0, $b0e463ffe46d623a$export$5d35863c355a22a9)(onUploadProgress))), 2), onProgress = _progressEventDecorator[0], flush = _progressEventDecorator[1];
                                data = (0, $9d34a67db7b84a1e$export$b0119225647bd83)(_request.body, $52de8754cf4d01ba$var$DEFAULT_CHUNK_SIZE, onProgress, flush);
                            }
                        }
                        if (!(0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).isString(withCredentials)) withCredentials = withCredentials ? 'include' : 'omit';
                        // Cloudflare Workers throws when credentials are defined
                        // see https://github.com/cloudflare/workerd/issues/902
                        isCredentialsSupported = isRequestSupported && 'credentials' in Request.prototype;
                        // If data is FormData and Content-Type is multipart/form-data without boundary,
                        // delete it so fetch can set it correctly with the boundary
                        if ((0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).isFormData(data)) {
                            contentType = headers.getContentType();
                            if (contentType && /^multipart\/form-data/i.test(contentType) && !/boundary=/i.test(contentType)) headers["delete"]('content-type');
                        }
                        // Set User-Agent header if not already set (fetch defaults to 'node' in Node.js)
                        headers.set('User-Agent', 'axios/' + (0, $5fb60c46abcc7e9c$export$a4ad2735b021c132), false);
                        resolvedOptions = (0, $85ace02a75c67cbd$export$71511d61b312f219)((0, $a1640dbfa76e87bd$export$71511d61b312f219)({}, fetchOptions), {
                            signal: composedSignal,
                            method: method.toUpperCase(),
                            headers: (0, $11e5b93840d3f7d6$export$c30c72bb7e677d54)(headers.normalize()),
                            body: data,
                            duplex: 'half',
                            credentials: isCredentialsSupported ? withCredentials : undefined
                        });
                        request = isRequestSupported && new Request(url, resolvedOptions);
                        return [
                            4,
                            isRequestSupported ? _fetch(request, fetchOptions) : _fetch(url, resolvedOptions)
                        ];
                    case 6:
                        response = _state.sent();
                        // Cheap pre-check: if the server honestly declares a content-length that
                        // already exceeds the cap, reject before we start streaming.
                        if (hasMaxContentLength) {
                            declaredLength = (0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).toFiniteNumber(response.headers.get('content-length'));
                            if (declaredLength != null && declaredLength > maxContentLength) throw new (0, $781d5d445dc0d633$export$2e2bcd8739ae039)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, $781d5d445dc0d633$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, config, request);
                        }
                        isStreamResponse = supportsResponseStream && (responseType === 'stream' || responseType === 'response');
                        if (supportsResponseStream && response.body && (onDownloadProgress || hasMaxContentLength || isStreamResponse && unsubscribe)) {
                            options = {};
                            [
                                'status',
                                'statusText',
                                'headers'
                            ].forEach(function(prop) {
                                options[prop] = response[prop];
                            });
                            responseContentLength = (0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).toFiniteNumber(response.headers.get('content-length'));
                            _ref = (0, $c940fad574a3594c$export$71511d61b312f219)(onDownloadProgress && (0, $b0e463ffe46d623a$export$d9fadd12586c18d6)(responseContentLength, (0, $b0e463ffe46d623a$export$c1b28109d46c3592)((0, $b0e463ffe46d623a$export$5d35863c355a22a9)(onDownloadProgress), true)) || [], 2), onProgress1 = _ref[0], flush1 = _ref[1];
                            bytesRead = 0;
                            onChunkProgress = function(loadedBytes) {
                                if (hasMaxContentLength) {
                                    bytesRead = loadedBytes;
                                    if (bytesRead > maxContentLength) throw new (0, $781d5d445dc0d633$export$2e2bcd8739ae039)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, $781d5d445dc0d633$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, config, request);
                                }
                                onProgress1 && onProgress1(loadedBytes);
                            };
                            response = new Response((0, $9d34a67db7b84a1e$export$b0119225647bd83)(response.body, $52de8754cf4d01ba$var$DEFAULT_CHUNK_SIZE, onChunkProgress, function() {
                                flush1 && flush1();
                                unsubscribe && unsubscribe();
                            }), options);
                        }
                        responseType = responseType || 'text';
                        return [
                            4,
                            resolvers[(0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).findKey(resolvers, responseType) || 'text'](response, config)
                        ];
                    case 7:
                        responseData = _state.sent();
                        // Fallback enforcement for environments without ReadableStream support
                        // (legacy runtimes). Detect materialized size from typed output; skip
                        // streams/Response passthrough since the user will read those themselves.
                        if (hasMaxContentLength && !supportsResponseStream && !isStreamResponse) {
                            ;
                            if (responseData != null) {
                                if (typeof responseData.byteLength === 'number') materializedSize = responseData.byteLength;
                                else if (typeof responseData.size === 'number') materializedSize = responseData.size;
                                else if (typeof responseData === 'string') materializedSize = typeof TextEncoder === 'function' ? new TextEncoder().encode(responseData).byteLength : responseData.length;
                            }
                            if (typeof materializedSize === 'number' && materializedSize > maxContentLength) throw new (0, $781d5d445dc0d633$export$2e2bcd8739ae039)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, $781d5d445dc0d633$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, config, request);
                        }
                        !isStreamResponse && unsubscribe && unsubscribe();
                        return [
                            4,
                            new Promise(function(resolve, reject) {
                                (0, $fa6ddd8972b1eef7$export$2e2bcd8739ae039)(resolve, reject, {
                                    data: responseData,
                                    headers: (0, $027c52967d4f7f5c$export$2e2bcd8739ae039).from(response.headers),
                                    status: response.status,
                                    statusText: response.statusText,
                                    config: config,
                                    request: request
                                });
                            })
                        ];
                    case 8:
                        return [
                            2,
                            _state.sent()
                        ];
                    case 9:
                        err = _state.sent();
                        unsubscribe && unsubscribe();
                        // Safari can surface fetch aborts as a DOMException-like object whose
                        // branded getters throw. Prefer our composed signal reason before reading
                        // the caught error, preserving timeout vs cancellation semantics.
                        if (composedSignal && composedSignal.aborted && composedSignal.reason instanceof (0, $781d5d445dc0d633$export$2e2bcd8739ae039)) {
                            canceledError = composedSignal.reason;
                            canceledError.config = config;
                            request && (canceledError.request = request);
                            err !== canceledError && (canceledError.cause = err);
                            throw canceledError;
                        }
                        if (err && err.name === 'TypeError' && /Load failed|fetch/i.test(err.message)) throw Object.assign(new (0, $781d5d445dc0d633$export$2e2bcd8739ae039)('Network Error', (0, $781d5d445dc0d633$export$2e2bcd8739ae039).ERR_NETWORK, config, request, err && err.response), {
                            cause: err.cause || err
                        });
                        throw (0, $781d5d445dc0d633$export$2e2bcd8739ae039).from(err, err && err.code, config, request, err && err.response);
                    case 10:
                        return [
                            2
                        ];
                }
            });
        })();
    };
};
var $52de8754cf4d01ba$var$seedCache = new Map();
var $52de8754cf4d01ba$export$3105c6651375d4fa = function(config) {
    var env = config && config.env || {};
    var fetch1 = env.fetch, Request = env.Request, Response = env.Response;
    var seeds = [
        Request,
        Response,
        fetch1
    ];
    var len = seeds.length, i = len, seed, target, map = $52de8754cf4d01ba$var$seedCache;
    while(i--){
        seed = seeds[i];
        target = map.get(seed);
        target === undefined && map.set(seed, target = i ? new Map() : $52de8754cf4d01ba$var$factory(env));
        map = target;
    }
    return target;
};
var $52de8754cf4d01ba$var$adapter = $52de8754cf4d01ba$export$3105c6651375d4fa();
var $52de8754cf4d01ba$export$2e2bcd8739ae039 = $52de8754cf4d01ba$var$adapter;



/**
 * Known adapters mapping.
 * Provides environment-specific adapters for Axios:
 * - `http` for Node.js
 * - `xhr` for browsers
 * - `fetch` for fetch API-based requests
 *
 * @type {Object<string, Function|Object>}
 */ var $cc824dc813b31c0a$var$knownAdapters = {
    http: (0, $ae65935d5d170552$export$2e2bcd8739ae039),
    xhr: (0, $cf6cc3f5cc27a7c0$export$2e2bcd8739ae039),
    fetch: {
        get: $52de8754cf4d01ba$export$3105c6651375d4fa
    }
};
// Assign adapter names for easier debugging and identification
(0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).forEach($cc824dc813b31c0a$var$knownAdapters, function(fn, value) {
    if (fn) {
        try {
            // Null-proto descriptors so a polluted Object.prototype.get cannot turn
            // these data descriptors into accessor descriptors on the way in.
            Object.defineProperty(fn, 'name', {
                __proto__: null,
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, 'adapterName', {
            __proto__: null,
            value: value
        });
    }
});
/**
 * Render a rejection reason string for unknown or unsupported adapters
 *
 * @param {string} reason
 * @returns {string}
 */ var $cc824dc813b31c0a$var$renderReason = function(reason) {
    return "- ".concat(reason);
};
/**
 * Check if the adapter is resolved (function, null, or false)
 *
 * @param {Function|null|false} adapter
 * @returns {boolean}
 */ var $cc824dc813b31c0a$var$isResolvedHandle = function(adapter) {
    return (0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).isFunction(adapter) || adapter === null || adapter === false;
};
/**
 * Get the first suitable adapter from the provided list.
 * Tries each adapter in order until a supported one is found.
 * Throws an AxiosError if no adapter is suitable.
 *
 * @param {Array<string|Function>|string|Function} adapters - Adapter(s) by name or function.
 * @param {Object} config - Axios request configuration
 * @throws {AxiosError} If no suitable adapter is available
 * @returns {Function} The resolved adapter function
 */ function $cc824dc813b31c0a$var$getAdapter(adapters, config) {
    adapters = (0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).isArray(adapters) ? adapters : [
        adapters
    ];
    var length = adapters.length;
    var nameOrAdapter;
    var adapter;
    var rejectedReasons = {};
    for(var i = 0; i < length; i++){
        nameOrAdapter = adapters[i];
        var id = void 0;
        adapter = nameOrAdapter;
        if (!$cc824dc813b31c0a$var$isResolvedHandle(nameOrAdapter)) {
            adapter = $cc824dc813b31c0a$var$knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
            if (adapter === undefined) throw new (0, $781d5d445dc0d633$export$2e2bcd8739ae039)("Unknown adapter '".concat(id, "'"));
        }
        if (adapter && ((0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).isFunction(adapter) || (adapter = adapter.get(config)))) break;
        rejectedReasons[id || '#' + i] = adapter;
    }
    if (!adapter) {
        var reasons = Object.entries(rejectedReasons).map(function(param) {
            var _param = (0, $c940fad574a3594c$export$71511d61b312f219)(param, 2), id = _param[0], state = _param[1];
            return "adapter ".concat(id, " ") + (state === false ? 'is not supported by the environment' : 'is not available in the build');
        });
        var s = length ? reasons.length > 1 ? 'since :\n' + reasons.map($cc824dc813b31c0a$var$renderReason).join('\n') : ' ' + $cc824dc813b31c0a$var$renderReason(reasons[0]) : 'as no adapter specified';
        throw new (0, $781d5d445dc0d633$export$2e2bcd8739ae039)("There is no suitable adapter to dispatch the request " + s, 'ERR_NOT_SUPPORT');
    }
    return adapter;
}
var /**
 * Exports Axios adapters and utility to resolve an adapter
 */ $cc824dc813b31c0a$export$2e2bcd8739ae039 = {
    /**
   * Resolve an adapter from a list of adapter names or functions.
   * @type {Function}
   */ getAdapter: $cc824dc813b31c0a$var$getAdapter,
    /**
   * Exposes all known adapters
   * @type {Object<string, Function|Object>}
   */ adapters: $cc824dc813b31c0a$var$knownAdapters
};


'use strict';
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $aea9fc6348bd706e$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $deb8b523360309d3$export$2e2bcd8739ae039)(null, config);
}
function $aea9fc6348bd706e$export$2e2bcd8739ae039(config) {
    $aea9fc6348bd706e$var$throwIfCancellationRequested(config);
    config.headers = (0, $027c52967d4f7f5c$export$2e2bcd8739ae039).from(config.headers);
    // Transform request data
    config.data = (0, $d421006f298e0907$export$2e2bcd8739ae039).call(config, config.transformRequest);
    if ([
        'post',
        'put',
        'patch'
    ].indexOf(config.method) !== -1) config.headers.setContentType('application/x-www-form-urlencoded', false);
    var adapter = (0, $cc824dc813b31c0a$export$2e2bcd8739ae039).getAdapter(config.adapter || (0, $9a9eabebd13760ea$export$2e2bcd8739ae039).adapter, config);
    return adapter(config).then(function onAdapterResolution(response) {
        $aea9fc6348bd706e$var$throwIfCancellationRequested(config);
        // Expose the current response on config so that transformResponse can
        // attach it to any AxiosError it throws (e.g. on JSON parse failure).
        // We clean it up afterwards to avoid polluting the config object.
        config.response = response;
        try {
            response.data = (0, $d421006f298e0907$export$2e2bcd8739ae039).call(config, config.transformResponse, response);
        } finally{
            delete config.response;
        }
        response.headers = (0, $027c52967d4f7f5c$export$2e2bcd8739ae039).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $04ca7e0fcb50dd8a$export$2e2bcd8739ae039)(reason)) {
            $aea9fc6348bd706e$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                config.response = reason.response;
                try {
                    reason.response.data = (0, $d421006f298e0907$export$2e2bcd8739ae039).call(config, config.transformResponse, reason.response);
                } finally{
                    delete config.response;
                }
                reason.response.headers = (0, $027c52967d4f7f5c$export$2e2bcd8739ae039).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}







'use strict';
var $846aa4724f36f98f$var$validators = {};
// eslint-disable-next-line func-names
[
    'object',
    'boolean',
    'number',
    'function',
    'string',
    'symbol'
].forEach(function(type, i) {
    $846aa4724f36f98f$var$validators[type] = function validator(thing) {
        return (typeof thing === "undefined" ? "undefined" : (0, $15ae7fd16c0fe95b$export$71511d61b312f219)(thing)) === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
    };
});
var $846aa4724f36f98f$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $846aa4724f36f98f$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return '[Axios v' + (0, $5fb60c46abcc7e9c$export$a4ad2735b021c132) + "] Transitional option '" + opt + "'" + desc + (message ? '. ' + message : '');
    }
    // eslint-disable-next-line func-names
    return function(value, opt, opts) {
        if (validator === false) throw new (0, $781d5d445dc0d633$export$2e2bcd8739ae039)(formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')), (0, $781d5d445dc0d633$export$2e2bcd8739ae039).ERR_DEPRECATED);
        if (version && !$846aa4724f36f98f$var$deprecatedWarnings[opt]) {
            $846aa4724f36f98f$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, ' has been deprecated since v' + version + ' and will be removed in the near future'));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
$846aa4724f36f98f$var$validators.spelling = function spelling(correctSpelling) {
    return function(value, opt) {
        // eslint-disable-next-line no-console
        console.warn("".concat(opt, " is likely a misspelling of ").concat(correctSpelling));
        return true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $846aa4724f36f98f$var$assertOptions(options, schema, allowUnknown) {
    if ((typeof options === "undefined" ? "undefined" : (0, $15ae7fd16c0fe95b$export$71511d61b312f219)(options)) !== 'object') throw new (0, $781d5d445dc0d633$export$2e2bcd8739ae039)('options must be an object', (0, $781d5d445dc0d633$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
    var keys = Object.keys(options);
    var i = keys.length;
    while(i-- > 0){
        var opt = keys[i];
        // Use hasOwnProperty so a polluted Object.prototype.<opt> cannot supply
        // a non-function validator and cause a TypeError.
        var validator = Object.prototype.hasOwnProperty.call(schema, opt) ? schema[opt] : undefined;
        if (validator) {
            var value = options[opt];
            var result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $781d5d445dc0d633$export$2e2bcd8739ae039)('option ' + opt + ' must be ' + result, (0, $781d5d445dc0d633$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $781d5d445dc0d633$export$2e2bcd8739ae039)('Unknown option ' + opt, (0, $781d5d445dc0d633$export$2e2bcd8739ae039).ERR_BAD_OPTION);
    }
}
var $846aa4724f36f98f$export$2e2bcd8739ae039 = {
    assertOptions: $846aa4724f36f98f$var$assertOptions,
    validators: $846aa4724f36f98f$var$validators
};




'use strict';
var $a41f6d0ef750d43a$var$validators = (0, $846aa4724f36f98f$export$2e2bcd8739ae039).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ var $a41f6d0ef750d43a$var$Axios = /*#__PURE__*/ function() {
    function Axios(instanceConfig) {
        (0, $27b4cf4927316b66$export$71511d61b312f219)(this, Axios);
        this.defaults = instanceConfig || {};
        this.interceptors = {
            request: new (0, $7ad406f9763aae38$export$2e2bcd8739ae039)(),
            response: new (0, $7ad406f9763aae38$export$2e2bcd8739ae039)()
        };
    }
    (0, $9ec8be00d480deaf$export$71511d61b312f219)(Axios, [
        {
            key: "request",
            value: /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ function request(configOrUrl, config) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $03857362ebfa6f2c$export$71511d61b312f219)(function() {
                    var err, dummy, stack, firstNewlineIndex, secondNewlineIndex, stackWithoutTwoTopLines;
                    return (0, $ca8679453dfc275b$export$71511d61b312f219)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    this._request(configOrUrl, config)
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 2:
                                err = _state.sent();
                                if (err instanceof Error) {
                                    dummy = {};
                                    Error.captureStackTrace ? Error.captureStackTrace(dummy) : dummy = new Error();
                                    // slice off the Error: ... line
                                    stack = function() {
                                        if (!dummy.stack) return '';
                                        var firstNewlineIndex = dummy.stack.indexOf('\n');
                                        return firstNewlineIndex === -1 ? '' : dummy.stack.slice(firstNewlineIndex + 1);
                                    }();
                                    try {
                                        if (!err.stack) err.stack = stack;
                                        else if (stack) {
                                            firstNewlineIndex = stack.indexOf('\n');
                                            secondNewlineIndex = firstNewlineIndex === -1 ? -1 : stack.indexOf('\n', firstNewlineIndex + 1);
                                            stackWithoutTwoTopLines = secondNewlineIndex === -1 ? '' : stack.slice(secondNewlineIndex + 1);
                                            if (!String(err.stack).endsWith(stackWithoutTwoTopLines)) err.stack += '\n' + stack;
                                        }
                                    } catch (e) {
                                    // ignore the case where "stack" is an un-writable property
                                    }
                                }
                                throw err;
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "_request",
            value: function _request(configOrUrl, config) {
                /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
                if (typeof configOrUrl === 'string') {
                    config = config || {};
                    config.url = configOrUrl;
                } else config = configOrUrl || {};
                config = (0, $807c7b5a8b6039d6$export$2e2bcd8739ae039)(this.defaults, config);
                var transitional = config.transitional, paramsSerializer = config.paramsSerializer, headers = config.headers;
                if (transitional !== undefined) (0, $846aa4724f36f98f$export$2e2bcd8739ae039).assertOptions(transitional, {
                    silentJSONParsing: $a41f6d0ef750d43a$var$validators.transitional($a41f6d0ef750d43a$var$validators["boolean"]),
                    forcedJSONParsing: $a41f6d0ef750d43a$var$validators.transitional($a41f6d0ef750d43a$var$validators["boolean"]),
                    clarifyTimeoutError: $a41f6d0ef750d43a$var$validators.transitional($a41f6d0ef750d43a$var$validators["boolean"]),
                    legacyInterceptorReqResOrdering: $a41f6d0ef750d43a$var$validators.transitional($a41f6d0ef750d43a$var$validators["boolean"])
                }, false);
                if (paramsSerializer != null) {
                    if ((0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).isFunction(paramsSerializer)) config.paramsSerializer = {
                        serialize: paramsSerializer
                    };
                    else (0, $846aa4724f36f98f$export$2e2bcd8739ae039).assertOptions(paramsSerializer, {
                        encode: $a41f6d0ef750d43a$var$validators["function"],
                        serialize: $a41f6d0ef750d43a$var$validators["function"]
                    }, true);
                }
                // Set config.allowAbsoluteUrls
                if (config.allowAbsoluteUrls !== undefined) ;
                else if (this.defaults.allowAbsoluteUrls !== undefined) config.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls;
                else config.allowAbsoluteUrls = true;
                (0, $846aa4724f36f98f$export$2e2bcd8739ae039).assertOptions(config, {
                    baseUrl: $a41f6d0ef750d43a$var$validators.spelling('baseURL'),
                    withXsrfToken: $a41f6d0ef750d43a$var$validators.spelling('withXSRFToken')
                }, true);
                // Set config.method
                config.method = (config.method || this.defaults.method || 'get').toLowerCase();
                // Flatten headers
                var contextHeaders = headers && (0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).merge(headers.common, headers[config.method]);
                headers && (0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).forEach([
                    'delete',
                    'get',
                    'head',
                    'post',
                    'put',
                    'patch',
                    'query',
                    'common'
                ], function(method) {
                    delete headers[method];
                });
                config.headers = (0, $027c52967d4f7f5c$export$2e2bcd8739ae039).concat(contextHeaders, headers);
                // filter out skipped interceptors
                var requestInterceptorChain = [];
                var synchronousRequestInterceptors = true;
                this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
                    if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) return;
                    synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
                    var transitional = config.transitional || (0, $4f1fbd47c7daaec2$export$2e2bcd8739ae039);
                    var legacyInterceptorReqResOrdering = transitional && transitional.legacyInterceptorReqResOrdering;
                    if (legacyInterceptorReqResOrdering) requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
                    else requestInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
                });
                var responseInterceptorChain = [];
                this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
                    responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
                });
                var promise;
                var i = 0;
                var len;
                if (!synchronousRequestInterceptors) {
                    var _chain, _chain1;
                    var chain = [
                        (0, $aea9fc6348bd706e$export$2e2bcd8739ae039).bind(this),
                        undefined
                    ];
                    (_chain = chain).unshift.apply(_chain, (0, $9b2c00b55773b429$export$71511d61b312f219)(requestInterceptorChain));
                    (_chain1 = chain).push.apply(_chain1, (0, $9b2c00b55773b429$export$71511d61b312f219)(responseInterceptorChain));
                    len = chain.length;
                    promise = Promise.resolve(config);
                    while(i < len)promise = promise.then(chain[i++], chain[i++]);
                    return promise;
                }
                len = requestInterceptorChain.length;
                var newConfig = config;
                while(i < len){
                    var onFulfilled = requestInterceptorChain[i++];
                    var onRejected = requestInterceptorChain[i++];
                    try {
                        newConfig = onFulfilled(newConfig);
                    } catch (error) {
                        onRejected.call(this, error);
                        break;
                    }
                }
                try {
                    promise = (0, $aea9fc6348bd706e$export$2e2bcd8739ae039).call(this, newConfig);
                } catch (error) {
                    return Promise.reject(error);
                }
                i = 0;
                len = responseInterceptorChain.length;
                while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
                return promise;
            }
        },
        {
            key: "getUri",
            value: function getUri(config) {
                config = (0, $807c7b5a8b6039d6$export$2e2bcd8739ae039)(this.defaults, config);
                var fullPath = (0, $e4de6ed9cce1530d$export$2e2bcd8739ae039)(config.baseURL, config.url, config.allowAbsoluteUrls);
                return (0, $99de190d72ac4f4a$export$2e2bcd8739ae039)(fullPath, config.params, config.paramsSerializer);
            }
        }
    ]);
    return Axios;
}();
// Provide aliases for supported request methods
(0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).forEach([
    'delete',
    'get',
    'head',
    'options'
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $a41f6d0ef750d43a$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $807c7b5a8b6039d6$export$2e2bcd8739ae039)(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
(0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).forEach([
    'post',
    'put',
    'patch',
    'query'
], function forEachMethodWithData(method) {
    function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $807c7b5a8b6039d6$export$2e2bcd8739ae039)(config || {}, {
                method: method,
                headers: isForm ? {
                    'Content-Type': 'multipart/form-data'
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $a41f6d0ef750d43a$var$Axios.prototype[method] = generateHTTPMethod();
    // QUERY is a safe/idempotent read method; multipart form bodies don't fit
    // its semantics, so no queryForm shorthand is generated.
    if (method !== 'query') $a41f6d0ef750d43a$var$Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});
var $a41f6d0ef750d43a$export$2e2bcd8739ae039 = $a41f6d0ef750d43a$var$Axios;









'use strict';
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ var $07fe6e1e93d4ea5f$var$CancelToken = /*#__PURE__*/ function() {
    function CancelToken(executor) {
        (0, $27b4cf4927316b66$export$71511d61b312f219)(this, CancelToken);
        if (typeof executor !== 'function') throw new TypeError('executor must be a function.');
        var resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        var token = this;
        // eslint-disable-next-line func-names
        this.promise.then(function(cancel) {
            if (!token._listeners) return;
            var i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = function(onfulfilled) {
            var _resolve;
            // eslint-disable-next-line func-names
            var promise = new Promise(function(resolve) {
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $deb8b523360309d3$export$2e2bcd8739ae039)(message, config, request);
            resolvePromise(token.reason);
        });
    }
    (0, $9ec8be00d480deaf$export$71511d61b312f219)(CancelToken, [
        {
            /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ key: "throwIfRequested",
            value: function throwIfRequested() {
                if (this.reason) throw this.reason;
            }
        },
        {
            /**
   * Subscribe to the cancel signal
   */ key: "subscribe",
            value: function subscribe(listener) {
                if (this.reason) {
                    listener(this.reason);
                    return;
                }
                if (this._listeners) this._listeners.push(listener);
                else this._listeners = [
                    listener
                ];
            }
        },
        {
            /**
   * Unsubscribe from the cancel signal
   */ key: "unsubscribe",
            value: function unsubscribe(listener) {
                if (!this._listeners) return;
                var index = this._listeners.indexOf(listener);
                if (index !== -1) this._listeners.splice(index, 1);
            }
        },
        {
            key: "toAbortSignal",
            value: function toAbortSignal() {
                var _this = this;
                var controller = new AbortController();
                var abort = function(err) {
                    controller.abort(err);
                };
                this.subscribe(abort);
                controller.signal.unsubscribe = function() {
                    return _this.unsubscribe(abort);
                };
                return controller.signal;
            }
        }
    ], [
        {
            key: "source",
            value: /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ function source() {
                var cancel;
                var token = new CancelToken(function executor(c) {
                    cancel = c;
                });
                return {
                    token: token,
                    cancel: cancel
                };
            }
        }
    ]);
    return CancelToken;
}();
var $07fe6e1e93d4ea5f$export$2e2bcd8739ae039 = $07fe6e1e93d4ea5f$var$CancelToken;






'use strict';
function $7ce57182e0753bb4$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}



'use strict';
function $5b0aa85d9d500620$export$2e2bcd8739ae039(payload) {
    return (0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).isObject(payload) && payload.isAxiosError === true;
}





var $1be90c822661435b$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511,
    WebServerIsDown: 521,
    ConnectionTimedOut: 522,
    OriginIsUnreachable: 523,
    TimeoutOccurred: 524,
    SslHandshakeFailed: 525,
    InvalidSslCertificate: 526
};
Object.entries($1be90c822661435b$var$HttpStatusCode).forEach(function(param) {
    var _param = (0, $c940fad574a3594c$export$71511d61b312f219)(param, 2), key = _param[0], value = _param[1];
    $1be90c822661435b$var$HttpStatusCode[value] = key;
});
var $1be90c822661435b$export$2e2bcd8739ae039 = $1be90c822661435b$var$HttpStatusCode;


'use strict';
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $0ed3984fa928546b$var$createInstance(defaultConfig) {
    var context = new (0, $a41f6d0ef750d43a$export$2e2bcd8739ae039)(defaultConfig);
    var instance = (0, $ad97c7e0c7328995$export$2e2bcd8739ae039)((0, $a41f6d0ef750d43a$export$2e2bcd8739ae039).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).extend(instance, (0, $a41f6d0ef750d43a$export$2e2bcd8739ae039).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $0ed3984fa928546b$var$createInstance((0, $807c7b5a8b6039d6$export$2e2bcd8739ae039)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
var $0ed3984fa928546b$var$axios = $0ed3984fa928546b$var$createInstance((0, $9a9eabebd13760ea$export$2e2bcd8739ae039));
// Expose Axios class to allow class inheritance
$0ed3984fa928546b$var$axios.Axios = (0, $a41f6d0ef750d43a$export$2e2bcd8739ae039);
// Expose Cancel & CancelToken
$0ed3984fa928546b$var$axios.CanceledError = (0, $deb8b523360309d3$export$2e2bcd8739ae039);
$0ed3984fa928546b$var$axios.CancelToken = (0, $07fe6e1e93d4ea5f$export$2e2bcd8739ae039);
$0ed3984fa928546b$var$axios.isCancel = (0, $04ca7e0fcb50dd8a$export$2e2bcd8739ae039);
$0ed3984fa928546b$var$axios.VERSION = (0, $5fb60c46abcc7e9c$export$a4ad2735b021c132);
$0ed3984fa928546b$var$axios.toFormData = (0, $49a9beed7bc31dae$export$2e2bcd8739ae039);
// Expose AxiosError class
$0ed3984fa928546b$var$axios.AxiosError = (0, $781d5d445dc0d633$export$2e2bcd8739ae039);
// alias for CanceledError for backward compatibility
$0ed3984fa928546b$var$axios.Cancel = $0ed3984fa928546b$var$axios.CanceledError;
// Expose all/spread
$0ed3984fa928546b$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$0ed3984fa928546b$var$axios.spread = (0, $7ce57182e0753bb4$export$2e2bcd8739ae039);
// Expose isAxiosError
$0ed3984fa928546b$var$axios.isAxiosError = (0, $5b0aa85d9d500620$export$2e2bcd8739ae039);
// Expose mergeConfig
$0ed3984fa928546b$var$axios.mergeConfig = (0, $807c7b5a8b6039d6$export$2e2bcd8739ae039);
$0ed3984fa928546b$var$axios.AxiosHeaders = (0, $027c52967d4f7f5c$export$2e2bcd8739ae039);
$0ed3984fa928546b$var$axios.formToJSON = function(thing) {
    return (0, $fb53b50c26be7261$export$2e2bcd8739ae039)((0, $4ee88d3ab9e0f87b$export$2e2bcd8739ae039).isHTMLForm(thing) ? new FormData(thing) : thing);
};
$0ed3984fa928546b$var$axios.getAdapter = (0, $cc824dc813b31c0a$export$2e2bcd8739ae039).getAdapter;
$0ed3984fa928546b$var$axios.HttpStatusCode = (0, $1be90c822661435b$export$2e2bcd8739ae039);
$0ed3984fa928546b$var$axios["default"] = $0ed3984fa928546b$var$axios;
var // this module should only have a default export
$0ed3984fa928546b$export$2e2bcd8739ae039 = $0ed3984fa928546b$var$axios;


// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
var $227eea59ed3c1db7$export$1c00760e9e5a4e95 = (0, $0ed3984fa928546b$export$2e2bcd8739ae039).Axios, $227eea59ed3c1db7$export$c1fbed17c2f6a328 = (0, $0ed3984fa928546b$export$2e2bcd8739ae039).AxiosError, $227eea59ed3c1db7$export$1ab0c6b20d94fa14 = (0, $0ed3984fa928546b$export$2e2bcd8739ae039).CanceledError, $227eea59ed3c1db7$export$3b22524397b493c6 = (0, $0ed3984fa928546b$export$2e2bcd8739ae039).isCancel, $227eea59ed3c1db7$export$fd08e3cb425f0d61 = (0, $0ed3984fa928546b$export$2e2bcd8739ae039).CancelToken, $227eea59ed3c1db7$export$a4ad2735b021c132 = (0, $0ed3984fa928546b$export$2e2bcd8739ae039).VERSION, $227eea59ed3c1db7$export$84bf76cd7afc7469 = (0, $0ed3984fa928546b$export$2e2bcd8739ae039).all, $227eea59ed3c1db7$export$848c9b7ead0df967 = (0, $0ed3984fa928546b$export$2e2bcd8739ae039).Cancel, $227eea59ed3c1db7$export$fbafdbe06a5b5a9a = (0, $0ed3984fa928546b$export$2e2bcd8739ae039).isAxiosError, $227eea59ed3c1db7$export$3ae0fd4797ed47c8 = (0, $0ed3984fa928546b$export$2e2bcd8739ae039).spread, $227eea59ed3c1db7$export$10ae0d317ea97f8b = (0, $0ed3984fa928546b$export$2e2bcd8739ae039).toFormData, $227eea59ed3c1db7$export$4e7d6ff0f3e6520 = (0, $0ed3984fa928546b$export$2e2bcd8739ae039).AxiosHeaders, $227eea59ed3c1db7$export$a972f69c851492b3 = (0, $0ed3984fa928546b$export$2e2bcd8739ae039).HttpStatusCode, $227eea59ed3c1db7$export$86d7c59254d6a2c9 = (0, $0ed3984fa928546b$export$2e2bcd8739ae039).formToJSON, $227eea59ed3c1db7$export$17ddc20a97d669e2 = (0, $0ed3984fa928546b$export$2e2bcd8739ae039).getAdapter, $227eea59ed3c1db7$export$7ec1ebcfa9d8bd6a = (0, $0ed3984fa928546b$export$2e2bcd8739ae039).mergeConfig, $227eea59ed3c1db7$export$185802fd694ee1f5 = (0, $0ed3984fa928546b$export$2e2bcd8739ae039).create;


var $cdc9be61cf79477c$var$_envRoutes, $cdc9be61cf79477c$var$_promise;
var $cdc9be61cf79477c$export$2e2bcd8739ae039 = new ($cdc9be61cf79477c$var$_envRoutes = /*#__PURE__*/ new WeakMap(), $cdc9be61cf79477c$var$_promise = /*#__PURE__*/ new WeakMap(), /*#__PURE__*/ function() {
    "use strict";
    function _class() {
        var _this = this;
        (0, $27b4cf4927316b66$export$71511d61b312f219)(this, _class);
        (0, $532319f0d9d2d372$export$71511d61b312f219)(this, $cdc9be61cf79477c$var$_envRoutes, {
            writable: true,
            value: void 0
        });
        (0, $532319f0d9d2d372$export$71511d61b312f219)(this, $cdc9be61cf79477c$var$_promise, {
            writable: true,
            value: void 0
        });
        (0, $e0a0c6592404d6dd$export$71511d61b312f219)(this, $cdc9be61cf79477c$var$_promise, (0, $0ed3984fa928546b$export$2e2bcd8739ae039).get("/routes.json").then(function(response) {
            (0, $e0a0c6592404d6dd$export$71511d61b312f219)(_this, $cdc9be61cf79477c$var$_envRoutes, response.data);
        }));
    }
    (0, $9ec8be00d480deaf$export$71511d61b312f219)(_class, [
        {
            key: "getRoutes",
            value: function getRoutes() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $03857362ebfa6f2c$export$71511d61b312f219)(function() {
                    return (0, $ca8679453dfc275b$export$71511d61b312f219)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!!(0, $9a040ee0b198d009$export$71511d61b312f219)(this, $cdc9be61cf79477c$var$_envRoutes)) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    (0, $9a040ee0b198d009$export$71511d61b312f219)(this, $cdc9be61cf79477c$var$_promise)
                                ];
                            case 1:
                                _state.sent();
                                _state.label = 2;
                            case 2:
                                if (!(0, $9a040ee0b198d009$export$71511d61b312f219)(this, $cdc9be61cf79477c$var$_envRoutes)) throw new Error("Routes not loaded");
                                return [
                                    2,
                                    (0, $9a040ee0b198d009$export$71511d61b312f219)(this, $cdc9be61cf79477c$var$_envRoutes)
                                ];
                        }
                    });
                }).call(this);
            }
        }
    ]);
    return _class;
}())();








"use strict";
var $2952193d0ebcaecb$var$_events = /*#__PURE__*/ new WeakMap();
var $2952193d0ebcaecb$export$5087227eb54526 = /*#__PURE__*/ function() {
    function EventBus() {
        (0, $27b4cf4927316b66$export$71511d61b312f219)(this, EventBus);
        (0, $532319f0d9d2d372$export$71511d61b312f219)(this, $2952193d0ebcaecb$var$_events, {
            writable: true,
            value: {}
        });
        (0, $e0a0c6592404d6dd$export$71511d61b312f219)(this, $2952193d0ebcaecb$var$_events, {});
    }
    (0, $9ec8be00d480deaf$export$71511d61b312f219)(EventBus, [
        {
            key: "subscribe",
            value: function subscribe(event, callback) {
                if (!(0, $9a040ee0b198d009$export$71511d61b312f219)(this, $2952193d0ebcaecb$var$_events)[event]) (0, $9a040ee0b198d009$export$71511d61b312f219)(this, $2952193d0ebcaecb$var$_events)[event] = [];
                (0, $9a040ee0b198d009$export$71511d61b312f219)(this, $2952193d0ebcaecb$var$_events)[event].push(callback);
            }
        },
        {
            key: "publish",
            value: function publish(event, data) {
                if (!(0, $9a040ee0b198d009$export$71511d61b312f219)(this, $2952193d0ebcaecb$var$_events)[event]) return;
                (0, $9a040ee0b198d009$export$71511d61b312f219)(this, $2952193d0ebcaecb$var$_events)[event].forEach(function(callback) {
                    return callback(data);
                });
            }
        }
    ]);
    return EventBus;
}();





"use strict";
var $3b26ebc5ace60397$export$79dd73309e90dfd0 = function OAuth(eventBus) {
    (0, $27b4cf4927316b66$export$71511d61b312f219)(this, OAuth);
    (0, $bfe84793eadce7a5$export$71511d61b312f219)(this, "afterLogin", function(data) {
        (0, $0ed3984fa928546b$export$2e2bcd8739ae039).post(window.location.pathname + "/result", data).then(function(response) {
            if (response.status === 200) window.location.href = response.data.redirectUrl;
        });
    });
    eventBus.subscribe("login", this.afterLogin);
};


"use strict";
function $c418bd1506027f0b$export$191b4c9edf0899a6() {
    document.getElementById("authenticatingUser").style.display = "block";
}
function $c418bd1506027f0b$export$c6c09f9583388923() {
    document.getElementById("authenticatingUser").style.display = "none";
}
function $c418bd1506027f0b$export$64858b67578a10bb() {
    document.getElementById("loading").style.display = "flex";
}
function $c418bd1506027f0b$export$7d026bf51c574e0d() {
    document.getElementById("loading").style.display = "none";
}
function $c418bd1506027f0b$export$1d1423934687e1c6() {
    $c418bd1506027f0b$export$7d026bf51c574e0d();
    $c418bd1506027f0b$export$c6c09f9583388923();
    document.getElementById("loginForm").style.display = "block";
    document.getElementById("logoContainer").children[0].style.display = "block";
    document.getElementById("signUpDiv").style.display = "block";
    document.getElementById("legalTermsSection").style.display = "block";
}


var $817bc92a38d06f3b$exports = {};
$817bc92a38d06f3b$exports = $parcel$resolve("iJPGa");


var $8416a8c05b6cd586$exports = {};
$8416a8c05b6cd586$exports = $parcel$resolve("gxAgp");


var $56764195ae0a7bb6$exports = {};
$56764195ae0a7bb6$exports = $parcel$resolve("8ZdaI");


var $1b7f251a08f28c57$exports = {};
$1b7f251a08f28c57$exports = $parcel$resolve("jTQWl");


var $bf238252a34a27d9$exports = {};
$bf238252a34a27d9$exports = $parcel$resolve("9iap4");


var $c4ba49442065b6ca$exports = {};
$c4ba49442065b6ca$exports = $parcel$resolve("8rctJ");


var $e79439daf03dee95$exports = {};
$e79439daf03dee95$exports = $parcel$resolve("2lU7u");


var $693fa0ef2078e6e2$exports = {};
$693fa0ef2078e6e2$exports = $parcel$resolve("kB9Md");


var $764ccf2d8ae08b2d$exports = {};
$764ccf2d8ae08b2d$exports = $parcel$resolve("4mSQ1");


var $8727c3eca8835207$exports = {};
$8727c3eca8835207$exports = $parcel$resolve("5teKa");


var $4e417c0cc15b8ca6$exports = {};
$4e417c0cc15b8ca6$exports = $parcel$resolve("aCHb4");


var $348701764c2bd8b4$exports = {};
$348701764c2bd8b4$exports = $parcel$resolve("7plC6");


var $bcdc7d441764fae4$exports = {};
$bcdc7d441764fae4$exports = $parcel$resolve("ekseF");


var $aa8e5f4a104c700c$exports = {};
$aa8e5f4a104c700c$exports = $parcel$resolve("behbj");


var $81e79c754f2a79df$exports = {};
$81e79c754f2a79df$exports = $parcel$resolve("2hpS8");


var $dbbb3d9e20ea29f2$exports = {};
$dbbb3d9e20ea29f2$exports = $parcel$resolve("ahx9V");


var $b16cc018ba132783$exports = {};
$b16cc018ba132783$exports = $parcel$resolve("6STaM");


var $ff99b281d4dfa046$exports = {};
$ff99b281d4dfa046$exports = $parcel$resolve("5p7Og");


var $a41da7ceca394982$exports = {};
$a41da7ceca394982$exports = $parcel$resolve("aU3AY");


var $d08bbdc2f24b399f$exports = {};
$d08bbdc2f24b399f$exports = $parcel$resolve("Mu50N");


var $211e097e8f6d2ed4$exports = {};
$211e097e8f6d2ed4$exports = $parcel$resolve("1G1JZ");


var $4d2f521885f503f6$exports = {};
$4d2f521885f503f6$exports = $parcel$resolve("60k6i");


var $d660adff451f9287$exports = {};
$d660adff451f9287$exports = $parcel$resolve("3cgvA");


var $f30134bb02fbde57$exports = {};
$f30134bb02fbde57$exports = $parcel$resolve("jVbKF");


var $03460c1d1ba95f4f$exports = {};
$03460c1d1ba95f4f$exports = $parcel$resolve("bODa4");


var $2afaddfbd93549dc$exports = {};
$2afaddfbd93549dc$exports = $parcel$resolve("hzCNs");


var $c49eb67cea6617a4$exports = {};
$c49eb67cea6617a4$exports = $parcel$resolve("c3622");


var $9b252ea871487885$exports = {};
$9b252ea871487885$exports = $parcel$resolve("gehAD");


// console.log(documen)
/*
 * This code is to test the document referrer and build out the logo switching
 */ var $0da753eadb345b64$var$isStaging = false;
// Check if we're in staging environment and automatically enable the forgot password button and hide captcha
function $0da753eadb345b64$var$checkEnvironment() {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $03857362ebfa6f2c$export$71511d61b312f219)(function() {
        var routes, error;
        return (0, $ca8679453dfc275b$export$71511d61b312f219)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        (0, $cdc9be61cf79477c$export$2e2bcd8739ae039).getRoutes()
                    ];
                case 1:
                    routes = _state.sent();
                    $0da753eadb345b64$var$isStaging = routes.backendAuthServer && routes.backendAuthServer.includes("staging");
                    if ($0da753eadb345b64$var$isStaging) {
                        if (document.getElementById("forgotPwBtn")) document.getElementById("forgotPwBtn").disabled = false;
                        if (document.getElementById("captchaContainer")) document.getElementById("captchaContainer").style.display = "none";
                    }
                    return [
                        3,
                        3
                    ];
                case 2:
                    error = _state.sent();
                    console.error("Error determining environment:", error);
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    })();
}
document.addEventListener("DOMContentLoaded", function() {
    $0da753eadb345b64$var$checkEnvironment();
});
var $0da753eadb345b64$var$eventBus = new (0, $2952193d0ebcaecb$export$5087227eb54526)();
var $0da753eadb345b64$var$MOBILE_REDIRECT_ROUTE = "/mobileDashboard";
var $0da753eadb345b64$var$USE_NEW_PW_EXPIRED = true;
var $0da753eadb345b64$var$isESignatureVerification = window.location.pathname === "/esignature-verification";
var $0da753eadb345b64$var$isOAuth = window.location.pathname.includes("/interaction");
if ($0da753eadb345b64$var$isOAuth) new (0, $3b26ebc5ace60397$export$79dd73309e90dfd0)($0da753eadb345b64$var$eventBus);
// This is a workaround for SSO logins. I don't have access to the
// cookies from the ssoLogin route, so we send the user back here
// and check if they are already logged in, then run the OIDC flow.
if (window.location.search.includes("checkLoggedIn=true")) (0, $cdc9be61cf79477c$export$2e2bcd8739ae039).getRoutes().then(function(routes) {
    (0, $0ed3984fa928546b$export$2e2bcd8739ae039).post("".concat(routes.backendAuthServer, "/verify")).then(function(response) {
        console.log("devLog: response", response);
        if (response.data.success) $0da753eadb345b64$var$eventBus.publish("login", {
            success: true,
            user: response.data.userID,
            username: response.data.userLoginName
        });
    })["catch"](function(error) {
        console.error("devLog: error", error);
    });
});
document.getElementById("loginBtn").addEventListener("click", function() {
    $0da753eadb345b64$var$submitLogin();
});
document.getElementById("loginForm").addEventListener("keydown", function(event) {
    if (event.key == "Enter") $0da753eadb345b64$var$submitLogin();
}, false);
document.getElementById("forgotPwBtn").addEventListener("click", function() {
    $0da753eadb345b64$var$forgotMyPassword();
});
/*

   On page load we should check for the exsitance of a cookie and redirect the user if they have one? Maybe.

*/ var $0da753eadb345b64$var$userField = "system_processor"; //these names are specifically misleading
var $0da753eadb345b64$var$passField = "limble_region"; //these names are specifically misleading
var $0da753eadb345b64$var$creds = $0da753eadb345b64$var$getLoginLocalStorage($0da753eadb345b64$var$userField, $0da753eadb345b64$var$passField);
if ($0da753eadb345b64$var$creds.user && $0da753eadb345b64$var$creds.pass) {
    document.getElementById("username").value = $0da753eadb345b64$var$creds.user;
    document.getElementById("password").value = $0da753eadb345b64$var$creds.pass;
    document.getElementById("box3").checked = true;
}
function $0da753eadb345b64$var$submitLogin() {
    //IN THE FUTURE BEFORE WE POST TO THE LOGIN SERVER WILL NEED TO POST TO THE AUTH SERVER LOCATED IN N.CALI
    //THAT AUTH SERVER WILL HAVE TO RETURN WHICH REGION THE ACCOUNT IS IN BASED ON A HASH DATABASE/Dynamo
    // grecaptcha.ready(function () {
    //    grecaptcha
    //       .execute("6LeyXOAUAAAAAIEfLKdFbTscOgqtl34_M1cSWK09", { action: "login" })
    //       .then(function (token) {
    if (document.getElementById("username").value && document.getElementById("password").value) $0da753eadb345b64$var$login();
    else {
        document.getElementById("loginErr").style.display = "";
        document.getElementById("loading").style.display = "none";
        $0da753eadb345b64$var$setAllLogoDisplays("");
        return;
    }
// });
// });
}
function $0da753eadb345b64$var$submitPasswordUpdate() {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $03857362ebfa6f2c$export$71511d61b312f219)(function() {
        var validCurrentPassword, updateSuccessful, error;
        return (0, $ca8679453dfc275b$export$71511d61b312f219)(this, function(_state) {
            switch(_state.label){
                case 0:
                    $0da753eadb345b64$var$setAllLogoDisplays("none");
                    document.getElementById("loading").style.display = "flex";
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        8
                    ]);
                    return [
                        4,
                        $0da753eadb345b64$var$verifyCurrentPassword()
                    ];
                case 2:
                    validCurrentPassword = _state.sent();
                    if (!validCurrentPassword) return [
                        3,
                        4
                    ];
                    return [
                        4,
                        $0da753eadb345b64$var$updatePassword()
                    ];
                case 3:
                    updateSuccessful = _state.sent();
                    if (updateSuccessful) $0da753eadb345b64$var$showUpdateSuccess();
                    else $0da753eadb345b64$var$showUpdateError();
                    return [
                        3,
                        5
                    ];
                case 4:
                    $0da753eadb345b64$var$showCurrentPasswordValidationError();
                    _state.label = 5;
                case 5:
                    return [
                        3,
                        8
                    ];
                case 6:
                    error = _state.sent();
                    $0da753eadb345b64$var$showUpdateError();
                    return [
                        3,
                        8
                    ];
                case 7:
                    document.getElementById("loading").style.display = "none";
                    $0da753eadb345b64$var$setAllLogoDisplays("");
                    return [
                        7
                    ];
                case 8:
                    return [
                        2
                    ];
            }
        });
    })();
}
function $0da753eadb345b64$var$setAllLogoDisplays() {
    var displayCode = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    var logos = document.getElementsByClassName("logo");
    for(var i = 0; i < logos.length; ++i){
        var item = logos[i];
        item.style.display = displayCode;
    }
}
function $0da753eadb345b64$var$verifyCurrentPassword() {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $03857362ebfa6f2c$export$71511d61b312f219)(function() {
        var routes, config, response, error;
        return (0, $ca8679453dfc275b$export$71511d61b312f219)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        (0, $cdc9be61cf79477c$export$2e2bcd8739ae039).getRoutes()
                    ];
                case 1:
                    routes = _state.sent();
                    config = {
                        headers: {
                            "Access-Control-Allow-Origin": routes.backendAuthServer
                        },
                        withCredentials: true
                    };
                    return [
                        4,
                        (0, $0ed3984fa928546b$export$2e2bcd8739ae039).post(routes.backendAuthServer + "/verifyCurrentPassword", {
                            username: document.getElementById("username").value,
                            currentPassword: document.getElementById("currentPassword").value
                        }, config)
                    ];
                case 2:
                    response = _state.sent();
                    return [
                        2,
                        response.data.success
                    ];
                case 3:
                    error = _state.sent();
                    return [
                        2,
                        false
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    })();
}
function $0da753eadb345b64$var$updatePassword() {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $03857362ebfa6f2c$export$71511d61b312f219)(function() {
        var _response_data, routes, config, response, error;
        return (0, $ca8679453dfc275b$export$71511d61b312f219)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        (0, $cdc9be61cf79477c$export$2e2bcd8739ae039).getRoutes()
                    ];
                case 1:
                    routes = _state.sent();
                    config = {
                        headers: {
                            "Access-Control-Allow-Origin": routes.backendAuthServer
                        },
                        withCredentials: true
                    };
                    return [
                        4,
                        (0, $0ed3984fa928546b$export$2e2bcd8739ae039).post(routes.backendAuthServer + "/updatePassword", {
                            username: document.getElementById("username").value,
                            currentPassword: document.getElementById("currentPassword").value,
                            newPassword: document.getElementById("newPassword").value,
                            confirmNewPassword: document.getElementById("confirmNewPass").value
                        }, config)
                    ];
                case 2:
                    response = _state.sent();
                    return [
                        2,
                        (response === null || response === void 0 ? void 0 : (_response_data = response.data) === null || _response_data === void 0 ? void 0 : _response_data.success) ? true : false
                    ];
                case 3:
                    error = _state.sent();
                    return [
                        2,
                        false
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    })();
}
function $0da753eadb345b64$var$showUpdateSuccess() {
    // Show the success message div
    var messageDiv = document.getElementById("updatePasswordMessage");
    messageDiv.style.display = "block";
    messageDiv.style.color = "#14AE5C";
    messageDiv.textContent = document.lang.PasswordSuccessfullyUpdatedLoginAgain;
    // Reset the form and show login
    document.getElementById("newPwExpired").style.display = "none";
    document.getElementById("loginForm").style.display = "";
    document.getElementById("signUpDiv").style.display = "";
    document.getElementById("legalTermsSection").style.display = "";
    // Clear the password fields
    document.getElementById("password").value = "";
    document.getElementById("currentPassword").value = "";
    document.getElementById("newPassword").value = "";
    document.getElementById("confirmNewPass").value = "";
}
function $0da753eadb345b64$var$showUpdateError() {
    var messageDiv = document.getElementById("updatePasswordMessage");
    messageDiv.style.display = "block";
    messageDiv.style.color = "#FF0000";
    messageDiv.textContent = document.lang.ErrorUpdatingPasswordContactSupport;
}
function $0da753eadb345b64$var$showCurrentPasswordValidationError() {
    var currentPasswordElement = document.getElementById("currentPassword");
    var errorElement = document.getElementById("currentPasswordFieldError");
    var wrapperElement = currentPasswordElement.closest(".wrap-input");
    errorElement.style.display = "";
    errorElement.textContent = "Current Password is incorrect";
    wrapperElement.classList.toggle("has-error", true);
}
function $0da753eadb345b64$var$login() {
    document.getElementById("loading").style.display = "flex";
    $0da753eadb345b64$var$setAllLogoDisplays("none");
    document.getElementById("loginErr").style.display = "none";
    return (0, $cdc9be61cf79477c$export$2e2bcd8739ae039).getRoutes().then(function(routes) {
        //post to N.cali auth server to find out which region
        var config = {
            headers: {
                "Access-Control-Allow-Origin": routes.backendAuthServer
            },
            withCredentials: true
        };
        (0, $0ed3984fa928546b$export$2e2bcd8739ae039).post(function() {
            var params = new URLSearchParams(window.location.search);
            var redirectUrlParam = params.get("redirect_uri");
            var base = routes.backendAuthServer + "/login";
            return redirectUrlParam ? "".concat(base, "?redirect_uri=").concat(encodeURIComponent(redirectUrlParam)) : base;
        }(), {
            username: document.getElementById("username").value,
            password: document.getElementById("password").value,
            isMobile: $0da753eadb345b64$var$checkMobile()
        }, config).then(function(response) {
            if (response.data.success) {
                // console.log(response.data);
                $0da753eadb345b64$var$setCookie("languageCookie", $0da753eadb345b64$var$getCookie("languageCookie"), 365);
                //save pass info here.
                var box3 = document.getElementById("box3");
                if (box3 && box3.checked) $0da753eadb345b64$var$setLoginLocalStorage(document.getElementById("username").value, document.getElementById("password").value);
                else $0da753eadb345b64$var$clearLoginLocalStorage($0da753eadb345b64$var$userField, $0da753eadb345b64$var$passField);
                $0da753eadb345b64$var$deleteUnusedCookies(response.data.link);
                /*
                  The server is going to have to return the URL they should be directed to..... Only it can know what creds each user has...
               */ //if there is a document.referrer then they came here un-authenticated from an app subdomain so save that and once logged in shoot them over to where they were trying to go
                //catch if there is a document referrer. This is for white label customers. If they are a white label customer their subdomain will point to the app server, if they are not logged in they will be forwarded to auth.limblecmms.com where the logo will get replaced based on document referrer, and this will send them to their sub-domain app server
                // if (
                //    document.referrer.includes(".limblecmms.com") &&
                //    !document.referrer.includes("https://limblecmms.com") &&
                //    !document.referrer.includes("https://www.limblecmms.com")
                // ) {
                //This needs to be a bit smarter for white label customers and direct them to the page they have access to, but also the white label domain. Find a way to do this without string replacing... hopefully.
                //    window.location.href = document.referrer;
                // } else {
                if ($0da753eadb345b64$var$isESignatureVerification) {
                    window.sessionStorage.removeItem("loginAttemptNumber");
                    window.parent.postMessage({
                        success: true,
                        user: response.data.user
                    }, routes.appUrl);
                } else if ($0da753eadb345b64$var$isOAuth) ;
                else {
                    var redirectUrl = $0da753eadb345b64$var$evaluateRedirectUri(response.data.link);
                    $0da753eadb345b64$var$navigateToApp(redirectUrl);
                }
                // }
                //if remember me was checked then store their username and password in a cookie
                $0da753eadb345b64$var$eventBus.publish("login", response.data);
            } else if (response.data.success == false && response.data.pwExpired == true) {
                if ($0da753eadb345b64$var$USE_NEW_PW_EXPIRED) {
                    $0da753eadb345b64$var$togglePwExpiredVisibility();
                    $0da753eadb345b64$var$addEventListenersToPasswords();
                } else {
                    document.getElementById("loading").style.display = "none";
                    //display forgot my password modal with a message telling the user their password expired and will have to reset it via email
                    openModal();
                    document.getElementById("pwExpired").style.display = "";
                }
            } else {
                //display message saying login failed
                $0da753eadb345b64$var$setAllLogoDisplays("none");
                if (!$0da753eadb345b64$var$isESignatureVerification) document.getElementById("errorContainer").classList.add("p-b-32");
                document.getElementById("loginErr").style.display = "";
            }
        // console.log(response, "response from auth server");
        })["catch"](function(error) {
            $0da753eadb345b64$var$setAllLogoDisplays();
            if (!$0da753eadb345b64$var$isESignatureVerification) document.getElementById("errorContainer").classList.add("p-b-32");
            document.getElementById("loginErr").style.display = "";
            document.getElementById("loading").style.display = "none";
            if (document.getElementById("ssoProviderErr")) document.getElementById("ssoProviderErr").style.display = "block";
            // console.log("CATCH ERROR");
            console.log(error);
            if ($0da753eadb345b64$var$isESignatureVerification) {
                var _window_sessionStorage_getItem;
                var loginAttemptNumber = (_window_sessionStorage_getItem = window.sessionStorage.getItem("loginAttemptNumber")) !== null && _window_sessionStorage_getItem !== void 0 ? _window_sessionStorage_getItem : 0;
                if (loginAttemptNumber >= 3) {
                    window.sessionStorage.removeItem("loginAttemptNumber");
                    window.parent.postMessage({
                        success: false,
                        user: 0
                    }, routes.appUrl);
                    return;
                }
                window.sessionStorage.setItem("loginAttemptNumber", ++loginAttemptNumber);
                $0da753eadb345b64$var$setElementAttribute("loginAttemptNumber", "innerHTML", loginAttemptNumber);
            }
        });
    //get the region return and post to that region's auth server
    });
}
//forgot my password button clicked here.
function $0da753eadb345b64$var$enableForgotPassword() {
    document.getElementById("forgotPwBtn").disabled = false;
}
window.enableForgotPassword = $0da753eadb345b64$var$enableForgotPassword;
function $0da753eadb345b64$var$forgotMyPassword() {
    document.getElementById("forgotPasswordSuccess").style.display = "none";
    if (document.getElementById("forgotMyPasswordUsername").value) return (0, $cdc9be61cf79477c$export$2e2bcd8739ae039).getRoutes().then(function(routes) {
        $0da753eadb345b64$var$setAllLogoDisplays("none");
        //post to N.cali auth server to find out which region
        var config = {
            headers: {
                "Access-Control-Allow-Origin": routes.backendAuthServer
            },
            withCredentials: true
        };
        $0da753eadb345b64$var$isStaging = routes.backendAuthServer && routes.backendAuthServer.includes("staging");
        var requestData = {
            username: document.getElementById("forgotMyPasswordUsername").value,
            hcaptcha_client_response: $0da753eadb345b64$var$isStaging ? "staging-bypass" : hcaptcha.getResponse()
        };
        (0, $0ed3984fa928546b$export$2e2bcd8739ae039).post(routes.backendAuthServer + "/forgotMyPassword", requestData, config).then(function(response) {
            $0da753eadb345b64$var$setAllLogoDisplays();
            document.getElementById("forgotPasswordErrorHandlingStyles").classList.add("p-b-32");
            if (response.data.success) document.getElementById("forgotPasswordSuccess").style.display = "inline";
            else {
                document.getElementById("forgotPasswordSuccess").style.display = "inline";
                document.getElementById("loginErr").style.display = "none";
            }
            // console.log(response, "response from auth server");
            if ($0da753eadb345b64$var$isESignatureVerification) window.parent.postMessage({
                success: null,
                user: 0
            }, routes.appUrl);
        })["catch"](function(error) {
            document.getElementById("forgotPasswordErrorHandlingStyles").classList.add("p-b-32");
            document.getElementById("loginErr").style.display = "";
            console.log(error);
        });
    //get the region return and post to that region's auth server
    });
    else return;
}
var $0da753eadb345b64$var$customerPasswordLength = 8;
var $0da753eadb345b64$var$currentPasswordFieldErrors = [];
var $0da753eadb345b64$var$newPasswordFieldErrors = [];
var $0da753eadb345b64$var$repeatPasswordFieldErrors = [];
function $0da753eadb345b64$var$validateCurrentPassword(currentPassword) {
    $0da753eadb345b64$var$currentPasswordFieldErrors = [];
    if (!currentPassword) {
        var _document_lang_CurrentPasswordIsBlank;
        $0da753eadb345b64$var$currentPasswordFieldErrors.push((_document_lang_CurrentPasswordIsBlank = document.lang.CurrentPasswordIsBlank) !== null && _document_lang_CurrentPasswordIsBlank !== void 0 ? _document_lang_CurrentPasswordIsBlank : "Enter your current password");
        return false;
    }
    return true;
}
function $0da753eadb345b64$var$validateNewPassword(newPassword, currentPassword) {
    $0da753eadb345b64$var$newPasswordFieldErrors = [];
    if (!newPassword) {
        var _document_lang_NewPasswordIsBlank;
        $0da753eadb345b64$var$newPasswordFieldErrors.push((_document_lang_NewPasswordIsBlank = document.lang.NewPasswordIsBlank) !== null && _document_lang_NewPasswordIsBlank !== void 0 ? _document_lang_NewPasswordIsBlank : "Enter your new password");
        return false;
    }
    if (newPassword.length < $0da753eadb345b64$var$customerPasswordLength) {
        var _document_lang, _document;
        var errorMessage;
        if (typeof ((_document = document) === null || _document === void 0 ? void 0 : (_document_lang = _document.lang) === null || _document_lang === void 0 ? void 0 : _document_lang.yourPasswordMustBeAtLeast) == "undefined") errorMessage = "Your password must be at least this many characters: " + " ".concat($0da753eadb345b64$var$customerPasswordLength);
        else errorMessage = document.lang.yourPasswordMustBeAtLeast + ": ".concat($0da753eadb345b64$var$customerPasswordLength);
        $0da753eadb345b64$var$newPasswordFieldErrors.push(errorMessage);
    }
    var _document_lang_PasswordOnlyLettersNumbersCharacters;
    if (!/^[a-zA-Z0-9!@#$%^&*()_+\-=[\]{};':"\\|,.<~`>/?]*$/.test(newPassword)) $0da753eadb345b64$var$newPasswordFieldErrors.push((_document_lang_PasswordOnlyLettersNumbersCharacters = document.lang.PasswordOnlyLettersNumbersCharacters) !== null && _document_lang_PasswordOnlyLettersNumbersCharacters !== void 0 ? _document_lang_PasswordOnlyLettersNumbersCharacters : "Your password can only contain letters, numbers, and special characters.");
    var _document_lang_PasswordMustContainUpperLowerNumberSymbol;
    if (!/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=[\]{};':"\\|,.<~`>/?])/.test(newPassword)) $0da753eadb345b64$var$newPasswordFieldErrors.push((_document_lang_PasswordMustContainUpperLowerNumberSymbol = document.lang.PasswordMustContainUpperLowerNumberSymbol) !== null && _document_lang_PasswordMustContainUpperLowerNumberSymbol !== void 0 ? _document_lang_PasswordMustContainUpperLowerNumberSymbol : "Your password must contain at least one uppercase letter, one lowercase letter, one number, and one special character.");
    var _document_lang_YourNewPasswordCannotMatchYourOldPassword;
    if (currentPassword && currentPassword === newPassword) $0da753eadb345b64$var$newPasswordFieldErrors.push((_document_lang_YourNewPasswordCannotMatchYourOldPassword = document.lang.YourNewPasswordCannotMatchYourOldPassword) !== null && _document_lang_YourNewPasswordCannotMatchYourOldPassword !== void 0 ? _document_lang_YourNewPasswordCannotMatchYourOldPassword : "Your new password cannot match your old password");
    return $0da753eadb345b64$var$newPasswordFieldErrors.length === 0;
}
function $0da753eadb345b64$var$validateRepeatPassword(repeatPassword, newPassword) {
    $0da753eadb345b64$var$repeatPasswordFieldErrors = [];
    if (!repeatPassword) {
        var _document_lang_ConfirmNewPasswordIsBlank;
        $0da753eadb345b64$var$repeatPasswordFieldErrors.push((_document_lang_ConfirmNewPasswordIsBlank = document.lang.ConfirmNewPasswordIsBlank) !== null && _document_lang_ConfirmNewPasswordIsBlank !== void 0 ? _document_lang_ConfirmNewPasswordIsBlank : "Enter your new password again");
        return false;
    }
    if (newPassword && newPassword !== repeatPassword) {
        var _document_lang_NewPasswordsDontMatchReenter;
        $0da753eadb345b64$var$repeatPasswordFieldErrors.push((_document_lang_NewPasswordsDontMatchReenter = document.lang.NewPasswordsDontMatchReenter) !== null && _document_lang_NewPasswordsDontMatchReenter !== void 0 ? _document_lang_NewPasswordsDontMatchReenter : "New passwords do not match. Update and try again.");
        return false;
    }
    return true;
}
function $0da753eadb345b64$var$getCustomerPasswordRequirements() {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $03857362ebfa6f2c$export$71511d61b312f219)(function() {
        return (0, $ca8679453dfc275b$export$71511d61b312f219)(this, function(_state) {
            if (document.getElementById("username").value) return [
                2,
                (0, $cdc9be61cf79477c$export$2e2bcd8739ae039).getRoutes().then(function(routes) {
                    //post to N.cali auth server to find out which region
                    var config = {
                        headers: {
                            "Access-Control-Allow-Origin": routes.backendAuthServer
                        },
                        withCredentials: true
                    };
                    (0, $0ed3984fa928546b$export$2e2bcd8739ae039).post(routes.backendAuthServer + "/passwordMinLength", {
                        username: document.getElementById("username").value
                    }, config).then(function(response) {
                        if (response.data.success) $0da753eadb345b64$var$customerPasswordLength = response.data.pwMinLength;
                        else $0da753eadb345b64$var$customerPasswordLength = 8;
                        $0da753eadb345b64$var$updatePasswordExpiredLengthWarning($0da753eadb345b64$var$customerPasswordLength);
                    })["catch"](function() {
                        $0da753eadb345b64$var$customerPasswordLength = 8;
                        $0da753eadb345b64$var$updatePasswordExpiredLengthWarning($0da753eadb345b64$var$customerPasswordLength);
                    });
                })
            ];
            else return [
                2
            ];
            return [
                2
            ];
        });
    })();
}
function $0da753eadb345b64$var$updatePasswordExpiredLengthWarning(minLength) {
    var _document_lang, _document;
    var lengthWarningSpan = document.getElementById("pwExpiredLengthWarning");
    var errorMessage;
    if (typeof ((_document = document) === null || _document === void 0 ? void 0 : (_document_lang = _document.lang) === null || _document_lang === void 0 ? void 0 : _document_lang.yourPasswordMustBeAtLeast) == "undefined") errorMessage = "Your password must be at least this many characters: " + " ".concat(minLength);
    else errorMessage = document.lang.yourPasswordMustBeAtLeast + ": ".concat(minLength);
    $0da753eadb345b64$var$newPasswordFieldErrors.push(errorMessage);
    if (lengthWarningSpan) lengthWarningSpan.textContent = errorMessage;
}
function $0da753eadb345b64$var$togglePwExpiredVisibility() {
    document.getElementById("loading").style.display = "none";
    document.getElementById("loginForm").style.display = "none";
    document.getElementById("newPwExpired").style.display = "";
    document.getElementById("signUpDiv").style.display = "none";
    document.getElementById("legalTermsSection").style.display = "none";
    $0da753eadb345b64$var$getCustomerPasswordRequirements();
    $0da753eadb345b64$var$setAllLogoDisplays("");
}
function $0da753eadb345b64$var$setupPasswordVisibilityToggle(toggleId, passwordId) {
    var toggleButton = document.querySelector("#".concat(toggleId));
    var passwordField = document.querySelector("#".concat(passwordId));
    toggleButton === null || toggleButton === void 0 ? void 0 : toggleButton.addEventListener("click", function() {
        var type = passwordField.getAttribute("type") === "password" ? "text" : "password";
        passwordField.setAttribute("type", type);
        this.classList.toggle("fa-eye-slash");
        this.classList.toggle("fa-eye");
    });
}
function $0da753eadb345b64$var$addEventListenersToPasswords() {
    var currentPasswordField = document.getElementById("currentPassword");
    var newPasswordField = document.getElementById("newPassword");
    var confirmNewPass = document.getElementById("confirmNewPass");
    var updatePasswordBtn = document.getElementById("updatePasswordBtn");
    if (currentPasswordField && newPasswordField && confirmNewPass) {
        currentPasswordField.addEventListener("blur", function() {
            var isValid = $0da753eadb345b64$var$validateCurrentPassword(this.value);
            var errorElement = document.getElementById("currentPasswordFieldError");
            var wrapperElement = this.closest(".wrap-input");
            errorElement.textContent = $0da753eadb345b64$var$currentPasswordFieldErrors.join(",\n");
            errorElement.style.display = isValid ? "none" : "";
            wrapperElement.classList.toggle("has-error", !isValid);
        });
        newPasswordField.addEventListener("blur", function() {
            var isValid = $0da753eadb345b64$var$validateNewPassword(this.value, currentPasswordField.value);
            var errorElement = document.getElementById("newPasswordFieldError");
            var wrapperElement = this.closest(".wrap-input");
            errorElement.textContent = $0da753eadb345b64$var$newPasswordFieldErrors.join(",\n");
            errorElement.style.display = isValid ? "none" : "";
            wrapperElement.classList.toggle("has-error", !isValid);
        });
        confirmNewPass.addEventListener("blur", function() {
            var isValid = $0da753eadb345b64$var$validateRepeatPassword(this.value, newPasswordField.value);
            var errorElement = document.getElementById("confirmNewPassFieldError");
            var wrapperElement = this.closest(".wrap-input");
            errorElement.textContent = $0da753eadb345b64$var$repeatPasswordFieldErrors.join(",\n");
            errorElement.style.display = isValid ? "none" : "";
            wrapperElement.classList.toggle("has-error", !isValid);
        });
        // Set up toggle functionality for all password fields
        $0da753eadb345b64$var$setupPasswordVisibilityToggle("toggleCurrentPassword", "currentPassword");
        $0da753eadb345b64$var$setupPasswordVisibilityToggle("toggleNewPassword", "newPassword");
        $0da753eadb345b64$var$setupPasswordVisibilityToggle("toggleConfirmNewPass", "confirmNewPass");
        // turn on the update password button
        updatePasswordBtn.addEventListener("click", function(e) {
            e.preventDefault();
            var isCurrentPasswordValid = $0da753eadb345b64$var$validateCurrentPassword(currentPasswordField.value);
            var isNewPasswordValid = $0da753eadb345b64$var$validateNewPassword(newPasswordField.value, currentPasswordField.value);
            var isConfirmPasswordValid = $0da753eadb345b64$var$validateRepeatPassword(confirmNewPass.value, newPasswordField.value);
            if (isCurrentPasswordValid && isNewPasswordValid && isConfirmPasswordValid) // All validations passed, proceed with password update
            $0da753eadb345b64$var$submitPasswordUpdate(currentPasswordField.value, newPasswordField.value);
        });
    }
}
var $0da753eadb345b64$var$src = (0, (/*@__PURE__*/$parcel$interopDefault($817bc92a38d06f3b$exports)));
function $0da753eadb345b64$var$checkWhiteLabelDomainMatch(domain) {
    if (document.referrer.includes(domain)) return true;
    else if ($0da753eadb345b64$var$getCookie("whiteLabelSubDomain").includes(domain)) return true;
    else return false;
}
if ($0da753eadb345b64$var$checkWhiteLabelDomainMatch("dhl.limblecmms.com")) $0da753eadb345b64$var$src = (0, (/*@__PURE__*/$parcel$interopDefault($8416a8c05b6cd586$exports)));
else if ($0da753eadb345b64$var$checkWhiteLabelDomainMatch("neutron.limblecmms.com")) $0da753eadb345b64$var$src = (0, (/*@__PURE__*/$parcel$interopDefault($56764195ae0a7bb6$exports)));
else if ($0da753eadb345b64$var$checkWhiteLabelDomainMatch("enco.limblecmms.com")) $0da753eadb345b64$var$src = (0, (/*@__PURE__*/$parcel$interopDefault($1b7f251a08f28c57$exports)));
else if ($0da753eadb345b64$var$checkWhiteLabelDomainMatch("deliver-ez.limblecmms.com")) $0da753eadb345b64$var$src = (0, (/*@__PURE__*/$parcel$interopDefault($bf238252a34a27d9$exports)));
else if ($0da753eadb345b64$var$checkWhiteLabelDomainMatch("epic.limblecmms.com")) $0da753eadb345b64$var$src = (0, (/*@__PURE__*/$parcel$interopDefault($c4ba49442065b6ca$exports)));
else if ($0da753eadb345b64$var$checkWhiteLabelDomainMatch("iotplus.limblecmms.com")) $0da753eadb345b64$var$src = (0, (/*@__PURE__*/$parcel$interopDefault($e79439daf03dee95$exports)));
else if ($0da753eadb345b64$var$checkWhiteLabelDomainMatch("invata.limblecmms.com")) $0da753eadb345b64$var$src = (0, (/*@__PURE__*/$parcel$interopDefault($693fa0ef2078e6e2$exports)));
else if ($0da753eadb345b64$var$checkWhiteLabelDomainMatch("netswat.limblecmms.com")) $0da753eadb345b64$var$src = (0, (/*@__PURE__*/$parcel$interopDefault($764ccf2d8ae08b2d$exports)));
else if ($0da753eadb345b64$var$checkWhiteLabelDomainMatch("demirer.limblecmms.com")) $0da753eadb345b64$var$src = (0, (/*@__PURE__*/$parcel$interopDefault($8727c3eca8835207$exports)));
else if ($0da753eadb345b64$var$checkWhiteLabelDomainMatch("scandinaviandrone.limblecmms.com")) $0da753eadb345b64$var$src = (0, (/*@__PURE__*/$parcel$interopDefault($4e417c0cc15b8ca6$exports)));
else if ($0da753eadb345b64$var$checkWhiteLabelDomainMatch("comstockfs.limblecmms.com")) $0da753eadb345b64$var$src = (0, (/*@__PURE__*/$parcel$interopDefault($348701764c2bd8b4$exports)));
else if ($0da753eadb345b64$var$checkWhiteLabelDomainMatch("harrigan.limblecmms.com")) $0da753eadb345b64$var$src = (0, (/*@__PURE__*/$parcel$interopDefault($bcdc7d441764fae4$exports)));
else if ($0da753eadb345b64$var$checkWhiteLabelDomainMatch("sentegrity.limblecmms.com")) $0da753eadb345b64$var$src = (0, (/*@__PURE__*/$parcel$interopDefault($aa8e5f4a104c700c$exports)));
else if ($0da753eadb345b64$var$checkWhiteLabelDomainMatch("dartbrook.limblecmms.com")) $0da753eadb345b64$var$src = (0, (/*@__PURE__*/$parcel$interopDefault($81e79c754f2a79df$exports)));
else if ($0da753eadb345b64$var$checkWhiteLabelDomainMatch("redaptive.limblecmms.com")) $0da753eadb345b64$var$src = (0, (/*@__PURE__*/$parcel$interopDefault($dbbb3d9e20ea29f2$exports)));
else if ($0da753eadb345b64$var$checkWhiteLabelDomainMatch("johndeere.limblecmms.com")) $0da753eadb345b64$var$src = (0, (/*@__PURE__*/$parcel$interopDefault($ff99b281d4dfa046$exports)));
else if ($0da753eadb345b64$var$checkWhiteLabelDomainMatch("kettering.limblecmms.com")) $0da753eadb345b64$var$src = (0, (/*@__PURE__*/$parcel$interopDefault($a41da7ceca394982$exports)));
else if ($0da753eadb345b64$var$checkWhiteLabelDomainMatch("homefix.limblecmms.com")) $0da753eadb345b64$var$src = (0, (/*@__PURE__*/$parcel$interopDefault($d08bbdc2f24b399f$exports)));
else if ($0da753eadb345b64$var$checkWhiteLabelDomainMatch("intelsat.limblecmms.com")) $0da753eadb345b64$var$src = (0, (/*@__PURE__*/$parcel$interopDefault($211e097e8f6d2ed4$exports)));
else if ($0da753eadb345b64$var$checkWhiteLabelDomainMatch("jbmpackaging.limblecmms.com")) $0da753eadb345b64$var$src = (0, (/*@__PURE__*/$parcel$interopDefault($4d2f521885f503f6$exports)));
else if ($0da753eadb345b64$var$checkWhiteLabelDomainMatch("access.limblecmms.com")) $0da753eadb345b64$var$src = (0, (/*@__PURE__*/$parcel$interopDefault($d660adff451f9287$exports)));
else if ($0da753eadb345b64$var$checkWhiteLabelDomainMatch("canyonridgeservices.limblecmms.com")) $0da753eadb345b64$var$src = (0, (/*@__PURE__*/$parcel$interopDefault($f30134bb02fbde57$exports)));
else if ($0da753eadb345b64$var$checkWhiteLabelDomainMatch("watermarkcommunitychurch.limblecmms.com")) $0da753eadb345b64$var$src = (0, (/*@__PURE__*/$parcel$interopDefault($03460c1d1ba95f4f$exports)));
else if ($0da753eadb345b64$var$checkWhiteLabelDomainMatch("oregonfoodbank.limblecmms.com")) $0da753eadb345b64$var$src = (0, (/*@__PURE__*/$parcel$interopDefault($2afaddfbd93549dc$exports)));
else if ($0da753eadb345b64$var$checkWhiteLabelDomainMatch("gbc.limblecmms.com")) $0da753eadb345b64$var$src = (0, (/*@__PURE__*/$parcel$interopDefault($c49eb67cea6617a4$exports)));
else if ($0da753eadb345b64$var$checkWhiteLabelDomainMatch("tqlfacilities.limblecmms.com")) $0da753eadb345b64$var$src = (0, (/*@__PURE__*/$parcel$interopDefault($9b252ea871487885$exports)));
var $0da753eadb345b64$var$logos = document.getElementsByClassName("logo");
for(var $0da753eadb345b64$var$i = 0; $0da753eadb345b64$var$i < $0da753eadb345b64$var$logos.length; ++$0da753eadb345b64$var$i){
    var $0da753eadb345b64$var$item = $0da753eadb345b64$var$logos[$0da753eadb345b64$var$i];
    $0da753eadb345b64$var$item.src = $0da753eadb345b64$var$src;
}
/*

END OF WHITE LABEL CUSTOMER SECTION

*/ //if remember me is checked then store creds inside of local storage? or maybe not just use secure cookie?
//read the customer's lang cookie and set the front end to foriegn language
/*
   Language Setting
*/ //default setting is english
//Talk to nathan about this maybe? Lang files are pretty big maybe it's better to not load them all on page load
//if not lang cookie then default to english first
// setCookie("languageCookie", "english", 365);
//else read lang cookie and select that language first.
// console.log(getCookie('languageCookie'));
if (!$0da753eadb345b64$var$getCookie("languageCookie")) {
    $0da753eadb345b64$var$setCookie("languageCookie", "english", 365);
    $0da753eadb345b64$var$loadLang("english");
} else {
    var $0da753eadb345b64$var$lang = $0da753eadb345b64$var$getCookie("languageCookie");
    $0da753eadb345b64$var$loadLang($0da753eadb345b64$var$lang);
}
var $0da753eadb345b64$var$queryString = window.location.search;
var $0da753eadb345b64$var$urlParams = new URLSearchParams($0da753eadb345b64$var$queryString);
var $0da753eadb345b64$var$error = $0da753eadb345b64$var$urlParams.get("error");
var $0da753eadb345b64$var$idp = $0da753eadb345b64$var$urlParams.get("idp");
if ($0da753eadb345b64$var$idp == "true" && $0da753eadb345b64$var$getCookie("ssoUsername")) $0da753eadb345b64$var$determineSSOProvider($0da753eadb345b64$var$getCookie("ssoUsername")).then(function(answer) {
    window.location.href = answer.data.ssoUrl;
});
document.getElementById("ssoProviderErr").innerHTML = $0da753eadb345b64$var$error;
function $0da753eadb345b64$var$setFrontEnd() {
    // Due to time constraints, some phrases in esignature verification will not be translated
    if (!$0da753eadb345b64$var$isESignatureVerification) {
        $0da753eadb345b64$var$setElementAttribute("loginErr", "innerHTML", document.lang.LoginErrorCheckUsernamePassword);
        $0da753eadb345b64$var$setElementAttribute("loginBtn", "innerHTML", document.lang.login);
    }
    var loginAttemptNumber = window.sessionStorage.getItem("loginAttemptNumber");
    if ($0da753eadb345b64$var$isESignatureVerification && loginAttemptNumber > 0) {
        document.getElementById("loginErr").style.display = "";
        $0da753eadb345b64$var$setElementAttribute("loginAttemptNumber", "innerHTML", loginAttemptNumber);
    }
    var languageCookieString = $0da753eadb345b64$var$getCookie("languageCookie");
    if (languageCookieString === "english") $0da753eadb345b64$var$setElementAttribute("slogan", "innerHTML", "<span id='empowerTextSwoosh'>Empower<img id='empowerImage' /></span> the unsung heroes that support the world");
    else $0da753eadb345b64$var$setElementAttribute("slogan", "innerHTML", document.lang.EmpowerSlogan);
    $0da753eadb345b64$var$setInternationalization();
    document.getElementById("sso").addEventListener("click", $0da753eadb345b64$var$enterSSOUsernameManually);
    document.getElementById("forgotMyPasswordBtn").addEventListener("click", $0da753eadb345b64$var$forgotPasswordClicked);
    document.getElementById("forgot-back-button").addEventListener("click", $0da753eadb345b64$var$backButtonClicked);
    document.getElementById("sso-back-button").addEventListener("click", $0da753eadb345b64$var$backButtonClicked);
    var params = new Proxy(new URLSearchParams(window.location.search), {
        get: function(searchParams, prop) {
            return searchParams.get(prop);
        }
    });
    if (params.autofill === "true") {
        $0da753eadb345b64$var$setElementAttribute("username", "value", params.username);
        $0da753eadb345b64$var$setElementAttribute("ssoUsername", "value", params.userEmail);
    }
}
function $0da753eadb345b64$var$setInternationalization() {
    $0da753eadb345b64$var$setElementAttribute("empowerImage", "src", (0, (/*@__PURE__*/$parcel$interopDefault($b16cc018ba132783$exports))));
    $0da753eadb345b64$var$setElementAttribute("forgotMyPasswordBtn", "innerHTML", document.lang.forgotPassword);
    $0da753eadb345b64$var$setElementAttribute("rememberMe", "innerHTML", document.lang.rememberMe);
    $0da753eadb345b64$var$setElementAttribute("dontHaveAnAccount", "innerHTML", document.lang.DoesYourCompanyNotHaveAnAccount);
    $0da753eadb345b64$var$setElementAttribute("email-login-label-text", "innerHTML", document.lang.username);
    $0da753eadb345b64$var$setElementAttribute("emailTooltip", "title", document.lang.UsernameLoginTooltip);
    $0da753eadb345b64$var$setElementAttribute("password-login-label", "innerHTML", document.lang.password);
    $0da753eadb345b64$var$setElementAttribute("forgotMyPasswordUsernameLabel", "innerHTML", document.lang.username);
    $0da753eadb345b64$var$setElementAttribute("forgotPwBtn", "innerHTML", document.lang.ResetPassword);
    $0da753eadb345b64$var$setElementAttribute("forgotPasswordInstruction", "innerHTML", document.lang.ForgotPasswordResetInstructions);
    $0da753eadb345b64$var$setElementAttribute("forgot-back-button", "innerHTML", document.lang.BackToMainPage);
    $0da753eadb345b64$var$setElementAttribute("signUpLink", "innerHTML", " " + document.lang.SignUp + " ");
    $0da753eadb345b64$var$setElementAttribute("sso-back-button", "innerHTML", document.lang.BackToMainPage);
    $0da753eadb345b64$var$setElementAttribute("legalTermsSection", "innerHTML", document.lang.LegalCopy);
    $0da753eadb345b64$var$setElementAttribute("pwExpiredOrgPolicy", "innerHTML", document.lang.UpdatePasswordEvery90Days);
    $0da753eadb345b64$var$setElementAttribute("pwExpiredLengthWarningText", "innerHTML", document.lang.yourPasswordMustBeAtLeast + ": 8");
    $0da753eadb345b64$var$setElementAttribute("updatePasswordBtn", "innerHTML", document.lang.UpdatePassword);
    $0da753eadb345b64$var$setElementAttribute("current-password-label", "innerHTML", document.lang.CurrentPassword);
    $0da753eadb345b64$var$setElementAttribute("new-password-label", "innerHTML", document.lang.NewPassword);
    $0da753eadb345b64$var$setElementAttribute("repeat-password-label", "innerHTML", document.lang.ConfirmNewPassword);
}
function $0da753eadb345b64$var$setElementAttribute(elementId, attribute, value) {
    var element = document.getElementById(elementId);
    if (element) element[attribute] = value;
}
function $0da753eadb345b64$var$determineSSOProvider(username) {
    var oauthInteraction = "";
    if ($0da753eadb345b64$var$isOAuth) oauthInteraction = window.location.pathname.split("/").pop();
    // Forward the webApp returnUrl (set as a query param on this page) so
    // /ssoLogin can redirect the user back to where they started after an
    // e-signature SSO round-trip.
    var params = new URLSearchParams(window.location.search);
    var returnUrl = params.get("returnUrl") || "";
    return (0, $cdc9be61cf79477c$export$2e2bcd8739ae039).getRoutes().then(function(routes) {
        var config = {
            headers: {
                "Access-Control-Allow-Origin": routes.backendAuthServer
            },
            withCredentials: true
        };
        return (0, $0ed3984fa928546b$export$2e2bcd8739ae039).post(routes.backendAuthServer + "/checkProvider", {
            username: username,
            isMobile: $0da753eadb345b64$var$checkMobile(),
            oauthInteraction: oauthInteraction,
            returnUrl: returnUrl
        }, config).then(function(answer) {
            return answer;
        });
    });
}
function $0da753eadb345b64$var$verifyESignatureVerificationToken() {
    return (0, $cdc9be61cf79477c$export$2e2bcd8739ae039).getRoutes().then(function(routes) {
        var config = {
            headers: {
                "Access-Control-Allow-Origin": routes.backendAuthServer
            },
            withCredentials: true
        };
        return (0, $0ed3984fa928546b$export$2e2bcd8739ae039).post(routes.backendAuthServer + "/verifyESignatureVerificationToken", {}, config).then(function(answer) {
            return answer;
        });
    });
}
function $0da753eadb345b64$var$forgotPasswordClicked() {
    document.getElementById("loginForm").style.display = "none";
    document.getElementById("manualForgotPassword").style.display = "block";
    if ($0da753eadb345b64$var$isESignatureVerification) {
        document.getElementById("login-btn-container").style.display = "none";
        document.getElementById("forgot-password-btn-container").style.display = "flex";
        document.getElementById("forgot-password-warning").style.display = "block";
        $0da753eadb345b64$var$setElementAttribute("main-title", "innerHTML", "Forgot Password?");
        $0da753eadb345b64$var$setElementAttribute("subtitle", "innerHTML", "Please enter your username to receive an email to reset your password.");
    }
}
function $0da753eadb345b64$var$backButtonClicked() {
    document.getElementById("loginForm").style.display = "";
    document.getElementById("manualSSOUsername").style.display = "none";
    document.getElementById("manualForgotPassword").style.display = "none";
    document.getElementById("newPwExpired").style.display = "none";
    document.getElementById("updatePasswordMessage").style.display = "none";
    if ($0da753eadb345b64$var$isESignatureVerification) {
        document.getElementById("login-btn-container").style.display = "flex";
        document.getElementById("sso-btn-container").style.display = "none";
        document.getElementById("forgot-password-btn-container").style.display = "none";
        document.getElementById("forgot-password-warning").style.display = "none";
        $0da753eadb345b64$var$setElementAttribute("main-title", "innerHTML", "Please verify your identity");
        $0da753eadb345b64$var$setElementAttribute("subtitle", "innerHTML", "I verify that I am the author of this signature.");
    }
}
function $0da753eadb345b64$var$enterSSOUsernameManually() {
    document.getElementById("loginForm").style.display = "none";
    document.getElementById("manualSSOUsername").style.display = "block";
    if ($0da753eadb345b64$var$getCookie("ssoUsername")) $0da753eadb345b64$var$setElementAttribute("ssoUsername", "value", $0da753eadb345b64$var$getCookie("ssoUsername"));
    document.getElementById("ssoUsernameSubmit").addEventListener("click", function() {
        $0da753eadb345b64$var$submitSSOUsername();
    });
    if ($0da753eadb345b64$var$isESignatureVerification) {
        document.getElementById("login-btn-container").style.display = "none";
        document.getElementById("sso-btn-container").style.display = "flex";
        $0da753eadb345b64$var$setElementAttribute("main-title", "innerHTML", "Verify with SSO");
    }
}
function $0da753eadb345b64$var$submitSSOUsername() {
    var username = document.getElementById("ssoUsername").value;
    $0da753eadb345b64$var$determineSSOProvider(username).then(function(answer) {
        var _answer_data = answer.data, ssoUrl = _answer_data.ssoUrl, success = _answer_data.success, eSignatureUseNewFlow = _answer_data.eSignatureUseNewFlow;
        if (success) {
            if ($0da753eadb345b64$var$isESignatureVerification) {
                $0da753eadb345b64$var$handleESignatureSSOLogin(ssoUrl, !!eSignatureUseNewFlow);
                return;
            }
            window.location.href = ssoUrl;
        }
    })["catch"](function(e) {
        document.getElementById("ssoLoginErr").style.display = "block";
    });
}
function $0da753eadb345b64$var$handleESignatureSSOLogin(ssoUrl, useNewFlow) {
    if (useNewFlow) // New flow (gated by `esig-update-202605`): ask the parent webApp to
    // navigate the top window to the IdP. iOS Safari blocks window.open()
    // from cross-origin iframes and ITP prevents the iframe from reading the
    // auth-server cookie set by a popup, so we can't poll for it.
    return (0, $cdc9be61cf79477c$export$2e2bcd8739ae039).getRoutes().then(function(routes) {
        window.parent.postMessage({
            type: "esign-sso-redirect",
            url: ssoUrl
        }, routes.appUrl);
    });
    // Legacy flow: pop a window to the IdP and poll for the cookie that the
    // /ssoLogin callback drops on the auth-server domain. Works on Chrome/desktop
    // browsers without ITP restrictions.
    var popup = window.open(ssoUrl, "ssoLogin", "popup=true, width=200, height=200");
    if (!popup) {
        window.alert("Please disable your popup blocker and try again.");
        return;
    }
    return (0, $cdc9be61cf79477c$export$2e2bcd8739ae039).getRoutes().then(function(routes) {
        var interval = setInterval(function() {
            var eSignatureVerificationToken = $0da753eadb345b64$var$getCookie("eSignatureVerificationToken");
            if (eSignatureVerificationToken) {
                clearInterval(interval);
                popup.close();
                $0da753eadb345b64$var$verifyESignatureVerificationToken().then(function(answer) {
                    $0da753eadb345b64$var$delete_cookie("eSignatureVerificationToken", "/");
                    window.sessionStorage.removeItem("loginAttemptNumber");
                    window.parent.postMessage({
                        success: answer.data.success,
                        user: answer.data.userID
                    }, routes.appUrl);
                });
            }
        }, 1000);
    });
}
document.getElementById("manualSSOUsername").addEventListener("keydown", function(event) {
    if (event.key == "Enter") $0da753eadb345b64$var$submitSSOUsername();
}, false);
function $0da753eadb345b64$var$setCookie(cname, value) {
    var d = new Date();
    d.setTime(d.getTime() + 2592000000);
    var expires = "expires=" + d.toUTCString();
    if (window.location.hostname.includes("localhost")) {
        $0da753eadb345b64$var$delete_cookie(cname, "/", "");
        document.cookie = cname + "=" + value + ";" + expires + ";";
    } else {
        $0da753eadb345b64$var$delete_cookie(cname, "/", "limblecmms.com");
        document.cookie = cname + "=" + value + ";" + expires + ";Domain=limblecmms.com";
    }
}
function $0da753eadb345b64$var$delete_cookie(name, path, domain) {
    if ($0da753eadb345b64$var$getCookie(name)) document.cookie = name + "=" + (path ? ";path=" + path : "") + (domain ? ";domain=" + domain : "") + ";expires=Thu, 01 Jan 1970 00:00:01 GMT";
}
function $0da753eadb345b64$var$getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(";");
    for(var i = 0; i < ca.length; i++){
        var c = ca[i];
        while(c.charAt(0) == " ")c = c.substring(1);
        if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
    }
    return "";
}
function $0da753eadb345b64$var$getCookies(prefixes) {
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(";");
    var found = [];
    for(var i = 0; i < ca.length; i++){
        var c = ca[i];
        while(c.charAt(0) == " ")c = c.substring(1);
        for(var j = 0; j < prefixes.length; j++)if (c.indexOf(prefixes[j]) == 0) {
            var r = c.split("=", 2);
            found[r[0]] = r[1];
            break;
        }
    }
    return found;
}
/**
 * Deletes old cookies that are no longer used.
 */ function $0da753eadb345b64$var$deleteUnusedCookies(redirect) {
    var prefixes = [
        "ph_phc"
    ];
    // temporary until we completely move CDN providers
    if (!/^https:\/\/(?:21cfr-)?app\.limblecmms\.com/.test(redirect)) // clear imperva cookies unless we redirecting to us-prod or 21cfr
    prefixes.push("incap", "visid_incap");
    var cookies = $0da753eadb345b64$var$getCookies(prefixes);
    var domains = $0da753eadb345b64$var$calculateCookieDomains();
    for(var domain in domains)for(var key in cookies)$0da753eadb345b64$var$delete_cookie(key, "/", domain);
}
/**
 * Calculates all possible cookie domains for the current hostname.
 * @returns {Object} An object with all possible cookie domains as keys.
 */ function $0da753eadb345b64$var$calculateCookieDomains() {
    var carry = document.location.hostname;
    var domains = {};
    domains[""] = true;
    while(carry.indexOf(".") != carry.lastIndexOf(".")){
        carry = carry.split(".").slice(1).join(".");
        domains[carry] = true;
    }
    return domains;
}



































function $0da753eadb345b64$var$loadLang(lang) {
    if (lang == "english") {
        var en = (parcelRequire("7ErNH"));
        en.then(function(en) {
            document.lang = en;
            $0da753eadb345b64$var$setFrontEnd();
            $0da753eadb345b64$var$setCookie("languageCookie", "english");
        });
    } else if (lang == "estonian") {
        var et = (parcelRequire("9Rj4S"));
        et.then(function(et) {
            document.lang = et;
            $0da753eadb345b64$var$setCookie("languageCookie", "estonian");
            $0da753eadb345b64$var$setFrontEnd();
        });
    } else if (lang == "slovenian") {
        var sl = (parcelRequire("kq5Gg"));
        sl.then(function(sl) {
            document.lang = sl;
            $0da753eadb345b64$var$setCookie("languageCookie", "slovenian");
            $0da753eadb345b64$var$setFrontEnd();
        });
    } else if (lang == "spanish") {
        var es = (parcelRequire("79Dca"));
        es.then(function(es) {
            document.lang = es;
            $0da753eadb345b64$var$setCookie("languageCookie", "spanish");
            $0da753eadb345b64$var$setFrontEnd();
        });
    } else if (lang == "thai") {
        var th = (parcelRequire("2aA9k"));
        th.then(function(th) {
            document.lang = th;
            $0da753eadb345b64$var$setCookie("languageCookie", "thai");
            $0da753eadb345b64$var$setFrontEnd();
        });
    } else if (lang == "french") {
        var fr = (parcelRequire("fQjVH"));
        fr.then(function(fr) {
            document.lang = fr;
            $0da753eadb345b64$var$setCookie("languageCookie", "french");
            $0da753eadb345b64$var$setFrontEnd();
        });
    } else if (lang == "portuguese") {
        var pt = (parcelRequire("cJqUG"));
        pt.then(function(pt) {
            document.lang = pt;
            $0da753eadb345b64$var$setCookie("languageCookie", "portuguese");
            $0da753eadb345b64$var$setFrontEnd();
        });
    } else if (lang == "hebrew") {
        var he = (parcelRequire("bp49u"));
        he.then(function(he) {
            document.lang = he;
            $0da753eadb345b64$var$setCookie("languageCookie", "hebrew");
            $0da753eadb345b64$var$setFrontEnd();
            document.body.classList.add("rightBodyAlignText");
        });
    } else if (lang == "german") {
        var de = (parcelRequire("47BTp"));
        de.then(function(de) {
            document.lang = de;
            $0da753eadb345b64$var$setCookie("languageCookie", "german");
            $0da753eadb345b64$var$setFrontEnd();
        });
    } else if (lang == "chinese") {
        var zh = (parcelRequire("5Bb8J"));
        zh.then(function(zh) {
            document.lang = zh;
            $0da753eadb345b64$var$setCookie("languageCookie", "chinese");
            $0da753eadb345b64$var$setFrontEnd();
        });
    } else if (lang == "arabic") {
        var ar = (parcelRequire("9Mb7m"));
        ar.then(function(ar) {
            document.lang = ar;
            $0da753eadb345b64$var$setCookie("languageCookie", "arabic");
            $0da753eadb345b64$var$setFrontEnd();
            document.body.classList.add("rightBodyAlignText");
        });
    } else if (lang == "bulgarian") {
        var bg = (parcelRequire("9lwob"));
        bg.then(function(bg) {
            document.lang = bg;
            $0da753eadb345b64$var$setCookie("languageCookie", "bulgarian");
            $0da753eadb345b64$var$setFrontEnd();
        });
    } else if (lang == "czech") {
        var cs = (parcelRequire("dOUch"));
        cs.then(function(cs) {
            document.lang = cs;
            $0da753eadb345b64$var$setCookie("languageCookie", "czech");
            $0da753eadb345b64$var$setFrontEnd();
        });
    } else if (lang == "farsi") {
        var fa = (parcelRequire("8fSon"));
        fa.then(function(fa) {
            document.lang = fa;
            $0da753eadb345b64$var$setCookie("languageCookie", "farsi");
            $0da753eadb345b64$var$setFrontEnd();
            document.body.classList.add("rightBodyAlignText");
        });
    } else if (lang == "hungarian") {
        var hu = (parcelRequire("27aFe"));
        hu.then(function(hu) {
            document.lang = hu;
            $0da753eadb345b64$var$setCookie("languageCookie", "hungarian");
            $0da753eadb345b64$var$setFrontEnd();
        });
    } else if (lang == "italian") {
        var it = (parcelRequire("3TzSS"));
        it.then(function(it) {
            document.lang = it;
            $0da753eadb345b64$var$setCookie("languageCookie", "italian");
            $0da753eadb345b64$var$setFrontEnd();
        });
    } else if (lang == "japanese") {
        var ja = (parcelRequire("jhCZ7"));
        ja.then(function(ja) {
            document.lang = ja;
            $0da753eadb345b64$var$setCookie("languageCookie", "japanese");
            $0da753eadb345b64$var$setFrontEnd();
        });
    } else if (lang == "korean") {
        var ko = (parcelRequire("5PMwu"));
        ko.then(function(ko) {
            document.lang = ko;
            $0da753eadb345b64$var$setCookie("languageCookie", "korean");
            $0da753eadb345b64$var$setFrontEnd();
        });
    } else if (lang == "latvian") {
        var lv = (parcelRequire("5MF98"));
        lv.then(function(lv) {
            document.lang = lv;
            $0da753eadb345b64$var$setCookie("languageCookie", "latvian");
            $0da753eadb345b64$var$setFrontEnd();
        });
    } else if (lang == "dutch") {
        var nl = (parcelRequire("1Uyaf"));
        nl.then(function(nl) {
            document.lang = nl;
            $0da753eadb345b64$var$setCookie("languageCookie", "dutch");
            $0da753eadb345b64$var$setFrontEnd();
        });
    } else if (lang == "norwegian") {
        var no = (parcelRequire("7jouE"));
        no.then(function(no) {
            document.lang = no;
            $0da753eadb345b64$var$setCookie("languageCookie", "norwegian");
            $0da753eadb345b64$var$setFrontEnd();
        });
    } else if (lang == "indonesian") {
        var no1 = (parcelRequire("6PjO2"));
        no1.then(function(no) {
            document.lang = no;
            $0da753eadb345b64$var$setCookie("languageCookie", "indonesian");
            $0da753eadb345b64$var$setFrontEnd();
        });
    } else if (lang == "polish") {
        var pl = (parcelRequire("aHNV2"));
        pl.then(function(pl) {
            document.lang = pl;
            $0da753eadb345b64$var$setCookie("languageCookie", "polish");
            $0da753eadb345b64$var$setFrontEnd();
        });
    } else if (lang == "romanian") {
        var ro = (parcelRequire("iRnqe"));
        ro.then(function(ro) {
            document.lang = ro;
            $0da753eadb345b64$var$setCookie("languageCookie", "romanian");
            $0da753eadb345b64$var$setFrontEnd();
        });
    } else if (lang == "russian") {
        var ru = (parcelRequire("4Hxzu"));
        ru.then(function(ru) {
            document.lang = ru;
            $0da753eadb345b64$var$setCookie("languageCookie", "russian");
            $0da753eadb345b64$var$setFrontEnd();
        });
    } else if (lang == "swedish") {
        var sv = (parcelRequire("dMNiO"));
        sv.then(function(sv) {
            document.lang = sv;
            $0da753eadb345b64$var$setCookie("languageCookie", "swedish");
            $0da753eadb345b64$var$setFrontEnd();
        });
    } else if (lang == "swahili") {
        var sw = (parcelRequire("cIUuE"));
        sw.then(function(sw) {
            document.lang = sw;
            $0da753eadb345b64$var$setCookie("languageCookie", "swahili");
            $0da753eadb345b64$var$setFrontEnd();
        });
    } else if (lang == "tagalog") {
        var tl = (parcelRequire("9ynBl"));
        tl.then(function(tl) {
            document.lang = tl;
            $0da753eadb345b64$var$setCookie("languageCookie", "tagalog");
            $0da753eadb345b64$var$setFrontEnd();
        });
    } else if (lang == "tajik") {
        var tg = (parcelRequire("cbpEo"));
        tg.then(function(tg) {
            document.lang = tg;
            $0da753eadb345b64$var$setCookie("languageCookie", "tajik");
            $0da753eadb345b64$var$setFrontEnd();
        });
    } else if (lang == "turkish") {
        var tr = (parcelRequire("8PAlw"));
        tr.then(function(tr) {
            document.lang = tr;
            $0da753eadb345b64$var$setCookie("languageCookie", "turkish");
            $0da753eadb345b64$var$setFrontEnd();
        });
    } else if (lang == "vietnamese") {
        var vi = (parcelRequire("hyL4o"));
        vi.then(function(vi) {
            document.lang = vi;
            $0da753eadb345b64$var$setCookie("languageCookie", "vietnamese");
            $0da753eadb345b64$var$setFrontEnd();
        });
    } else if (lang == "bengali") {
        var bn = (parcelRequire("kINHl"));
        bn.then(function(bn) {
            document.lang = bn;
            $0da753eadb345b64$var$setCookie("languageCookie", "bengali");
            $0da753eadb345b64$var$setFrontEnd();
        });
    } else if (lang == "hindi") {
        var hi = (parcelRequire("5J2FV"));
        hi.then(function(hi) {
            document.lang = hi;
            $0da753eadb345b64$var$setCookie("languageCookie", "hindi");
            $0da753eadb345b64$var$setFrontEnd();
        });
    } else if (lang == "traditional-chinese") {
        var zh1 = (parcelRequire("lYAUT"));
        zh1.then(function(zh) {
            document.lang = zh;
            $0da753eadb345b64$var$setCookie("languageCookie", "traditional-chinese");
            $0da753eadb345b64$var$setFrontEnd();
        });
    } else {
        var en1 = (parcelRequire("7ErNH"));
        en1.then(function(en) {
            document.lang = en;
            $0da753eadb345b64$var$setFrontEnd();
            $0da753eadb345b64$var$setCookie("languageCookie", "english");
        });
    }
}
// function setLang() {
// 	var selectBox = document.getElementById('lang');
// 	var selectedValue = selectBox.options[selectBox.selectedIndex].value;
// 	if (selectedValue == 'english') {
// 		loadLang('english');
// 	} else if (selectedValue == 'spanish') {
// 		loadLang('spanish');
// 	} else if (selectedValue == 'thai') {
// 		loadLang('thai');
// 	} else if (selectedValue == 'french') {
// 		loadLang('french');
// 	} else if (selectedValue == 'portuguese') {
// 		loadLang('portuguese');
// 	} else if (selectedValue == 'hebrew') {
// 		loadLang('hebrew');
// 	}
// }
// document.setLang = setLang;
/*
General Use functions
*/ function $0da753eadb345b64$var$checkMobile() {
    if (navigator.userAgent.includes("gonative")) return true;
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) return true;
    var mobile = new RegExp("m=true").test(window.location.href);
    if (mobile) return true;
    return false;
}
function $0da753eadb345b64$var$isAndroid() {
    return /Android/i.test(navigator.userAgent);
}
function $0da753eadb345b64$var$evaluateRedirectUri(responseRedirectUri) {
    return $0da753eadb345b64$var$checkMobile() === true ? $0da753eadb345b64$var$createMobileRedirectUri(responseRedirectUri) : responseRedirectUri;
}
function $0da753eadb345b64$var$createMobileRedirectUri(responseRedirectUri) {
    var url = new URL(responseRedirectUri);
    var baseUrl = url.origin;
    var mobileDashboardUrl = baseUrl + $0da753eadb345b64$var$MOBILE_REDIRECT_ROUTE;
    return mobileDashboardUrl;
}
function $0da753eadb345b64$var$navigateToApp(redirectUrl) {
    if ($0da753eadb345b64$var$isAndroid()) window.location.replace(redirectUrl);
    else window.location.href = redirectUrl;
}
function $0da753eadb345b64$var$setLoginLocalStorage(username, password) {
    if (username) localStorage.setItem($0da753eadb345b64$var$userField, btoa(username));
    if (password) localStorage.setItem($0da753eadb345b64$var$passField, btoa(password));
    return true;
}
function $0da753eadb345b64$var$getLoginLocalStorage(userField, passField) {
    if ($0da753eadb345b64$var$getCookie("email") != null && $0da753eadb345b64$var$getCookie("password") != null) $0da753eadb345b64$var$setLoginLocalStorage($0da753eadb345b64$var$getCookie("email"), $0da753eadb345b64$var$getCookie("password"));
    // console.log(userField);
    var user = localStorage.getItem(userField);
    var pass = localStorage.getItem(passField);
    if (user == null || pass == null) return {
        user: user,
        pass: pass
    };
    else return {
        user: atob(user),
        pass: atob(pass)
    };
}
function $0da753eadb345b64$var$clearLoginLocalStorage(userField, passField) {
    localStorage.removeItem(userField);
    localStorage.removeItem(passField);
    return true;
}
//Hide signup stuff from IOS because Apple is a pain.
if (navigator.userAgent.includes("iPhone")) document.getElementById("signUpDiv").style.display = "none";
var $0da753eadb345b64$var$togglePassword = document.querySelector("#togglePassword");
var $0da753eadb345b64$var$password = document.querySelector("#password");
$0da753eadb345b64$var$togglePassword.addEventListener("click", function(e) {
    // toggle the type attribute
    var type = $0da753eadb345b64$var$password.getAttribute("type") === "password" ? "text" : "password";
    $0da753eadb345b64$var$password.setAttribute("type", type);
    // toggle the eye slash icon
    this.classList.toggle("fa-eye-slash");
    this.classList.toggle("fa-eye");
}); // ESignatureVerification needs to let the parent know about sso logins
 // if (isESignatureVerification) {
 //    const params = new Proxy(new URLSearchParams(window.location.search), {
 //       get: (searchParams, prop) => searchParams.get(prop),
 //    });
 //    if (params.error) {
 //       window.parent.postMessage(
 //          {
 //             success: false,
 //             user: 0
 //          },
 //          routes.appUrl
 //       );
 //       return;
 //    }
 //    if (params.sso === "true") {
 //       const eSignatureVerificationToken = params.eSignatureVerificationToken;
 //       const eSignatureVerificationTokenCookie = getCookie("eSignatureVerificationToken");
 //       if (eSignatureVerificationToken === eSignatureVerificationTokenCookie) {
 //          delete_cookie("eSignatureVerificationToken", "/", "window.location.hostname");
 //          window.parent.postMessage(
 //             {
 //                success: true,
 //                user: params.userID
 //             },
 //             routes.appUrl
 //          );
 //       }
 //    }
 // }

})();
//# sourceMappingURL=views.12ca352a.js.map
